export const AqiMinimalPreview = () => (
	<svg viewBox="0 0 236 158" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect
			x={ 0.75 }
			y={ 0.75 }
			width={ 234.5 }
			height={ 156.5 }
			rx={ 3.25 }
			fill="white"
		/>
		<rect
			x={ 0.75 }
			y={ 0.75 }
			width={ 234.5 }
			height={ 156.5 }
			rx={ 3.25 }
			stroke="#9EA9B2"
			strokeWidth={ 1.5 }
		/>
		<path
			d="M83.9993 22.58C83.9993 20.421 83.9993 19.3415 84.67 18.6707C85.3407 18 86.4202 18 88.5793 18H147.956C150.115 18 151.194 18 151.865 18.6707C152.536 19.3415 152.536 20.421 152.536 22.58V134.644C152.536 136.803 152.536 137.882 151.865 138.553C151.194 139.224 150.115 139.224 147.956 139.224H88.5793C86.4202 139.224 85.3407 139.224 84.67 138.553C83.9993 137.882 83.9993 136.803 83.9993 134.644V22.58Z"
			fill="white"
		/>
		<path
			d="M147.955 138.224L147.956 139.224H88.5793L88.5793 138.224H147.955ZM151.535 134.644V22.5801C151.535 21.4723 151.534 20.7417 151.461 20.2002C151.392 19.6877 151.276 19.4965 151.157 19.3779C151.039 19.2594 150.848 19.1441 150.335 19.0752C149.794 19.0024 149.063 19 147.955 19H88.5793C87.4716 19 86.7409 19.0024 86.1995 19.0752C85.687 19.1441 85.4958 19.2594 85.3772 19.3779C85.2586 19.4965 85.1434 19.6877 85.0745 20.2002C85.0199 20.6064 85.0052 21.1191 85.0012 21.8174L84.9993 22.5801V134.644C84.9993 135.751 85.0017 136.482 85.0745 137.023C85.1434 137.536 85.2586 137.727 85.3772 137.846C85.4958 137.964 85.687 138.079 86.1995 138.148C86.7409 138.221 87.4716 138.224 88.5793 138.224L88.5793 139.224L87.8186 139.223C86.2754 139.214 85.3896 139.15 84.801 138.671L84.67 138.553C83.9993 137.882 83.9993 136.803 83.9993 134.644V22.58C83.9993 20.5561 83.9995 19.4809 84.552 18.8018L84.67 18.6707C85.2568 18.0839 86.1566 18.0102 87.8186 18.001L88.5793 18H147.956C150.115 18 151.194 18 151.865 18.6707C152.536 19.3415 152.536 20.421 152.536 22.58V134.644C152.536 136.803 152.536 137.882 151.865 138.553C151.194 139.224 150.115 139.224 147.956 139.224L147.955 138.224C149.063 138.224 149.794 138.221 150.335 138.148C150.848 138.08 151.039 137.964 151.157 137.846C151.276 137.727 151.392 137.536 151.461 137.023C151.534 136.482 151.535 135.751 151.535 134.644Z"
			fill="#58707F"
		/>
		<path
			d="M101.132 23.2476C101.132 23.1482 101.132 23.0985 101.135 23.0565C101.177 22.413 101.69 21.9004 102.333 21.8582C102.375 21.8555 102.425 21.8555 102.524 21.8555H132.295C132.394 21.8555 132.444 21.8555 132.486 21.8582C133.13 21.9004 133.642 22.413 133.684 23.0565C133.687 23.0985 133.687 23.1482 133.687 23.2476C133.687 23.3471 133.687 23.3968 133.684 23.4387C133.642 24.0823 133.13 24.5948 132.486 24.637C132.444 24.6398 132.394 24.6398 132.295 24.6398H102.524C102.425 24.6398 102.375 24.6398 102.333 24.637C101.69 24.5948 101.177 24.0823 101.135 23.4387C101.132 23.3968 101.132 23.3471 101.132 23.2476Z"
			fill="#58707F"
		/>
		<path
			d="M104.345 26.8886C104.345 26.4746 104.681 26.139 105.095 26.139H118.374C118.788 26.139 119.123 26.4746 119.123 26.8886C119.123 27.3026 118.788 27.6382 118.374 27.6382H105.095C104.681 27.6382 104.345 27.3026 104.345 26.8886Z"
			fill="#58707F"
		/>
		<path
			d="M119.98 26.8886C119.98 26.4746 120.315 26.139 120.729 26.139H129.725C130.139 26.139 130.474 26.4746 130.474 26.8886C130.474 27.3026 130.139 27.6382 129.725 27.6382H120.729C120.315 27.6382 119.98 27.3026 119.98 26.8886Z"
			fill="#58707F"
		/>
		<rect
			x={ 88.7105 }
			y={ 52.6966 }
			width={ 59.1126 }
			height={ 11.3513 }
			rx={ 0.642529 }
			stroke="#58707F"
			strokeWidth={ 0.428353 }
		/>
		<path
			d="M91.0664 55.5882C91.0664 55.2925 91.3061 55.0527 91.6018 55.0527H144.932C145.227 55.0527 145.467 55.2925 145.467 55.5882C145.467 55.8839 145.227 56.1236 144.932 56.1236H91.6018C91.3061 56.1236 91.0664 55.8839 91.0664 55.5882Z"
			fill="#58707F"
		/>
		<path
			d="M91.0664 58.3724C91.0664 58.0767 91.3061 57.8369 91.6018 57.8369H144.075C144.371 57.8369 144.61 58.0767 144.61 58.3724C144.61 58.6681 144.371 58.9078 144.075 58.9078H91.6018C91.3061 58.9078 91.0664 58.6681 91.0664 58.3724Z"
			fill="#58707F"
		/>
		<path
			d="M91.0664 61.1566C91.0664 60.8609 91.3061 60.6212 91.6018 60.6212H127.583C127.879 60.6212 128.119 60.8609 128.119 61.1566C128.119 61.4523 127.879 61.692 127.583 61.692H91.6018C91.3061 61.692 91.0664 61.4523 91.0664 61.1566Z"
			fill="#58707F"
		/>
		<rect
			x={ 88.7105 }
			y={ 68.7601 }
			width={ 28.0571 }
			height={ 8.1387 }
			rx={ 0.642529 }
			stroke="#58707F"
			strokeWidth={ 0.428353 }
		/>
		<path
			d="M91.709 72.8297C91.709 72.2382 92.1884 71.7588 92.7799 71.7588C93.3713 71.7588 93.8507 72.2382 93.8507 72.8297C93.8507 73.4211 93.3713 73.9006 92.7799 73.9006C92.1884 73.9006 91.709 73.4211 91.709 72.8297Z"
			fill="#58707F"
		/>
		<path
			d="M95.564 72.8297C95.564 72.2382 96.0434 71.7588 96.6349 71.7588H101.133C101.724 71.7588 102.203 72.2382 102.203 72.8297C102.203 73.4211 101.724 73.9006 101.133 73.9006H96.6349C96.0434 73.9006 95.564 73.4211 95.564 72.8297Z"
			fill="#58707F"
		/>
		<path
			d="M106.487 72.8297C106.487 72.2382 106.966 71.7588 107.558 71.7588H112.698C113.29 71.7588 113.769 72.2382 113.769 72.8297C113.769 73.4211 113.29 73.9006 112.698 73.9006H107.558C106.966 73.9006 106.487 73.4211 106.487 72.8297Z"
			fill="#58707F"
		/>
		<rect
			x={ 119.766 }
			y={ 68.7601 }
			width={ 28.0571 }
			height={ 8.1387 }
			rx={ 0.642529 }
			stroke="#58707F"
			strokeWidth={ 0.428353 }
		/>
		<path
			d="M122.764 72.8297C122.764 72.2382 123.244 71.7588 123.835 71.7588C124.427 71.7588 124.906 72.2382 124.906 72.8297C124.906 73.4211 124.427 73.9006 123.835 73.9006C123.244 73.9006 122.764 73.4211 122.764 72.8297Z"
			fill="#58707F"
		/>
		<path
			d="M126.62 72.8298C126.62 72.2383 127.099 71.7589 127.691 71.7589H132.188C132.78 71.7589 133.259 72.2383 133.259 72.8298C133.259 73.4212 132.78 73.9006 132.188 73.9006H127.691C127.099 73.9006 126.62 73.4212 126.62 72.8298Z"
			fill="#58707F"
		/>
		<path
			d="M137.543 72.8298C137.543 72.2383 138.022 71.7589 138.614 71.7589H143.754C144.345 71.7589 144.825 72.2383 144.825 72.8298C144.825 73.4212 144.345 73.9006 143.754 73.9006H138.614C138.022 73.9006 137.543 73.4212 137.543 72.8298Z"
			fill="#58707F"
		/>
		<rect
			x={ 88.7105 }
			y={ 79.8968 }
			width={ 28.0571 }
			height={ 8.1387 }
			rx={ 0.642529 }
			stroke="#58707F"
			strokeWidth={ 0.428353 }
		/>
		<path
			d="M91.7087 83.9664C91.7087 83.375 92.1882 82.8955 92.7796 82.8955C93.3711 82.8955 93.8505 83.375 93.8505 83.9664C93.8505 84.5578 93.3711 85.0373 92.7796 85.0373C92.1882 85.0373 91.7087 84.5578 91.7087 83.9664Z"
			fill="#58707F"
		/>
		<path
			d="M95.5639 83.9664C95.5639 83.375 96.0434 82.8955 96.6348 82.8955H101.132C101.724 82.8955 102.203 83.375 102.203 83.9664C102.203 84.5578 101.724 85.0373 101.132 85.0373H96.6348C96.0434 85.0373 95.5639 84.5578 95.5639 83.9664Z"
			fill="#58707F"
		/>
		<path
			d="M106.487 83.9664C106.487 83.375 106.966 82.8955 107.558 82.8955H112.698C113.289 82.8955 113.769 83.375 113.769 83.9664C113.769 84.5578 113.289 85.0373 112.698 85.0373H107.558C106.966 85.0373 106.487 84.5578 106.487 83.9664Z"
			fill="#58707F"
		/>
		<rect
			x={ 119.766 }
			y={ 79.8968 }
			width={ 28.0571 }
			height={ 8.1387 }
			rx={ 0.642529 }
			stroke="#58707F"
			strokeWidth={ 0.428353 }
		/>
		<path
			d="M122.765 83.9664C122.765 83.375 123.244 82.8955 123.836 82.8955C124.427 82.8955 124.906 83.375 124.906 83.9664C124.906 84.5578 124.427 85.0373 123.836 85.0373C123.244 85.0373 122.765 84.5578 122.765 83.9664Z"
			fill="#58707F"
		/>
		<path
			d="M126.62 83.9664C126.62 83.375 127.099 82.8955 127.691 82.8955H132.188C132.78 82.8955 133.259 83.375 133.259 83.9664C133.259 84.5578 132.78 85.0373 132.188 85.0373H127.691C127.099 85.0373 126.62 84.5578 126.62 83.9664Z"
			fill="#58707F"
		/>
		<path
			d="M137.543 83.9666C137.543 83.3752 138.022 82.8957 138.614 82.8957H143.754C144.345 82.8957 144.825 83.3752 144.825 83.9666C144.825 84.5581 144.345 85.0375 143.754 85.0375H138.614C138.022 85.0375 137.543 84.5581 137.543 83.9666Z"
			fill="#58707F"
		/>
		<rect
			x={ 88.7105 }
			y={ 91.0345 }
			width={ 28.0571 }
			height={ 8.1387 }
			rx={ 0.642529 }
			stroke="#58707F"
			strokeWidth={ 0.428353 }
		/>
		<path
			d="M91.709 95.1041C91.709 94.5127 92.1884 94.0332 92.7799 94.0332C93.3713 94.0332 93.8507 94.5127 93.8507 95.1041C93.8507 95.6955 93.3713 96.175 92.7799 96.175C92.1884 96.175 91.709 95.6955 91.709 95.1041Z"
			fill="#58707F"
		/>
		<path
			d="M95.5642 95.1041C95.5642 94.5127 96.0436 94.0332 96.635 94.0332H101.133C101.724 94.0332 102.204 94.5127 102.204 95.1041C102.204 95.6955 101.724 96.175 101.133 96.175H96.635C96.0436 96.175 95.5642 95.6955 95.5642 95.1041Z"
			fill="#58707F"
		/>
		<path
			d="M106.487 95.1041C106.487 94.5127 106.967 94.0332 107.558 94.0332H112.698C113.29 94.0332 113.769 94.5127 113.769 95.1041C113.769 95.6955 113.29 96.175 112.698 96.175H107.558C106.967 96.175 106.487 95.6955 106.487 95.1041Z"
			fill="#58707F"
		/>
		<rect
			x={ 119.766 }
			y={ 91.0345 }
			width={ 28.0571 }
			height={ 8.1387 }
			rx={ 0.642529 }
			stroke="#58707F"
			strokeWidth={ 0.428353 }
		/>
		<path
			d="M122.765 95.1041C122.765 94.5127 123.244 94.0332 123.836 94.0332C124.427 94.0332 124.906 94.5127 124.906 95.1041C124.906 95.6955 124.427 96.175 123.836 96.175C123.244 96.175 122.765 95.6955 122.765 95.1041Z"
			fill="#58707F"
		/>
		<path
			d="M126.62 95.1041C126.62 94.5127 127.099 94.0332 127.691 94.0332H132.188C132.78 94.0332 133.259 94.5127 133.259 95.1041C133.259 95.6955 132.78 96.175 132.188 96.175H127.691C127.099 96.175 126.62 95.6955 126.62 95.1041Z"
			fill="#58707F"
		/>
		<path
			d="M137.543 95.1041C137.543 94.5127 138.022 94.0332 138.614 94.0332H143.754C144.345 94.0332 144.825 94.5127 144.825 95.1041C144.825 95.6955 144.345 96.175 143.754 96.175H138.614C138.022 96.175 137.543 95.6955 137.543 95.1041Z"
			fill="#58707F"
		/>
		<g filter="url(#filter0_d_21307_21654)">
			<path
				d="M115.706 46.7643C115.706 45.1053 115.379 43.4621 114.744 41.9294C114.11 40.3967 113.179 39.0038 112.006 37.8308C110.833 36.6577 109.44 35.7273 107.907 35.0925C106.375 34.4577 104.732 34.1306 103.073 34.1306C101.414 34.1306 99.7713 34.4576 98.2385 35.0925C96.7058 35.7273 95.313 36.6577 94.1399 37.8308C92.9668 39.0038 92.0365 40.3967 91.4016 41.9294C90.7667 43.4621 90.4397 45.1053 90.4397 46.7643C90.4394 47.3008 90.0046 47.736 89.468 47.736C88.9315 47.736 88.4966 47.3008 88.4963 46.7643C88.4963 44.8501 88.8732 42.9538 89.6057 41.1852C90.3383 39.4168 91.4124 37.8102 92.7659 36.4567C94.1194 35.1032 95.7259 34.0291 97.4944 33.2966C99.2629 32.564 101.159 32.1872 103.073 32.1872C104.988 32.1873 106.883 32.5641 108.652 33.2966C110.42 34.0291 112.027 35.1032 113.38 36.4567C114.734 37.8102 115.808 39.4168 116.54 41.1852C117.273 42.9538 117.65 44.8501 117.65 46.7643C117.649 47.3008 117.215 47.736 116.678 47.736C116.141 47.736 115.707 47.3008 115.706 46.7643Z"
				fill="#58707F"
			/>
			<path
				d="M108.35 47.3805V48.0393H105.434V47.4771L106.813 45.9983C106.952 45.8441 107.061 45.7085 107.141 45.5913C107.221 45.4723 107.279 45.3659 107.314 45.2722C107.351 45.1765 107.37 45.0857 107.37 44.9998C107.37 44.871 107.348 44.7607 107.305 44.669C107.262 44.5752 107.199 44.503 107.115 44.4523C107.033 44.4015 106.931 44.3761 106.81 44.3761C106.681 44.3761 106.57 44.4074 106.476 44.4698C106.385 44.5323 106.314 44.6192 106.266 44.7304C106.219 44.8417 106.195 44.9676 106.195 45.1082H105.349C105.349 44.8544 105.41 44.6221 105.531 44.4113C105.652 44.1985 105.822 44.0296 106.043 43.9047C106.264 43.7778 106.525 43.7144 106.828 43.7144C107.127 43.7144 107.378 43.7632 107.583 43.8608C107.79 43.9564 107.946 44.095 108.052 44.2766C108.159 44.4562 108.213 44.6709 108.213 44.9208C108.213 45.0613 108.19 45.199 108.146 45.3336C108.101 45.4664 108.036 45.5991 107.952 45.7319C107.87 45.8627 107.771 45.9954 107.654 46.1301C107.536 46.2648 107.407 46.4044 107.264 46.5488L106.523 47.3805H108.35Z"
				fill="#58707F"
			/>
			<path
				d="M104.977 46.4464V47.1081H101.906L101.865 46.5957L103.642 43.7759H104.313L103.586 44.9911L102.702 46.4464H104.977ZM104.494 43.7759V48.0393H103.651V43.7759H104.494Z"
				fill="#58707F"
			/>
			<path
				d="M100.603 43.7671V48.0393H99.7592V44.7392L98.746 45.0613V44.3966L100.512 43.7671H100.603Z"
				fill="#58707F"
			/>
			<path
				d="M100.49 39.6014C100.49 39.2919 100.74 39.041 101.05 39.041H105.309C105.618 39.041 105.869 39.2919 105.869 39.6014C105.869 39.9108 105.618 40.1617 105.309 40.1617H101.05C100.74 40.1617 100.49 39.9108 100.49 39.6014Z"
				fill="#58707F"
			/>
			<path
				d="M100.275 33.9006C100.275 34.7286 99.604 35.3998 98.776 35.3998C97.948 35.3998 97.2768 34.7286 97.2768 33.9006C97.2768 33.0726 97.948 32.4014 98.776 32.4014C99.604 32.4014 100.275 33.0726 100.275 33.9006Z"
				fill="#D6E4ED"
			/>
			<path
				d="M99.9535 33.9004C99.9534 33.2499 99.4263 32.7227 98.7758 32.7227C98.1254 32.7228 97.5982 33.25 97.5981 33.9004C97.5981 34.5509 98.1253 35.078 98.7758 35.0781C99.4264 35.0781 99.9535 34.551 99.9535 33.9004ZM100.596 33.9004C100.596 34.9058 99.7812 35.7207 98.7758 35.7207C97.7705 35.7206 96.9555 34.9058 96.9555 33.9004C96.9556 32.8951 97.7705 32.0802 98.7758 32.0801C99.7812 32.0801 100.596 32.8951 100.596 33.9004Z"
				fill="#58707F"
			/>
		</g>
		<path
			d="M130.047 36.7398C130.047 36.1484 130.526 35.6689 131.118 35.6689H146.967C147.558 35.6689 148.037 36.1484 148.037 36.7398C148.037 37.3313 147.558 37.8107 146.967 37.8107H131.118C130.526 37.8107 130.047 37.3313 130.047 36.7398Z"
			fill="#58707F"
		/>
		<foreignObject
			x={ 134.019 }
			y={ 38.4532 }
			width={ 15.5174 }
			height={ 7.4959 }
		>
			<div
				xmlns="http://www.w3.org/1999/xhtml"
				style={ {
					backdropFilter: 'blur(0.64px)',
					clipPath: 'url(#bgblur_0_21307_21654_clip_path)',
					height: '100%',
					width: '100%',
				} }
			/>
		</foreignObject>
		<g data-figma-bg-blur-radius={ 1.28506 }>
			<rect
				x={ 135.411 }
				y={ 39.8451 }
				width={ 12.7331 }
				height={ 4.71188 }
				rx={ 0.749617 }
				fill="#D6E4ED"
			/>
			<rect
				x={ 135.411 }
				y={ 39.8451 }
				width={ 12.7331 }
				height={ 4.71188 }
				rx={ 0.749617 }
				stroke="#58707F"
				strokeWidth={ 0.214176 }
			/>
			<path
				d="M144.161 41.9866V43.1775H143.833V41.7065H144.146L144.161 41.9866ZM144.611 41.697L144.608 42.0016C144.588 41.9979 144.566 41.9952 144.543 41.9934C144.52 41.9916 144.497 41.9907 144.475 41.9907C144.419 41.9907 144.369 41.9988 144.327 42.0152C144.284 42.0306 144.248 42.0532 144.219 42.0831C144.191 42.1121 144.169 42.1475 144.154 42.1892C144.138 42.2309 144.129 42.2775 144.127 42.3292L144.052 42.3346C144.052 42.2422 144.061 42.1565 144.079 42.0777C144.097 41.9988 144.124 41.9295 144.161 41.8697C144.198 41.8099 144.244 41.7632 144.299 41.7297C144.356 41.6961 144.42 41.6794 144.494 41.6794C144.514 41.6794 144.535 41.6812 144.558 41.6848C144.581 41.6884 144.599 41.6925 144.611 41.697Z"
				fill="#58707F"
			/>
			<path
				d="M142.189 42.4584V42.4271C142.189 42.321 142.204 42.2227 142.235 42.1321C142.266 42.0405 142.31 41.9612 142.368 41.8942C142.427 41.8262 142.499 41.7736 142.583 41.7365C142.668 41.6984 142.764 41.6794 142.871 41.6794C142.979 41.6794 143.075 41.6984 143.159 41.7365C143.245 41.7736 143.317 41.8262 143.376 41.8942C143.435 41.9612 143.479 42.0405 143.51 42.1321C143.541 42.2227 143.556 42.321 143.556 42.4271V42.4584C143.556 42.5644 143.541 42.6627 143.51 42.7534C143.479 42.844 143.435 42.9233 143.376 42.9913C143.317 43.0584 143.245 43.1109 143.161 43.149C143.077 43.1861 142.981 43.2047 142.874 43.2047C142.766 43.2047 142.67 43.1861 142.584 43.149C142.5 43.1109 142.428 43.0584 142.37 42.9913C142.311 42.9233 142.266 42.844 142.235 42.7534C142.204 42.6627 142.189 42.5644 142.189 42.4584ZM142.516 42.4271V42.4584C142.516 42.5245 142.523 42.5871 142.537 42.646C142.55 42.7049 142.572 42.7565 142.601 42.801C142.63 42.8454 142.667 42.8803 142.712 42.9056C142.757 42.931 142.811 42.9437 142.874 42.9437C142.935 42.9437 142.987 42.931 143.032 42.9056C143.077 42.8803 143.114 42.8454 143.143 42.801C143.172 42.7565 143.193 42.7049 143.207 42.646C143.222 42.5871 143.229 42.5245 143.229 42.4584V42.4271C143.229 42.3618 143.222 42.3002 143.207 42.2422C143.193 42.1833 143.172 42.1312 143.142 42.0858C143.113 42.0405 143.076 42.0052 143.03 41.9798C142.986 41.9535 142.933 41.9404 142.871 41.9404C142.81 41.9404 142.756 41.9535 142.711 41.9798C142.666 42.0052 142.63 42.0405 142.601 42.0858C142.572 42.1312 142.55 42.1833 142.537 42.2422C142.523 42.3002 142.516 42.3618 142.516 42.4271Z"
				fill="#58707F"
			/>
			<path
				d="M140.609 42.4584V42.4271C140.609 42.321 140.625 42.2227 140.655 42.1321C140.686 42.0405 140.731 41.9612 140.789 41.8942C140.848 41.8262 140.919 41.7736 141.004 41.7365C141.089 41.6984 141.185 41.6794 141.292 41.6794C141.4 41.6794 141.496 41.6984 141.58 41.7365C141.665 41.7736 141.737 41.8262 141.796 41.8942C141.855 41.9612 141.9 42.0405 141.931 42.1321C141.962 42.2227 141.977 42.321 141.977 42.4271V42.4584C141.977 42.5644 141.962 42.6627 141.931 42.7534C141.9 42.844 141.855 42.9233 141.796 42.9913C141.737 43.0584 141.666 43.1109 141.581 43.149C141.497 43.1861 141.401 43.2047 141.294 43.2047C141.187 43.2047 141.09 43.1861 141.005 43.149C140.921 43.1109 140.849 43.0584 140.79 42.9913C140.731 42.9233 140.686 42.844 140.655 42.7534C140.625 42.6627 140.609 42.5644 140.609 42.4584ZM140.937 42.4271V42.4584C140.937 42.5245 140.944 42.5871 140.957 42.646C140.971 42.7049 140.992 42.7565 141.021 42.801C141.05 42.8454 141.087 42.8803 141.133 42.9056C141.178 42.931 141.232 42.9437 141.294 42.9437C141.355 42.9437 141.408 42.931 141.452 42.9056C141.497 42.8803 141.535 42.8454 141.564 42.801C141.593 42.7565 141.614 42.7049 141.628 42.646C141.642 42.5871 141.649 42.5245 141.649 42.4584V42.4271C141.649 42.3618 141.642 42.3002 141.628 42.2422C141.614 42.1833 141.592 42.1312 141.562 42.0858C141.533 42.0405 141.496 42.0052 141.451 41.9798C141.406 41.9535 141.353 41.9404 141.292 41.9404C141.23 41.9404 141.177 41.9535 141.131 41.9798C141.087 42.0052 141.05 42.0405 141.021 42.0858C140.992 42.1312 140.971 42.1833 140.957 42.2422C140.944 42.3002 140.937 42.3618 140.937 42.4271Z"
				fill="#58707F"
			/>
			<path
				d="M139.697 42.4395H139.182V42.1689H139.697C139.787 42.1689 139.859 42.1544 139.915 42.1254C139.97 42.0964 140.01 42.0566 140.036 42.0058C140.062 41.9541 140.075 41.8952 140.075 41.8291C140.075 41.7665 140.062 41.7081 140.036 41.6537C140.01 41.5984 139.97 41.554 139.915 41.5204C139.859 41.4869 139.787 41.4701 139.697 41.4701H139.287V43.1777H138.945V41.1982H139.697C139.85 41.1982 139.98 41.2254 140.087 41.2798C140.195 41.3333 140.277 41.4076 140.333 41.5028C140.39 41.597 140.418 41.7049 140.418 41.8263C140.418 41.9541 140.39 42.0638 140.333 42.1553C140.277 42.2469 140.195 42.3171 140.087 42.3661C139.98 42.415 139.85 42.4395 139.697 42.4395Z"
				fill="#58707F"
			/>
		</g>
		<g filter="url(#filter2_d_21307_21654)">
			<path
				d="M88.4954 104.741C88.4954 104.149 88.9748 103.67 89.5662 103.67H107.771C108.363 103.67 108.842 104.149 108.842 104.741C108.842 105.332 108.363 105.812 107.771 105.812H89.5662C88.9748 105.812 88.4954 105.332 88.4954 104.741Z"
				fill="#58707F"
			/>
			<path
				d="M139.898 104.741C139.898 104.149 140.377 103.67 140.969 103.67H146.966C147.557 103.67 148.037 104.149 148.037 104.741C148.037 105.332 147.557 105.812 146.966 105.812H140.969C140.377 105.812 139.898 105.332 139.898 104.741Z"
				fill="#58707F"
			/>
			<path
				d="M130.045 104.741C130.045 104.149 130.525 103.67 131.116 103.67H137.113C137.705 103.67 138.184 104.149 138.184 104.741C138.184 105.332 137.705 105.812 137.113 105.812H131.116C130.525 105.812 130.045 105.332 130.045 104.741Z"
				fill="#58707F"
			/>
			<path
				d="M88.4961 110.953C88.4961 110.598 88.7838 110.31 89.1387 110.31H101.561C101.916 110.31 102.203 110.598 102.203 110.953C102.203 111.307 101.916 111.595 101.561 111.595H89.1387C88.7838 111.595 88.4961 111.307 88.4961 110.953Z"
				fill="#58707F"
			/>
			<path
				d="M88.4961 113.737C88.4961 113.382 88.7838 113.094 89.1387 113.094H98.7766C99.1315 113.094 99.4191 113.382 99.4191 113.737C99.4191 114.092 99.1315 114.379 98.7766 114.379H89.1387C88.7838 114.379 88.4961 114.092 88.4961 113.737Z"
				fill="#58707F"
			/>
			<path
				d="M134.33 112.238C134.33 111.883 134.617 111.595 134.972 111.595H147.394C147.749 111.595 148.037 111.883 148.037 112.238C148.037 112.592 147.749 112.88 147.394 112.88H134.972C134.617 112.88 134.33 112.592 134.33 112.238Z"
				fill="#58707F"
			/>
			<path
				d="M124.433 115.376C124.433 114.58 124.277 113.792 123.972 113.057C123.667 112.321 123.22 111.653 122.658 111.09C122.095 110.527 121.427 110.081 120.692 109.776C119.957 109.472 119.168 109.315 118.372 109.315C117.577 109.315 116.788 109.472 116.053 109.776C115.318 110.081 114.649 110.527 114.086 111.09C113.524 111.653 113.077 112.321 112.773 113.057C112.468 113.792 112.311 114.58 112.311 115.376C112.311 115.633 112.103 115.842 111.845 115.842C111.588 115.842 111.379 115.633 111.379 115.376C111.379 114.458 111.56 113.548 111.912 112.699C112.263 111.851 112.778 111.08 113.427 110.431C114.076 109.781 114.847 109.267 115.696 108.915C116.544 108.564 117.454 108.383 118.372 108.383C119.291 108.383 120.2 108.564 121.048 108.915C121.897 109.267 122.668 109.781 123.318 110.431C123.967 111.08 124.482 111.851 124.833 112.699C125.185 113.548 125.366 114.458 125.366 115.376C125.366 115.633 125.157 115.842 124.9 115.842C124.642 115.842 124.433 115.633 124.433 115.376Z"
				fill="#58707F"
			/>
			<path
				d="M120.766 113.779V114.095H119.367V113.826L120.029 113.116C120.095 113.042 120.148 112.977 120.186 112.921C120.224 112.864 120.252 112.813 120.269 112.768C120.287 112.722 120.296 112.678 120.296 112.637C120.296 112.575 120.285 112.522 120.265 112.478C120.244 112.433 120.214 112.399 120.173 112.374C120.134 112.35 120.085 112.338 120.027 112.338C119.965 112.338 119.912 112.353 119.867 112.383C119.823 112.413 119.789 112.455 119.766 112.508C119.743 112.561 119.732 112.622 119.732 112.689H119.326C119.326 112.567 119.355 112.456 119.413 112.355C119.471 112.253 119.553 112.172 119.659 112.112C119.765 112.051 119.89 112.02 120.036 112.02C120.179 112.02 120.3 112.044 120.398 112.091C120.497 112.137 120.572 112.203 120.623 112.29C120.674 112.376 120.7 112.479 120.7 112.599C120.7 112.667 120.689 112.733 120.668 112.797C120.646 112.861 120.615 112.925 120.575 112.988C120.536 113.051 120.488 113.115 120.432 113.179C120.376 113.244 120.313 113.311 120.245 113.38L119.89 113.779H120.766Z"
				fill="#58707F"
			/>
			<path
				d="M119.148 113.331V113.649H117.674L117.654 113.403L118.507 112.05H118.829L118.48 112.633L118.056 113.331H119.148ZM118.916 112.05V114.095H118.511V112.05H118.916Z"
				fill="#58707F"
			/>
			<path
				d="M117.049 112.046V114.095H116.644V112.512L116.158 112.667V112.348L117.005 112.046H117.049Z"
				fill="#58707F"
			/>
			<path
				d="M117.031 109.204C117.031 109.602 116.709 109.924 116.312 109.924C115.914 109.924 115.592 109.602 115.592 109.204C115.592 108.807 115.914 108.485 116.312 108.485C116.709 108.485 117.031 108.807 117.031 109.204Z"
				fill="#D6E4ED"
			/>
			<path
				d="M116.876 109.205C116.876 108.893 116.624 108.64 116.312 108.639C116 108.639 115.747 108.893 115.747 109.205C115.747 109.517 116 109.769 116.312 109.769C116.624 109.769 116.876 109.517 116.876 109.205ZM117.185 109.205C117.185 109.687 116.794 110.078 116.312 110.078C115.83 110.078 115.438 109.687 115.438 109.205C115.438 108.722 115.83 108.331 116.312 108.331C116.794 108.331 117.185 108.723 117.185 109.205Z"
				fill="#58707F"
			/>
			<path
				d="M88.496 120.475C88.496 120.12 88.7837 119.833 89.1386 119.833H101.561C101.916 119.833 102.203 120.12 102.203 120.475C102.203 120.83 101.916 121.118 101.561 121.118H89.1386C88.7837 121.118 88.496 120.83 88.496 120.475Z"
				fill="#58707F"
			/>
			<path
				d="M88.496 123.161C88.496 122.806 88.7837 122.518 89.1386 122.518H98.7765C99.1314 122.518 99.419 122.806 99.419 123.161C99.419 123.516 99.1314 123.803 98.7765 123.803H89.1386C88.7837 123.803 88.496 123.516 88.496 123.161Z"
				fill="#58707F"
			/>
			<path
				d="M134.33 121.761C134.33 121.406 134.617 121.118 134.972 121.118H147.394C147.749 121.118 148.037 121.406 148.037 121.761C148.037 122.115 147.749 122.403 147.394 122.403H134.972C134.617 122.403 134.33 122.115 134.33 121.761Z"
				fill="#58707F"
			/>
			<path
				d="M124.433 124.898C124.433 124.103 124.277 123.314 123.972 122.579C123.667 121.844 123.22 121.175 122.658 120.612C122.095 120.05 121.427 119.603 120.692 119.299C119.956 118.994 119.168 118.837 118.372 118.837C117.577 118.837 116.788 118.994 116.053 119.299C115.318 119.603 114.649 120.049 114.086 120.612C113.523 121.175 113.077 121.844 112.773 122.579C112.468 123.314 112.311 124.103 112.311 124.898C112.311 125.156 112.102 125.364 111.845 125.364C111.588 125.364 111.379 125.156 111.379 124.898C111.379 123.98 111.56 123.07 111.911 122.222C112.263 121.373 112.778 120.602 113.427 119.953C114.076 119.304 114.847 118.789 115.696 118.437C116.544 118.086 117.454 117.905 118.372 117.905C119.291 117.905 120.2 118.086 121.048 118.437C121.897 118.789 122.668 119.304 123.318 119.953C123.967 120.602 124.482 121.373 124.833 122.222C125.185 123.07 125.366 123.98 125.366 124.898C125.365 125.156 125.157 125.364 124.9 125.364C124.642 125.364 124.433 125.156 124.433 124.898Z"
				fill="#58707F"
			/>
			<path
				d="M120.766 123.302V123.618H119.367V123.349L120.029 122.639C120.095 122.565 120.147 122.5 120.186 122.444C120.224 122.387 120.252 122.336 120.269 122.291C120.287 122.245 120.295 122.201 120.295 122.16C120.295 122.098 120.285 122.045 120.265 122.001C120.244 121.956 120.213 121.922 120.173 121.897C120.134 121.873 120.085 121.861 120.027 121.861C119.965 121.861 119.912 121.876 119.867 121.906C119.823 121.936 119.789 121.978 119.766 122.031C119.743 122.084 119.732 122.145 119.732 122.212H119.326C119.326 122.09 119.355 121.979 119.413 121.878C119.471 121.776 119.553 121.695 119.659 121.635C119.765 121.574 119.89 121.543 120.036 121.543C120.179 121.543 120.3 121.567 120.398 121.614C120.497 121.66 120.572 121.726 120.623 121.813C120.674 121.899 120.7 122.002 120.7 122.122C120.7 122.19 120.689 122.256 120.668 122.32C120.646 122.384 120.615 122.448 120.575 122.511C120.536 122.574 120.488 122.638 120.432 122.702C120.375 122.767 120.313 122.834 120.245 122.903L119.889 123.302H120.766Z"
				fill="#58707F"
			/>
			<path
				d="M119.148 122.854V123.172H117.674L117.654 122.926L118.507 121.573H118.829L118.48 122.156L118.056 122.854H119.148ZM118.916 121.573V123.618H118.511V121.573H118.916Z"
				fill="#58707F"
			/>
			<path
				d="M117.049 121.569V123.618H116.644V122.035L116.158 122.19V121.871L117.005 121.569H117.049Z"
				fill="#58707F"
			/>
			<path
				d="M117.031 118.727C117.031 119.125 116.709 119.447 116.311 119.447C115.914 119.447 115.592 119.125 115.592 118.727C115.592 118.33 115.914 118.008 116.311 118.008C116.709 118.008 117.031 118.33 117.031 118.727Z"
				fill="#D6E4ED"
			/>
			<path
				d="M116.876 118.728C116.876 118.416 116.624 118.163 116.312 118.162C116 118.162 115.746 118.416 115.746 118.728C115.747 119.04 116 119.292 116.312 119.292C116.624 119.292 116.876 119.04 116.876 118.728ZM117.185 118.728C117.185 119.21 116.794 119.601 116.312 119.601C115.83 119.601 115.438 119.21 115.438 118.728C115.438 118.245 115.829 117.854 116.312 117.854C116.794 117.854 117.185 118.246 117.185 118.728Z"
				fill="#58707F"
			/>
			<path
				d="M88.4959 129.997C88.4959 129.642 88.7836 129.355 89.1384 129.355H101.561C101.916 129.355 102.203 129.642 102.203 129.997C102.203 130.352 101.916 130.64 101.561 130.64H89.1384C88.7836 130.64 88.4959 130.352 88.4959 129.997Z"
				fill="#58707F"
			/>
			<path
				d="M88.4959 132.798C88.4959 132.443 88.7836 132.155 89.1384 132.155H98.7764C99.1312 132.155 99.4189 132.443 99.4189 132.798C99.4189 133.153 99.1312 133.44 98.7764 133.44H89.1384C88.7836 133.44 88.4959 133.153 88.4959 132.798Z"
				fill="#58707F"
			/>
			<path
				d="M134.33 131.282C134.33 130.927 134.617 130.64 134.972 130.64H147.394C147.749 130.64 148.037 130.927 148.037 131.282C148.037 131.637 147.749 131.925 147.394 131.925H134.972C134.617 131.925 134.33 131.637 134.33 131.282Z"
				fill="#58707F"
			/>
			<path
				d="M124.37 134.421C124.37 133.625 124.204 132.837 123.879 132.102C123.554 131.366 123.077 130.698 122.477 130.135C121.877 129.572 121.164 129.126 120.38 128.821C119.596 128.517 118.755 128.359 117.906 128.359C117.057 128.359 116.217 128.517 115.432 128.821C114.648 129.126 113.935 129.572 113.335 130.135C112.734 130.698 112.259 131.366 111.934 132.102C111.609 132.837 111.441 133.625 111.441 134.421C111.441 134.678 111.219 134.887 110.944 134.887C110.67 134.887 110.447 134.678 110.447 134.421C110.447 133.503 110.64 132.593 111.015 131.744C111.39 130.896 111.939 130.125 112.632 129.476C113.324 128.826 114.146 128.311 115.051 127.96C115.956 127.609 116.927 127.428 117.906 127.428C118.886 127.428 119.855 127.609 120.76 127.96C121.665 128.311 122.488 128.826 123.181 129.476C123.873 130.125 124.423 130.896 124.798 131.744C125.172 132.593 125.365 133.503 125.365 134.421C125.365 134.678 125.143 134.887 124.868 134.887C124.594 134.887 124.371 134.678 124.37 134.421Z"
				fill="#58707F"
			/>
			<path
				d="M120.766 132.824V133.14H119.367V132.871L120.028 132.161C120.095 132.087 120.147 132.022 120.186 131.966C120.224 131.909 120.252 131.858 120.269 131.813C120.286 131.767 120.295 131.723 120.295 131.682C120.295 131.62 120.285 131.568 120.264 131.524C120.244 131.479 120.213 131.444 120.173 131.42C120.134 131.395 120.085 131.383 120.027 131.383C119.965 131.383 119.912 131.398 119.867 131.428C119.823 131.458 119.789 131.5 119.766 131.553C119.743 131.606 119.732 131.667 119.732 131.734H119.326C119.326 131.612 119.355 131.501 119.413 131.4C119.471 131.298 119.553 131.217 119.659 131.157C119.765 131.096 119.89 131.066 120.035 131.066C120.179 131.066 120.299 131.089 120.398 131.136C120.497 131.182 120.572 131.248 120.623 131.335C120.674 131.421 120.7 131.524 120.7 131.644C120.7 131.712 120.689 131.778 120.668 131.842C120.646 131.906 120.615 131.97 120.575 132.033C120.535 132.096 120.488 132.16 120.432 132.225C120.375 132.289 120.313 132.356 120.245 132.425L119.889 132.824H120.766Z"
				fill="#58707F"
			/>
			<path
				d="M119.148 132.376V132.694H117.674L117.654 132.448L118.507 131.095H118.829L118.48 131.678L118.056 132.376H119.148ZM118.916 131.095V133.14H118.511V131.095H118.916Z"
				fill="#58707F"
			/>
			<path
				d="M117.049 131.091V133.14H116.644V131.557L116.158 131.712V131.393L117.005 131.091H117.049Z"
				fill="#58707F"
			/>
			<path
				d="M117.031 128.249C117.031 128.647 116.709 128.969 116.311 128.969C115.914 128.969 115.592 128.647 115.592 128.249C115.592 127.852 115.914 127.53 116.311 127.53C116.709 127.53 117.031 127.852 117.031 128.249Z"
				fill="#D6E4ED"
			/>
			<path
				d="M116.876 128.25C116.876 127.938 116.624 127.685 116.312 127.684C116 127.684 115.746 127.938 115.746 128.25C115.746 128.562 116 128.814 116.312 128.814C116.623 128.814 116.876 128.562 116.876 128.25ZM117.185 128.25C117.185 128.732 116.794 129.123 116.312 129.123C115.829 129.123 115.438 128.732 115.438 128.25C115.438 127.768 115.829 127.376 116.312 127.376C116.794 127.376 117.185 127.768 117.185 128.25Z"
				fill="#58707F"
			/>
		</g>
		<defs>
			<filter
				id="filter0_d_21307_21654"
				x={ 88.2534 }
				y={ 31.8371 }
				width={ 30.1251 }
				height={ 16.9308 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.242946 } dy={ 0.242946 } />
				<feGaussianBlur stdDeviation={ 0.242946 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_21307_21654"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_21307_21654"
					result="shape"
				/>
			</filter>
			<clipPath
				id="bgblur_0_21307_21654_clip_path"
				transform="translate(-134.019 -38.4532)"
			>
				<rect
					x={ 135.411 }
					y={ 39.8451 }
					width={ 12.7331 }
					height={ 4.71188 }
					rx={ 0.749617 }
				/>
			</clipPath>
			<filter
				id="filter2_d_21307_21654"
				x={ 88.3788 }
				y={ 103.553 }
				width={ 60.008 }
				height={ 31.683 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.116557 } dy={ 0.116557 } />
				<feGaussianBlur stdDeviation={ 0.116557 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_21307_21654"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_21307_21654"
					result="shape"
				/>
			</filter>
		</defs>
	</svg>
);

export const AqiMinimalBlockIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
		<path
			fill="#F26C0D"
			d="M19.36 23.953H4.64a2.93 2.93 0 0 1-2.93-2.93V2.977A2.93 2.93 0 0 1 4.64.047h14.72a2.93 2.93 0 0 1 2.93 2.93v18.046a2.93 2.93 0 0 1-2.93 2.93ZM4.64 2.156c-.45 0-.82.37-.82.82v18.047c0 .45.37.82.82.82h14.72c.45 0 .82-.37.82-.82V2.977c0-.45-.37-.82-.82-.82H4.64Z"
		/>
		<path
			fill="#F26C0D"
			d="M11.495 6.413a.412.412 0 0 1-.41.412H6.73a.729.729 0 0 0 0 1.457h4.356c1.033 0 1.868-.84 1.868-1.869a1.864 1.864 0 0 0-1.868-1.863c-.453 0-.874.16-1.202.434l-.133.126-.05.056a.729.729 0 0 0 1.037 1.012l.055-.051.059-.05a.41.41 0 0 1 .234-.07c.23 0 .41.183.41.406Z"
		/>
		<path
			fill="#F26C0D"
			d="M16.543 8.659a.662.662 0 0 1-.66.662h-6.36a.729.729 0 0 0 0 1.457h6.36a2.12 2.12 0 0 0 0-4.237c-.589 0-1.123.241-1.506.628a.729.729 0 0 0 .981 1.075l.055-.05.099-.082a.66.66 0 0 1 1.031.546ZM7.73 10.01a.729.729 0 1 1-1.457 0 .729.729 0 0 1 1.458 0ZM17.117 19.433v-5.52h1.133v5.52h-1.133ZM13.331 19.568c-.523 0-.987-.119-1.394-.357a2.533 2.533 0 0 1-.942-1.013c-.222-.433-.333-.94-.333-1.521 0-.58.111-1.088.333-1.52.227-.434.54-.771.942-1.014.402-.243.866-.365 1.394-.365.533 0 1 .122 1.402.365.401.237.713.572.934 1.005.228.433.341.943.341 1.529 0 .58-.113 1.088-.34 1.52-.227.434-.542.771-.943 1.014-.401.238-.866.357-1.394.357Zm2.337.332-2.297-2.21.657-.704 2.313 2.257-.674.657Zm-2.337-1.417c.317 0 .589-.074.816-.222.227-.148.404-.356.53-.626.127-.274.19-.594.19-.958 0-.37-.063-.689-.19-.958a1.467 1.467 0 0 0-.53-.634 1.477 1.477 0 0 0-.824-.222c-.306 0-.575.074-.808.222a1.405 1.405 0 0 0-.538.618c-.122.27-.182.594-.182.974 0 .375.06.697.182.966.127.27.306.478.538.626.233.143.505.214.816.214ZM5.25 19.433l2.257-5.52h.84l2.257 5.52H9.368l-1.433-3.84-1.45 3.84H5.25Zm1.552-1.006.357-1.013h1.544l.364 1.013H6.802Z"
		/>
	</svg>
);

export const AqiMinimalOneIcon = ( { isPopup = false } ) => (
	<svg
		width={ isPopup ? 102 : 76 }
		height={ isPopup ? 172 : 128 }
		viewBox="0 0 76 128"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x={ 0.558824 }
			y={ 0.558824 }
			width={ 74.8824 }
			height={ 126.882 }
			rx={ 1.67647 }
			fill="white"
		/>
		<rect
			x={ 0.558824 }
			y={ 0.558824 }
			width={ 74.8824 }
			height={ 126.882 }
			rx={ 1.67647 }
			stroke="#8796A1"
			strokeWidth={ 1.11765 }
		/>
		<path
			d="M4.47559 6.50284C4.47559 5.50752 4.47559 5.00986 4.78479 4.70066C5.094 4.39145 5.59166 4.39145 6.58698 4.39145H69.9289C70.9242 4.39145 71.4219 4.39145 71.7311 4.70066C72.0403 5.00986 72.0403 5.50752 72.0403 6.50285V121.785C72.0403 122.78 72.0403 123.278 71.7311 123.587C71.4219 123.896 70.9242 123.896 69.9289 123.896H6.58698C5.59166 123.896 5.094 123.896 4.78479 123.587C4.47559 123.278 4.47559 122.78 4.47559 121.785V6.50284Z"
			fill="white"
		/>
		<path
			d="M69.9285 123.166V123.897H6.58718V123.166H69.9285ZM71.3096 121.785V6.50305C71.3096 5.98499 71.3081 5.66962 71.2776 5.44215C71.2634 5.33698 71.246 5.28017 71.2339 5.25079C71.2242 5.22725 71.2181 5.22111 71.2142 5.21731C71.2104 5.21351 71.2042 5.20729 71.1808 5.19767C71.1514 5.18559 71.095 5.16812 70.9901 5.15401C70.7626 5.12343 70.4468 5.12199 69.9285 5.12199H6.58718C6.06914 5.12199 5.75375 5.12347 5.52629 5.15401C5.42116 5.16814 5.36432 5.18558 5.33492 5.19767C5.31137 5.20736 5.30525 5.21351 5.30145 5.21731C5.29765 5.22111 5.2915 5.22723 5.28181 5.25079C5.26972 5.28018 5.25228 5.33702 5.23815 5.44215C5.20761 5.66961 5.20613 5.98501 5.20613 6.50305V121.785C5.20613 122.303 5.20758 122.619 5.23815 122.846C5.25229 122.951 5.26971 123.008 5.28181 123.037C5.29145 123.061 5.29766 123.067 5.30145 123.071C5.30526 123.075 5.31161 123.081 5.33492 123.091C5.36434 123.103 5.42126 123.12 5.52629 123.134C5.75375 123.165 6.06917 123.166 6.58718 123.166V123.897L5.92867 123.892C5.40256 123.878 5.07477 123.829 4.84522 123.642L4.78483 123.587C4.5529 123.356 4.49517 123.017 4.48068 122.443L4.47559 121.785V6.50305C4.47559 5.57009 4.47561 5.07419 4.73026 4.76109L4.78483 4.70069C5.01669 4.46883 5.3545 4.41105 5.92867 4.39654L6.58718 4.39145H69.9285C70.9238 4.39145 71.4217 4.39157 71.7309 4.70069C72.0401 5.0099 72.0401 5.50772 72.0401 6.50305V121.785L72.0358 122.443C72.0213 123.017 71.9628 123.356 71.7309 123.587L71.6705 123.642C71.4409 123.829 71.1132 123.878 70.587 123.892L69.9285 123.897V123.166C70.4468 123.166 70.7626 123.165 70.9901 123.134C71.0949 123.12 71.1513 123.103 71.1808 123.091C71.2039 123.081 71.2104 123.075 71.2142 123.071C71.218 123.067 71.2243 123.061 71.2339 123.037C71.246 123.008 71.2634 122.951 71.2776 122.846C71.3081 122.619 71.3096 122.303 71.3096 121.785Z"
			fill="#58707F"
		/>
		<path
			d="M21.3667 9.64292C21.3667 9.54489 21.3667 9.49587 21.3694 9.45449C21.411 8.82011 21.9163 8.3148 22.5507 8.27322C22.5921 8.27051 22.6411 8.27051 22.7391 8.27051H52.0875C52.1855 8.27051 52.2346 8.27051 52.2759 8.27322C52.9103 8.3148 53.4156 8.82011 53.4572 9.45449C53.4599 9.49587 53.4599 9.54489 53.4599 9.64292C53.4599 9.74094 53.4599 9.78996 53.4572 9.83134C53.4156 10.4657 52.9103 10.971 52.2759 11.0126C52.2346 11.0153 52.1855 11.0153 52.0875 11.0153H22.7391C22.6411 11.0153 22.5921 11.0153 22.5507 11.0126C21.9163 10.971 21.411 10.4657 21.3694 9.83134C21.3667 9.78996 21.3667 9.74094 21.3667 9.64292Z"
			fill="#58707F"
		/>
		<path
			d="M24.5337 13.2322C24.5337 12.8241 24.8645 12.4932 25.2727 12.4932H38.3633C38.7715 12.4932 39.1023 12.8241 39.1023 13.2322C39.1023 13.6403 38.7715 13.9712 38.3633 13.9712H25.2727C24.8645 13.9712 24.5337 13.6403 24.5337 13.2322Z"
			fill="#58707F"
		/>
		<path
			d="M39.9473 13.2322C39.9473 12.8241 40.2781 12.4932 40.6863 12.4932H49.5541C49.9623 12.4932 50.2931 12.8241 50.2931 13.2322C50.2931 13.6403 49.9623 13.9712 49.5541 13.9712H40.6863C40.2781 13.9712 39.9473 13.6403 39.9473 13.2322Z"
			fill="#58707F"
		/>
		<rect
			x={ 9.12032 }
			y={ 38.6746 }
			width={ 58.2745 }
			height={ 11.1904 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M11.4429 41.5251C11.4429 41.2336 11.6792 40.9973 11.9707 40.9973H64.5445C64.836 40.9973 65.0723 41.2336 65.0723 41.5251C65.0723 41.8167 64.836 42.053 64.5445 42.053H11.9707C11.6792 42.053 11.4429 41.8167 11.4429 41.5251Z"
			fill="#58707F"
		/>
		<path
			d="M11.4429 44.2699C11.4429 43.9783 11.6792 43.742 11.9707 43.742H63.6999C63.9915 43.742 64.2278 43.9783 64.2278 44.2699C64.2278 44.5614 63.9915 44.7977 63.6999 44.7977H11.9707C11.6792 44.7977 11.4429 44.5614 11.4429 44.2699Z"
			fill="#58707F"
		/>
		<path
			d="M11.4429 47.0146C11.4429 46.7231 11.6792 46.4868 11.9707 46.4868H47.4422C47.7337 46.4868 47.97 46.7231 47.97 47.0146C47.97 47.3061 47.7337 47.5425 47.4422 47.5425H11.9707C11.6792 47.5425 11.4429 47.3061 11.4429 47.0146Z"
			fill="#58707F"
		/>
		<rect
			x={ 9.12032 }
			y={ 54.51 }
			width={ 27.6593 }
			height={ 8.02331 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M12.0767 58.5216C12.0767 57.9386 12.5493 57.4659 13.1324 57.4659C13.7154 57.4659 14.1881 57.9386 14.1881 58.5216C14.1881 59.1047 13.7154 59.5773 13.1324 59.5773C12.5493 59.5773 12.0767 59.1047 12.0767 58.5216Z"
			fill="#58707F"
		/>
		<path
			d="M15.877 58.5216C15.877 57.9386 16.3496 57.4659 16.9327 57.4659H21.3666C21.9496 57.4659 22.4223 57.9386 22.4223 58.5216C22.4223 59.1047 21.9496 59.5773 21.3666 59.5773H16.9327C16.3496 59.5773 15.877 59.1047 15.877 58.5216Z"
			fill="#58707F"
		/>
		<path
			d="M26.645 58.5216C26.645 57.9386 27.1177 57.4659 27.7007 57.4659H32.7681C33.3511 57.4659 33.8238 57.9386 33.8238 58.5216C33.8238 59.1047 33.3511 59.5773 32.7681 59.5773H27.7007C27.1177 59.5773 26.645 59.1047 26.645 58.5216Z"
			fill="#58707F"
		/>
		<rect
			x={ 39.7356 }
			y={ 54.51 }
			width={ 27.6593 }
			height={ 8.02331 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M42.6914 58.5216C42.6914 57.9386 43.1641 57.4659 43.7471 57.4659C44.3302 57.4659 44.8028 57.9386 44.8028 58.5216C44.8028 59.1047 44.3302 59.5773 43.7471 59.5773C43.1641 59.5773 42.6914 59.1047 42.6914 58.5216Z"
			fill="#58707F"
		/>
		<path
			d="M46.4922 58.5216C46.4922 57.9386 46.9648 57.4659 47.5479 57.4659H51.9818C52.5649 57.4659 53.0375 57.9386 53.0375 58.5216C53.0375 59.1047 52.5649 59.5773 51.9818 59.5773H47.5479C46.9648 59.5773 46.4922 59.1047 46.4922 58.5216Z"
			fill="#58707F"
		/>
		<path
			d="M57.2603 58.5216C57.2603 57.9386 57.7329 57.4659 58.316 57.4659H63.3833C63.9664 57.4659 64.439 57.9386 64.439 58.5216C64.439 59.1047 63.9664 59.5773 63.3833 59.5773H58.316C57.7329 59.5773 57.2603 59.1047 57.2603 58.5216Z"
			fill="#58707F"
		/>
		<rect
			x={ 9.12032 }
			y={ 65.4892 }
			width={ 27.6593 }
			height={ 8.02331 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M12.0767 69.501C12.0767 68.918 12.5493 68.4453 13.1324 68.4453C13.7154 68.4453 14.1881 68.918 14.1881 69.501C14.1881 70.0841 13.7154 70.5567 13.1324 70.5567C12.5493 70.5567 12.0767 70.0841 12.0767 69.501Z"
			fill="#58707F"
		/>
		<path
			d="M15.877 69.501C15.877 68.918 16.3496 68.4453 16.9327 68.4453H21.3666C21.9496 68.4453 22.4223 68.918 22.4223 69.501C22.4223 70.0841 21.9496 70.5567 21.3666 70.5567H16.9327C16.3496 70.5567 15.877 70.0841 15.877 69.501Z"
			fill="#58707F"
		/>
		<path
			d="M26.645 69.5009C26.645 68.9178 27.1177 68.4452 27.7007 68.4452H32.7681C33.3511 68.4452 33.8238 68.9178 33.8238 69.5009C33.8238 70.0839 33.3511 70.5566 32.7681 70.5566H27.7007C27.1177 70.5566 26.645 70.0839 26.645 69.5009Z"
			fill="#58707F"
		/>
		<rect
			x={ 39.7356 }
			y={ 65.4892 }
			width={ 27.6593 }
			height={ 8.02331 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M42.6914 69.501C42.6914 68.918 43.1641 68.4453 43.7471 68.4453C44.3302 68.4453 44.8028 68.918 44.8028 69.501C44.8028 70.0841 44.3302 70.5567 43.7471 70.5567C43.1641 70.5567 42.6914 70.0841 42.6914 69.501Z"
			fill="#58707F"
		/>
		<path
			d="M46.4922 69.5009C46.4922 68.9178 46.9648 68.4452 47.5479 68.4452H51.9818C52.5649 68.4452 53.0375 68.9178 53.0375 69.5009C53.0375 70.0839 52.5649 70.5566 51.9818 70.5566H47.5479C46.9648 70.5566 46.4922 70.0839 46.4922 69.5009Z"
			fill="#58707F"
		/>
		<path
			d="M57.2603 69.5007C57.2603 68.9177 57.7329 68.445 58.316 68.445H63.3833C63.9664 68.445 64.439 68.9177 64.439 69.5007C64.439 70.0838 63.9664 70.5564 63.3833 70.5564H58.316C57.7329 70.5564 57.2603 70.0838 57.2603 69.5007Z"
			fill="#58707F"
		/>
		<rect
			x={ 9.12032 }
			y={ 76.4685 }
			width={ 27.6593 }
			height={ 8.02331 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M12.0762 80.4801C12.0762 79.8971 12.5488 79.4244 13.1319 79.4244C13.7149 79.4244 14.1876 79.8971 14.1876 80.4801C14.1876 81.0632 13.7149 81.5358 13.1319 81.5358C12.5488 81.5358 12.0762 81.0632 12.0762 80.4801Z"
			fill="#58707F"
		/>
		<path
			d="M15.877 80.4801C15.877 79.8971 16.3496 79.4244 16.9327 79.4244H21.3666C21.9496 79.4244 22.4223 79.8971 22.4223 80.4801C22.4223 81.0632 21.9496 81.5358 21.3666 81.5358H16.9327C16.3496 81.5358 15.877 81.0632 15.877 80.4801Z"
			fill="#58707F"
		/>
		<path
			d="M26.645 80.4801C26.645 79.8971 27.1177 79.4244 27.7007 79.4244H32.7681C33.3511 79.4244 33.8238 79.8971 33.8238 80.4801C33.8238 81.0632 33.3511 81.5358 32.7681 81.5358H27.7007C27.1177 81.5358 26.645 81.0632 26.645 80.4801Z"
			fill="#58707F"
		/>
		<rect
			x={ 39.7356 }
			y={ 76.4685 }
			width={ 27.6593 }
			height={ 8.02331 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M42.6914 80.4801C42.6914 79.8971 43.1641 79.4244 43.7471 79.4244C44.3302 79.4244 44.8028 79.8971 44.8028 80.4801C44.8028 81.0632 44.3302 81.5358 43.7471 81.5358C43.1641 81.5358 42.6914 81.0632 42.6914 80.4801Z"
			fill="#58707F"
		/>
		<path
			d="M46.4922 80.4801C46.4922 79.8971 46.9648 79.4244 47.5479 79.4244H51.9818C52.5649 79.4244 53.0375 79.8971 53.0375 80.4801C53.0375 81.0632 52.5649 81.5358 51.9818 81.5358H47.5479C46.9648 81.5358 46.4922 81.0632 46.4922 80.4801Z"
			fill="#58707F"
		/>
		<path
			d="M57.2603 80.4801C57.2603 79.8971 57.7329 79.4244 58.316 79.4244H63.3833C63.9664 79.4244 64.439 79.8971 64.439 80.4801C64.439 81.0632 63.9664 81.5358 63.3833 81.5358H58.316C57.7329 81.5358 57.2603 81.0632 57.2603 80.4801Z"
			fill="#58707F"
		/>
		<path
			d="M35.5464 32.5638C35.5464 30.9284 35.2026 29.3093 34.5351 27.7985C33.8675 26.2875 32.8892 24.9144 31.6557 23.7579C30.4221 22.6014 28.9575 21.6835 27.3458 21.0577C25.7341 20.4319 24.0064 20.1103 22.262 20.1103C20.5178 20.1103 18.7906 20.4319 17.1791 21.0577C15.5674 21.6835 14.1028 22.6014 12.8692 23.7579C11.6357 24.9143 10.6566 26.2868 9.98896 27.7977C9.32141 29.3086 8.97848 30.9284 8.97843 32.5638C8.97843 33.0928 8.52062 33.522 7.95626 33.522C7.39189 33.522 6.93408 33.0928 6.93408 32.5638C6.93413 30.6768 7.33115 28.8084 8.10139 27.065C8.8717 25.3216 10.0007 23.7374 11.424 22.4031C12.8474 21.0687 14.5371 20.0102 16.3968 19.2881C18.2563 18.5659 20.2493 18.1937 22.262 18.1937C24.2749 18.1937 26.2684 18.5659 28.1281 19.2881C29.9878 20.0102 31.6775 21.0687 33.1008 22.4031C34.5241 23.7374 35.6532 25.3216 36.4235 27.065C37.1937 28.8084 37.5907 30.6768 37.5908 32.5638C37.5908 33.0928 37.1329 33.522 36.5686 33.522C36.0042 33.522 35.5464 33.0928 35.5464 32.5638Z"
			fill="#58707F"
		/>
		<path
			d="M28.119 33.2176V33.8671H25.2439V33.3129L26.6035 31.8551C26.7401 31.7031 26.8479 31.5693 26.9268 31.4538C27.0057 31.3365 27.0625 31.2316 27.0971 31.1392C27.1337 31.0449 27.152 30.9554 27.152 30.8707C27.152 30.7437 27.1308 30.635 27.0885 30.5445C27.0461 30.4522 26.9836 30.381 26.9008 30.3309C26.82 30.2809 26.7199 30.2559 26.6006 30.2559C26.4736 30.2559 26.3639 30.2867 26.2715 30.3482C26.1811 30.4098 26.1118 30.4955 26.0637 30.6052C26.0175 30.7149 25.9944 30.839 25.9944 30.9775H25.1602C25.1602 30.7274 25.2198 30.4984 25.3391 30.2905C25.4584 30.0807 25.6268 29.9143 25.8443 29.7911C26.0618 29.666 26.3196 29.6035 26.6179 29.6035C26.9124 29.6035 27.1606 29.6516 27.3627 29.7478C27.5667 29.8421 27.7206 29.9788 27.8246 30.1577C27.9304 30.3348 27.9833 30.5465 27.9833 30.7928C27.9833 30.9314 27.9612 31.067 27.9169 31.1998C27.8727 31.3307 27.8092 31.4615 27.7264 31.5924C27.6456 31.7213 27.5474 31.8522 27.432 31.985C27.3165 32.1178 27.1885 32.2554 27.048 32.3978L26.3177 33.2176H28.119Z"
			fill="#58707F"
		/>
		<path
			d="M24.7936 32.2968V32.9491H21.7655L21.7251 32.444L23.4773 29.6641H24.1384L23.4225 30.8621L22.5507 32.2968H24.7936ZM24.3173 29.6641V33.8671H23.486V29.6641H24.3173Z"
			fill="#58707F"
		/>
		<path
			d="M20.4805 29.6554V33.8671H19.6492V30.6138L18.6504 30.9314V30.2761L20.3911 29.6554H20.4805Z"
			fill="#58707F"
		/>
		<path
			d="M20.5757 25.5029C20.5757 25.1979 20.823 24.9505 21.1281 24.9505H25.3263C25.6314 24.9505 25.8787 25.1979 25.8787 25.5029C25.8787 25.808 25.6314 26.0553 25.3263 26.0553H21.1281C20.823 26.0553 20.5757 25.808 20.5757 25.5029Z"
			fill="#58707F"
		/>
		<g filter="url(#filter0_d_20430_28753)">
			<path
				d="M20.5214 19.883C20.5214 20.6993 19.8597 21.361 19.0434 21.361C18.2271 21.361 17.5654 20.6993 17.5654 19.883C17.5654 19.0667 18.2271 18.405 19.0434 18.405C19.8597 18.405 20.5214 19.0667 20.5214 19.883Z"
				fill="#D6E4ED"
			/>
		</g>
		<g filter="url(#filter1_d_20430_28753)">
			<path
				d="M20.2047 19.8829C20.2046 19.2416 19.6847 18.7216 19.0434 18.7216C18.4021 18.7216 17.8821 19.2416 17.8821 19.8829C17.8821 20.5242 18.4021 21.0441 19.0434 21.0442C19.6847 21.0442 20.2047 20.5242 20.2047 19.8829ZM20.8384 19.8829C20.8384 20.874 20.0345 21.6779 19.0434 21.6779C18.0523 21.6779 17.249 20.874 17.249 19.8829C17.2491 18.8918 18.0523 18.0886 19.0434 18.0885C20.0345 18.0885 20.8384 18.8918 20.8384 19.8829Z"
				fill="#58707F"
			/>
		</g>
		<path
			d="M49.8701 22.9445C49.8701 22.9445 49.8701 22.9445 49.8701 22.9445C49.8701 22.3614 50.3428 21.8888 50.9258 21.8888C50.9258 21.8888 50.9258 21.8888 50.9258 21.8888H66.5501C66.5501 21.8888 66.5501 21.8888 66.5501 21.8888C67.1332 21.8888 67.6058 22.3614 67.6058 22.9445C67.6058 22.9445 67.6058 22.9445 67.6058 22.9445C67.6058 22.9445 67.6058 22.9445 67.6058 22.9445C67.6058 23.5275 67.1332 24.0002 66.5501 24.0002H50.9258C50.9258 24.0002 50.9258 24.0002 50.9258 24.0002C50.3428 24.0002 49.8701 23.5275 49.8701 22.9445C49.8701 22.9445 49.8701 22.9445 49.8701 22.9445Z"
			fill="#58707F"
		/>
		<foreignObject
			x={ 53.7869 }
			y={ 24.6336 }
			width={ 15.2973 }
			height={ 7.38988 }
		>
			<div
				xmlns="http://www.w3.org/1999/xhtml"
				style={ {
					backdropFilter: 'blur(0.63px)',
					clipPath: 'url(#bgblur_0_20430_28753_clip_path)',
					height: '100%',
					width: '100%',
				} }
			/>
		</foreignObject>
		<g data-figma-bg-blur-radius={ 1.26684 }>
			<rect
				x={ 55.1591 }
				y={ 26.006 }
				width={ 12.5526 }
				height={ 4.64507 }
				rx={ 0.738989 }
				fill="#D6E4ED"
			/>
			<rect
				x={ 55.1591 }
				y={ 26.006 }
				width={ 12.5526 }
				height={ 4.64507 }
				rx={ 0.738989 }
				stroke="#58707F"
				strokeWidth={ 0.21114 }
			/>
			<path
				d="M63.7844 28.1169V29.291H63.4614V27.8408H63.7697L63.7844 28.1169ZM64.228 27.8314L64.2254 28.1316C64.2057 28.1281 64.1843 28.1254 64.161 28.1236C64.1387 28.1218 64.1164 28.1209 64.094 28.1209C64.0386 28.1209 63.9899 28.129 63.9479 28.1451C63.9059 28.1602 63.8706 28.1826 63.8421 28.2121C63.8144 28.2407 63.7929 28.2755 63.7777 28.3166C63.7625 28.3577 63.7536 28.4037 63.7509 28.4546L63.6772 28.46C63.6772 28.3689 63.6861 28.2844 63.704 28.2067C63.7219 28.129 63.7487 28.0606 63.7844 28.0016C63.8211 27.9427 63.8666 27.8967 63.9211 27.8636C63.9765 27.8305 64.0404 27.814 64.1128 27.814C64.1324 27.814 64.1534 27.8158 64.1758 27.8194C64.199 27.8229 64.2164 27.827 64.228 27.8314Z"
				fill="#58707F"
			/>
			<path
				d="M61.8408 28.582V28.5511C61.8408 28.4466 61.856 28.3497 61.8864 28.2603C61.9168 28.1701 61.9605 28.0919 62.0177 28.0258C62.0758 27.9588 62.1464 27.9069 62.2295 27.8703C62.3135 27.8328 62.4082 27.814 62.5136 27.814C62.6199 27.814 62.7147 27.8328 62.7978 27.8703C62.8817 27.9069 62.9528 27.9588 63.0109 28.0258C63.0689 28.0919 63.1132 28.1701 63.1435 28.2603C63.1739 28.3497 63.1891 28.4466 63.1891 28.5511V28.582C63.1891 28.6865 63.1739 28.7835 63.1435 28.8728C63.1132 28.9622 63.0689 29.0403 63.0109 29.1073C62.9528 29.1735 62.8822 29.2253 62.7991 29.2628C62.716 29.2994 62.6217 29.3178 62.5163 29.3178C62.41 29.3178 62.3148 29.2994 62.2308 29.2628C62.1477 29.2253 62.0771 29.1735 62.0191 29.1073C61.961 29.0403 61.9168 28.9622 61.8864 28.8728C61.856 28.7835 61.8408 28.6865 61.8408 28.582ZM62.1638 28.5511V28.582C62.1638 28.6472 62.1705 28.7088 62.1839 28.7669C62.1973 28.825 62.2183 28.8759 62.2469 28.9197C62.2755 28.9635 62.3121 28.9979 62.3568 29.0229C62.4015 29.0479 62.4547 29.0604 62.5163 29.0604C62.5762 29.0604 62.628 29.0479 62.6718 29.0229C62.7164 28.9979 62.7531 28.9635 62.7817 28.9197C62.8103 28.8759 62.8313 28.825 62.8447 28.7669C62.859 28.7088 62.8661 28.6472 62.8661 28.582V28.5511C62.8661 28.4868 62.859 28.4261 62.8447 28.3689C62.8313 28.3108 62.8098 28.2594 62.7803 28.2147C62.7517 28.1701 62.7151 28.1352 62.6704 28.1102C62.6266 28.0843 62.5744 28.0713 62.5136 28.0713C62.4529 28.0713 62.4001 28.0843 62.3555 28.1102C62.3117 28.1352 62.2755 28.1701 62.2469 28.2147C62.2183 28.2594 62.1973 28.3108 62.1839 28.3689C62.1705 28.4261 62.1638 28.4868 62.1638 28.5511Z"
				fill="#58707F"
			/>
			<path
				d="M60.2837 28.582V28.5511C60.2837 28.4466 60.2989 28.3497 60.3293 28.2603C60.3596 28.1701 60.4034 28.0919 60.4606 28.0258C60.5187 27.9588 60.5893 27.9069 60.6724 27.8703C60.7564 27.8328 60.8511 27.814 60.9565 27.814C61.0628 27.814 61.1575 27.8328 61.2406 27.8703C61.3246 27.9069 61.3956 27.9588 61.4537 28.0258C61.5118 28.0919 61.556 28.1701 61.5864 28.2603C61.6168 28.3497 61.632 28.4466 61.632 28.5511V28.582C61.632 28.6865 61.6168 28.7835 61.5864 28.8728C61.556 28.9622 61.5118 29.0403 61.4537 29.1073C61.3956 29.1735 61.3251 29.2253 61.242 29.2628C61.1589 29.2994 61.0646 29.3178 60.9592 29.3178C60.8528 29.3178 60.7577 29.2994 60.6737 29.2628C60.5906 29.2253 60.52 29.1735 60.4619 29.1073C60.4039 29.0403 60.3596 28.9622 60.3293 28.8728C60.2989 28.7835 60.2837 28.6865 60.2837 28.582ZM60.6067 28.5511V28.582C60.6067 28.6472 60.6134 28.7088 60.6268 28.7669C60.6402 28.825 60.6612 28.8759 60.6898 28.9197C60.7184 28.9635 60.755 28.9979 60.7997 29.0229C60.8444 29.0479 60.8975 29.0604 60.9592 29.0604C61.019 29.0604 61.0709 29.0479 61.1146 29.0229C61.1593 28.9979 61.1959 28.9635 61.2245 28.9197C61.2531 28.8759 61.2741 28.825 61.2875 28.7669C61.3018 28.7088 61.309 28.6472 61.309 28.582V28.5511C61.309 28.4868 61.3018 28.4261 61.2875 28.3689C61.2741 28.3108 61.2527 28.2594 61.2232 28.2147C61.1946 28.1701 61.158 28.1352 61.1133 28.1102C61.0695 28.0843 61.0173 28.0713 60.9565 28.0713C60.8957 28.0713 60.843 28.0843 60.7983 28.1102C60.7546 28.1352 60.7184 28.1701 60.6898 28.2147C60.6612 28.2594 60.6402 28.3108 60.6268 28.3689C60.6134 28.4261 60.6067 28.4868 60.6067 28.5511Z"
				fill="#58707F"
			/>
			<path
				d="M59.3842 28.5634H58.8763V28.2967H59.3842C59.4727 28.2967 59.5442 28.2824 59.5987 28.2538C59.6532 28.2252 59.6929 28.1859 59.7179 28.1358C59.7439 28.0849 59.7568 28.0268 59.7568 27.9616C59.7568 27.8999 59.7439 27.8423 59.7179 27.7887C59.6929 27.7342 59.6532 27.6904 59.5987 27.6574C59.5442 27.6243 59.4727 27.6078 59.3842 27.6078H58.9795V29.2911H58.6431V27.3397H59.3842C59.5352 27.3397 59.6634 27.3665 59.7689 27.4201C59.8752 27.4729 59.9561 27.5461 60.0115 27.6399C60.0669 27.7329 60.0945 27.8392 60.0945 27.9589C60.0945 28.0849 60.0669 28.193 60.0115 28.2833C59.9561 28.3735 59.8752 28.4427 59.7689 28.491C59.6634 28.5392 59.5352 28.5634 59.3842 28.5634Z"
				fill="#58707F"
			/>
		</g>
		<path
			d="M8.90967 89.9814C8.90967 89.9814 8.90967 89.9814 8.90967 89.9814C8.90967 89.3984 9.38232 88.9258 9.96537 88.9258C9.96537 88.9258 9.96537 88.9258 9.96537 88.9258H27.9122C27.9122 88.9258 27.9122 88.9258 27.9122 88.9258C28.4953 88.9258 28.9679 89.3984 28.9679 89.9814C28.9679 89.9814 28.9679 89.9814 28.9679 89.9814C28.9679 89.9814 28.9679 89.9814 28.9679 89.9814C28.9679 90.5645 28.4953 91.0371 27.9122 91.0371H9.96537C9.96537 91.0371 9.96537 91.0371 9.96537 91.0371C9.38232 91.0371 8.90967 90.5645 8.90967 89.9814C8.90967 89.9814 8.90967 89.9814 8.90967 89.9814Z"
			fill="#58707F"
		/>
		<path
			d="M59.583 89.9814C59.583 89.9814 59.583 89.9814 59.583 89.9814C59.583 89.3984 60.0557 88.9258 60.6387 88.9258C60.6387 88.9258 60.6387 88.9258 60.6387 88.9258H66.5506C66.5506 88.9258 66.5506 88.9258 66.5506 88.9258C67.1337 88.9258 67.6063 89.3984 67.6063 89.9814C67.6063 89.9814 67.6063 89.9814 67.6063 89.9814C67.6063 89.9814 67.6063 89.9814 67.6063 89.9814C67.6063 90.5645 67.1337 91.0371 66.5506 91.0371H66.5506H60.6387C60.6387 91.0371 60.6387 91.0371 60.6387 91.0371C60.0557 91.0371 59.583 90.5645 59.583 89.9814C59.583 89.9814 59.583 89.9814 59.583 89.9814Z"
			fill="#58707F"
		/>
		<path
			d="M49.8706 89.9814C49.8706 89.9814 49.8706 89.9814 49.8706 89.9814C49.8706 89.3984 50.3433 88.9258 50.9263 88.9258C50.9263 88.9258 50.9263 88.9258 50.9263 88.9258H56.8382C56.8382 88.9258 56.8382 88.9258 56.8382 88.9258C57.4213 88.9258 57.8939 89.3984 57.8939 89.9814C57.8939 89.9814 57.8939 89.9814 57.8939 89.9814C57.8939 89.9814 57.8939 89.9814 57.8939 89.9814C57.8939 90.5645 57.4213 91.0371 56.8382 91.0371H56.8382H50.9263C50.9263 91.0371 50.9263 91.0371 50.9263 91.0371C50.3433 91.0371 49.8706 90.5645 49.8706 89.9814C49.8706 89.9814 49.8706 89.9814 49.8706 89.9814Z"
			fill="#58707F"
		/>
		<path
			d="M8.90918 96.1046C8.90918 95.7548 9.19277 95.4712 9.5426 95.4712H21.7887C22.1386 95.4712 22.4221 95.7548 22.4221 96.1046C22.4221 96.4544 22.1386 96.738 21.7887 96.738H9.5426C9.19277 96.738 8.90918 96.4544 8.90918 96.1046Z"
			fill="#58707F"
		/>
		<path
			d="M8.90918 98.8493C8.90918 98.4995 9.19277 98.2159 9.5426 98.2159H19.0439C19.3937 98.2159 19.6773 98.4995 19.6773 98.8493C19.6773 99.1992 19.3937 99.4827 19.0439 99.4827H9.5426C9.19277 99.4827 8.90918 99.1992 8.90918 98.8493Z"
			fill="#58707F"
		/>
		<path
			d="M54.0928 97.3719C54.0928 97.0221 54.3764 96.7385 54.7262 96.7385H66.9723C67.3221 96.7385 67.6057 97.0221 67.6057 97.3719C67.6057 97.7217 67.3221 98.0053 66.9723 98.0053H54.7262C54.3764 98.0053 54.0928 97.7217 54.0928 97.3719Z"
			fill="#58707F"
		/>
		<path
			d="M44.1182 100.465C44.1182 99.6809 43.9534 98.904 43.6331 98.1792C43.3129 97.4544 42.8433 96.7956 42.2516 96.2408C41.6598 95.686 40.957 95.2459 40.1838 94.9456C39.4106 94.6453 38.5813 94.4908 37.7443 94.4908C36.9074 94.4909 36.0788 94.6454 35.3056 94.9456C34.5323 95.2459 33.8297 95.686 33.2379 96.2408C32.6461 96.7956 32.1766 97.4543 31.8563 98.1792C31.5361 98.9041 31.3712 99.6809 31.3712 100.465C31.3712 100.719 31.1514 100.925 30.8807 100.925C30.6099 100.925 30.3901 100.719 30.3901 100.465C30.3902 99.5601 30.581 98.6634 30.9505 97.827C31.3201 96.9907 31.8612 96.2304 32.544 95.5903C33.2268 94.9502 34.0378 94.4429 34.93 94.0965C35.8221 93.75 36.7786 93.5711 37.7443 93.5711C38.7101 93.5711 39.6665 93.75 40.5587 94.0965C41.4509 94.4429 42.2618 94.9502 42.9447 95.5903C43.6275 96.2304 44.1693 96.9907 44.5389 97.827C44.9085 98.6634 45.0985 99.5601 45.0985 100.465C45.0985 100.719 44.8788 100.925 44.608 100.925C44.3374 100.925 44.1182 100.719 44.1182 100.465Z"
			fill="#58707F"
		/>
		<path
			d="M41.1593 99.9007V100.212H39.7799V99.9464L40.4322 99.247C40.4978 99.1741 40.5495 99.1099 40.5873 99.0545C40.6252 98.9982 40.6524 98.9479 40.669 98.9036C40.6866 98.8583 40.6953 98.8154 40.6953 98.7748C40.6953 98.7138 40.6852 98.6617 40.6649 98.6183C40.6446 98.5739 40.6146 98.5398 40.5749 98.5158C40.5361 98.4918 40.4881 98.4798 40.4308 98.4798C40.3699 98.4798 40.3173 98.4945 40.2729 98.5241C40.2295 98.5536 40.1963 98.5947 40.1732 98.6473C40.1511 98.7 40.14 98.7595 40.14 98.826H39.7397C39.7397 98.706 39.7684 98.5961 39.8256 98.4964C39.8829 98.3958 39.9636 98.3159 40.068 98.2568C40.1723 98.1968 40.296 98.1668 40.4391 98.1668C40.5804 98.1668 40.6995 98.1899 40.7964 98.236C40.8943 98.2813 40.9682 98.3468 41.018 98.4327C41.0688 98.5176 41.0942 98.6192 41.0942 98.7374C41.0942 98.8038 41.0836 98.8689 41.0623 98.9326C41.0411 98.9954 41.0106 99.0582 40.9709 99.121C40.9322 99.1828 40.8851 99.2456 40.8297 99.3093C40.7743 99.373 40.7129 99.4391 40.6455 99.5074L40.2951 99.9007H41.1593Z"
			fill="#58707F"
		/>
		<path
			d="M39.5635 99.4589V99.7719H38.1107L38.0913 99.5295L38.932 98.1959H39.2491L38.9056 98.7706L38.4874 99.4589H39.5635ZM39.335 98.1959V100.212H38.9361V98.1959H39.335Z"
			fill="#58707F"
		/>
		<path
			d="M37.4947 98.1917V100.212H37.0959V98.6515L36.6167 98.8038V98.4895L37.4518 98.1917H37.4947Z"
			fill="#58707F"
		/>
		<g filter="url(#filter3_d_20430_28753)">
			<path
				d="M37.0393 94.3819C37.0393 94.7735 36.7218 95.091 36.3302 95.091C35.9386 95.091 35.6211 94.7735 35.6211 94.3819C35.6211 93.9903 35.9386 93.6728 36.3302 93.6728C36.7218 93.6728 37.0393 93.9903 37.0393 94.3819Z"
				fill="#D6E4ED"
			/>
		</g>
		<g filter="url(#filter4_d_20430_28753)">
			<path
				d="M36.8869 94.3823C36.8869 94.0747 36.6378 93.8251 36.3303 93.8249C36.0226 93.8249 35.7729 94.0746 35.7729 94.3823C35.7731 94.6898 36.0227 94.9389 36.3303 94.9389C36.6377 94.9387 36.8867 94.6897 36.8869 94.3823ZM37.1911 94.3823C37.1909 94.8575 36.8055 95.2429 36.3303 95.2431C35.8548 95.2431 35.4689 94.8577 35.4688 94.3823C35.4688 93.9067 35.8547 93.5208 36.3303 93.5208C36.8057 93.5209 37.1911 93.9068 37.1911 94.3823Z"
				fill="#58707F"
			/>
		</g>
		<path
			d="M8.90918 105.493C8.90918 105.143 9.19277 104.859 9.5426 104.859H21.7887C22.1386 104.859 22.4221 105.143 22.4221 105.493C22.4221 105.842 22.1386 106.126 21.7887 106.126H9.5426C9.19277 106.126 8.90918 105.842 8.90918 105.493Z"
			fill="#58707F"
		/>
		<path
			d="M8.90918 108.14C8.90918 107.79 9.19277 107.506 9.5426 107.506H19.0439C19.3937 107.506 19.6773 107.79 19.6773 108.14C19.6773 108.49 19.3937 108.773 19.0439 108.773H9.5426C9.19277 108.773 8.90918 108.49 8.90918 108.14Z"
			fill="#58707F"
		/>
		<path
			d="M54.0928 106.759C54.0928 106.41 54.3764 106.126 54.7262 106.126H66.9723C67.3221 106.126 67.6057 106.41 67.6057 106.759C67.6057 107.109 67.3221 107.393 66.9723 107.393H54.7262C54.3764 107.393 54.0928 107.109 54.0928 106.759Z"
			fill="#58707F"
		/>
		<path
			d="M44.1182 109.853C44.1182 109.068 43.9534 108.291 43.6331 107.566C43.3129 106.842 42.8433 106.183 42.2516 105.628C41.6598 105.073 40.957 104.633 40.1838 104.333C39.4106 104.033 38.5813 103.878 37.7443 103.878C36.9074 103.878 36.0788 104.033 35.3056 104.333C34.5323 104.633 33.8297 105.073 33.2379 105.628C32.6461 106.183 32.1766 106.841 31.8563 107.566C31.5361 108.291 31.3712 109.068 31.3712 109.853C31.3712 110.106 31.1514 110.312 30.8807 110.312C30.6099 110.312 30.3901 110.106 30.3901 109.853C30.3902 108.947 30.581 108.051 30.9505 107.214C31.3201 106.378 31.8612 105.618 32.544 104.977C33.2268 104.337 34.0378 103.83 34.93 103.484C35.8221 103.137 36.7786 102.958 37.7443 102.958C38.7101 102.958 39.6665 103.137 40.5587 103.484C41.4509 103.83 42.2618 104.337 42.9447 104.977C43.6275 105.618 44.1693 106.378 44.5389 107.214C44.9085 108.051 45.0985 108.947 45.0985 109.853C45.0985 110.106 44.8788 110.312 44.608 110.312C44.3374 110.312 44.1182 110.106 44.1182 109.853Z"
			fill="#58707F"
		/>
		<path
			d="M41.1593 109.288V109.6H39.7799V109.334L40.4322 108.634C40.4978 108.561 40.5495 108.497 40.5873 108.442C40.6252 108.386 40.6524 108.335 40.669 108.291C40.6866 108.246 40.6953 108.203 40.6953 108.162C40.6953 108.101 40.6852 108.049 40.6649 108.006C40.6446 107.961 40.6146 107.927 40.5749 107.903C40.5361 107.879 40.4881 107.867 40.4308 107.867C40.3699 107.867 40.3173 107.882 40.2729 107.911C40.2295 107.941 40.1963 107.982 40.1732 108.035C40.1511 108.087 40.14 108.147 40.14 108.213H39.7397C39.7397 108.093 39.7684 107.983 39.8256 107.884C39.8829 107.783 39.9636 107.703 40.068 107.644C40.1723 107.584 40.296 107.554 40.4391 107.554C40.5804 107.554 40.6995 107.577 40.7964 107.623C40.8943 107.669 40.9682 107.734 41.018 107.82C41.0688 107.905 41.0942 108.007 41.0942 108.125C41.0942 108.191 41.0836 108.256 41.0623 108.32C41.0411 108.383 41.0106 108.446 40.9709 108.508C40.9322 108.57 40.8851 108.633 40.8297 108.697C40.7743 108.76 40.7129 108.826 40.6455 108.895L40.2951 109.288H41.1593Z"
			fill="#58707F"
		/>
		<path
			d="M39.5635 108.846V109.159H38.1107L38.0913 108.917L38.932 107.583H39.2491L38.9056 108.158L38.4874 108.846H39.5635ZM39.335 107.583V109.6H38.9361V107.583H39.335Z"
			fill="#58707F"
		/>
		<path
			d="M37.4947 107.579V109.6H37.0959V108.039L36.6167 108.191V107.877L37.4518 107.579H37.4947Z"
			fill="#58707F"
		/>
		<g filter="url(#filter5_d_20430_28753)">
			<path
				d="M37.0393 103.769C37.0393 104.161 36.7218 104.478 36.3302 104.478C35.9386 104.478 35.6211 104.161 35.6211 103.769C35.6211 103.378 35.9386 103.06 36.3302 103.06C36.7218 103.06 37.0393 103.378 37.0393 103.769Z"
				fill="#D6E4ED"
			/>
		</g>
		<g filter="url(#filter6_d_20430_28753)">
			<path
				d="M36.8869 103.77C36.8869 103.462 36.6378 103.212 36.3303 103.212C36.0226 103.212 35.7729 103.462 35.7729 103.77C35.7731 104.077 36.0227 104.326 36.3303 104.326C36.6377 104.326 36.8867 104.077 36.8869 103.77ZM37.1911 103.77C37.1909 104.245 36.8055 104.63 36.3303 104.63C35.8548 104.63 35.4689 104.245 35.4688 103.77C35.4688 103.294 35.8547 102.908 36.3303 102.908C36.8057 102.908 37.1911 103.294 37.1911 103.77Z"
				fill="#58707F"
			/>
		</g>
		<path
			d="M8.90918 114.88C8.90918 114.53 9.19277 114.246 9.5426 114.246H21.7887C22.1386 114.246 22.4221 114.53 22.4221 114.88C22.4221 115.23 22.1386 115.513 21.7887 115.513H9.5426C9.19277 115.513 8.90918 115.23 8.90918 114.88Z"
			fill="#58707F"
		/>
		<path
			d="M8.90918 117.641C8.90918 117.291 9.19277 117.007 9.5426 117.007H19.0439C19.3937 117.007 19.6773 117.291 19.6773 117.641C19.6773 117.991 19.3937 118.274 19.0439 118.274H9.5426C9.19277 118.274 8.90918 117.991 8.90918 117.641Z"
			fill="#58707F"
		/>
		<path
			d="M54.0928 116.147C54.0928 115.797 54.3764 115.514 54.7262 115.514H66.9723C67.3221 115.514 67.6057 115.797 67.6057 116.147C67.6057 116.497 67.3221 116.78 66.9723 116.78H54.7262C54.3764 116.78 54.0928 116.497 54.0928 116.147Z"
			fill="#58707F"
		/>
		<path
			d="M44.1182 119.241C44.1182 118.456 43.9534 117.679 43.6331 116.954C43.3129 116.23 42.8433 115.571 42.2516 115.016C41.6598 114.461 40.957 114.021 40.1838 113.721C39.4106 113.42 38.5813 113.266 37.7443 113.266C36.9074 113.266 36.0788 113.42 35.3056 113.721C34.5323 114.021 33.8297 114.461 33.2379 115.016C32.6461 115.571 32.1766 116.229 31.8563 116.954C31.5361 117.679 31.3712 118.456 31.3712 119.241C31.3712 119.494 31.1514 119.7 30.8807 119.7C30.6099 119.7 30.3901 119.494 30.3901 119.241C30.3902 118.335 30.581 117.439 30.9505 116.602C31.3201 115.766 31.8612 115.006 32.544 114.365C33.2268 113.725 34.0378 113.218 34.93 112.872C35.8221 112.525 36.7786 112.346 37.7443 112.346C38.7101 112.346 39.6665 112.525 40.5587 112.872C41.4509 113.218 42.2618 113.725 42.9447 114.365C43.6275 115.006 44.1693 115.766 44.5389 116.602C44.9085 117.439 45.0985 118.335 45.0985 119.241C45.0985 119.494 44.8788 119.7 44.608 119.7C44.3374 119.7 44.1182 119.494 44.1182 119.241Z"
			fill="#58707F"
		/>
		<path
			d="M41.1593 118.675V118.987H39.7799V118.721L40.4322 118.022C40.4978 117.949 40.5495 117.885 40.5873 117.829C40.6252 117.773 40.6524 117.723 40.669 117.678C40.6866 117.633 40.6953 117.59 40.6953 117.549C40.6953 117.489 40.6852 117.436 40.6649 117.393C40.6446 117.349 40.6146 117.315 40.5749 117.29C40.5361 117.266 40.4881 117.254 40.4308 117.254C40.3699 117.254 40.3173 117.269 40.2729 117.299C40.2295 117.328 40.1963 117.369 40.1732 117.422C40.1511 117.475 40.14 117.534 40.14 117.601H39.7397C39.7397 117.481 39.7684 117.371 39.8256 117.271C39.8829 117.17 39.9636 117.091 40.068 117.032C40.1723 116.972 40.296 116.941 40.4391 116.941C40.5804 116.941 40.6995 116.965 40.7964 117.011C40.8943 117.056 40.9682 117.122 41.018 117.207C41.0688 117.292 41.0942 117.394 41.0942 117.512C41.0942 117.579 41.0836 117.644 41.0623 117.707C41.0411 117.77 41.0106 117.833 40.9709 117.896C40.9322 117.958 40.8851 118.02 40.8297 118.084C40.7743 118.148 40.7129 118.214 40.6455 118.282L40.2951 118.675H41.1593Z"
			fill="#58707F"
		/>
		<path
			d="M39.5635 118.234V118.547H38.1107L38.0913 118.304L38.932 116.971H39.2491L38.9056 117.545L38.4874 118.234H39.5635ZM39.335 116.971V118.987H38.9361V116.971H39.335Z"
			fill="#58707F"
		/>
		<path
			d="M37.4947 116.966V118.987H37.0959V117.426L36.6167 117.579V117.264L37.4518 116.966H37.4947Z"
			fill="#58707F"
		/>
		<g filter="url(#filter7_d_20430_28753)">
			<path
				d="M37.0393 113.157C37.0393 113.548 36.7218 113.866 36.3302 113.866C35.9386 113.866 35.6211 113.548 35.6211 113.157C35.6211 112.765 35.9386 112.448 36.3302 112.448C36.7218 112.448 37.0393 112.765 37.0393 113.157Z"
				fill="#D6E4ED"
			/>
		</g>
		<g filter="url(#filter8_d_20430_28753)">
			<path
				d="M36.8869 113.157C36.8869 112.849 36.6378 112.6 36.3303 112.6C36.0226 112.6 35.7729 112.849 35.7729 113.157C35.7731 113.465 36.0227 113.714 36.3303 113.714C36.6377 113.713 36.8867 113.464 36.8869 113.157ZM37.1911 113.157C37.1909 113.632 36.8055 114.018 36.3303 114.018C35.8548 114.018 35.4689 113.632 35.4688 113.157C35.4688 112.681 35.8547 112.295 36.3303 112.295C36.8057 112.296 37.1911 112.682 37.1911 113.157Z"
				fill="#58707F"
			/>
		</g>
		<defs>
			<filter
				id="filter0_d_20430_28753"
				x={ 17.3259 }
				y={ 18.1655 }
				width={ 3.91406 }
				height={ 3.91395 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.239502 } dy={ 0.239502 } />
				<feGaussianBlur stdDeviation={ 0.239502 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28753"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28753"
					result="shape"
				/>
			</filter>
			<filter
				id="filter1_d_20430_28753"
				x={ 17.0095 }
				y={ 17.849 }
				width={ 4.54736 }
				height={ 4.54742 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.239502 } dy={ 0.239502 } />
				<feGaussianBlur stdDeviation={ 0.239502 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28753"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28753"
					result="shape"
				/>
			</filter>
			<clipPath
				id="bgblur_0_20430_28753_clip_path"
				transform="translate(-53.7869 -24.6336)"
			>
				<rect
					x={ 55.1591 }
					y={ 26.006 }
					width={ 12.5526 }
					height={ 4.64507 }
					rx={ 0.738989 }
				/>
			</clipPath>
			<filter
				id="filter3_d_20430_28753"
				x={ 35.5062 }
				y={ 93.5579 }
				width={ 1.87759 }
				height={ 1.87783 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.114904 } dy={ 0.114904 } />
				<feGaussianBlur stdDeviation={ 0.114904 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28753"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28753"
					result="shape"
				/>
			</filter>
			<filter
				id="filter4_d_20430_28753"
				x={ 35.3538 }
				y={ 93.4058 }
				width={ 2.18178 }
				height={ 2.18194 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.114904 } dy={ 0.114904 } />
				<feGaussianBlur stdDeviation={ 0.114904 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28753"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28753"
					result="shape"
				/>
			</filter>
			<filter
				id="filter5_d_20430_28753"
				x={ 35.5062 }
				y={ 102.945 }
				width={ 1.87759 }
				height={ 1.87783 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.114904 } dy={ 0.114904 } />
				<feGaussianBlur stdDeviation={ 0.114904 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28753"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28753"
					result="shape"
				/>
			</filter>
			<filter
				id="filter6_d_20430_28753"
				x={ 35.3538 }
				y={ 102.793 }
				width={ 2.18178 }
				height={ 2.18194 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.114904 } dy={ 0.114904 } />
				<feGaussianBlur stdDeviation={ 0.114904 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28753"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28753"
					result="shape"
				/>
			</filter>
			<filter
				id="filter7_d_20430_28753"
				x={ 35.5062 }
				y={ 112.333 }
				width={ 1.87759 }
				height={ 1.87783 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.114904 } dy={ 0.114904 } />
				<feGaussianBlur stdDeviation={ 0.114904 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28753"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28753"
					result="shape"
				/>
			</filter>
			<filter
				id="filter8_d_20430_28753"
				x={ 35.3538 }
				y={ 112.181 }
				width={ 2.18178 }
				height={ 2.18194 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.114904 } dy={ 0.114904 } />
				<feGaussianBlur stdDeviation={ 0.114904 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28753"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28753"
					result="shape"
				/>
			</filter>
		</defs>
	</svg>
);

export const AqiMinimalTwoIcon = ( { isPopup = false } ) => (
	<svg
		width={ isPopup ? 102 : 76 }
		height={ isPopup ? 172 : 128 }
		viewBox="0 0 76 128"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x={ 0.558824 }
			y={ 0.558824 }
			width={ 74.8824 }
			height={ 126.882 }
			rx={ 1.67647 }
			fill="white"
		/>
		<rect
			x={ 0.558824 }
			y={ 0.558824 }
			width={ 74.8824 }
			height={ 126.882 }
			rx={ 1.67647 }
			stroke="#8796A1"
			strokeWidth={ 1.11765 }
		/>
		<path
			d="M4.43408 6.25545C4.43408 5.26013 4.43408 4.76247 4.74329 4.45327C5.0525 4.14406 5.55016 4.14406 6.54548 4.14406H69.4651C70.4604 4.14406 70.9581 4.14406 71.2673 4.45327C71.5765 4.76247 71.5765 5.26013 71.5765 6.25546V121.538C71.5765 122.533 71.5765 123.031 71.2673 123.34C70.9581 123.649 70.4604 123.649 69.4651 123.649H6.54548C5.55016 123.649 5.0525 123.649 4.74329 123.34C4.43408 123.031 4.43408 122.533 4.43408 121.538V6.25545Z"
			fill="white"
		/>
		<path
			d="M69.465 122.919V123.649H6.54568V122.919H69.465ZM70.846 121.538V6.25565C70.846 5.73763 70.8446 5.42222 70.814 5.19476C70.7999 5.08967 70.7825 5.0328 70.7704 5.00339C70.7607 4.97993 70.7545 4.97373 70.7507 4.96992C70.7469 4.96613 70.7408 4.95996 70.7172 4.95028C70.6879 4.93819 70.6311 4.92076 70.5259 4.90662C70.2984 4.87607 69.9831 4.8746 69.465 4.8746H6.54568C6.02764 4.8746 5.71225 4.87608 5.48479 4.90662C5.37965 4.92075 5.32282 4.93819 5.29342 4.95028C5.26986 4.95997 5.26375 4.96612 5.25995 4.96992C5.25615 4.97372 5.24999 4.97984 5.2403 5.00339C5.22821 5.03279 5.21078 5.08963 5.19664 5.19476C5.16611 5.42222 5.16463 5.73762 5.16463 6.25565V121.538C5.16463 122.056 5.16608 122.371 5.19664 122.599C5.21078 122.704 5.22821 122.761 5.2403 122.79C5.24995 122.813 5.25616 122.82 5.25995 122.823C5.26376 122.827 5.2701 122.834 5.29342 122.843C5.32284 122.855 5.37976 122.873 5.48479 122.887C5.71224 122.917 6.02766 122.919 6.54568 122.919V123.649L5.88717 123.644C5.36105 123.631 5.03327 123.581 4.80372 123.395L4.74333 123.34C4.5114 123.108 4.45366 122.77 4.43918 122.196L4.43408 121.538V6.25565C4.43408 5.3227 4.4341 4.8268 4.68875 4.5137L4.74333 4.4533C4.97519 4.22144 5.31299 4.16366 5.88717 4.14915L6.54568 4.14406H69.465C70.4603 4.14406 70.9581 4.1441 71.2673 4.4533C71.5765 4.76251 71.5766 5.26038 71.5766 6.25565V121.538L71.5715 122.196C71.557 122.77 71.4993 123.108 71.2673 123.34L71.2069 123.395C70.9773 123.581 70.6493 123.631 70.1228 123.644L69.465 123.649V122.919C69.9831 122.919 70.2984 122.917 70.5259 122.887C70.631 122.873 70.6879 122.855 70.7172 122.843C70.7407 122.833 70.7469 122.827 70.7507 122.823C70.7545 122.82 70.7607 122.813 70.7704 122.79C70.7825 122.761 70.7999 122.704 70.814 122.599C70.8446 122.371 70.846 122.056 70.846 121.538Z"
			fill="#58707F"
		/>
		<path
			d="M21.1953 9.48485C21.1953 8.67756 21.8498 8.02312 22.657 8.02312H51.8918C52.6991 8.02312 53.3535 8.67756 53.3535 9.48485C53.3535 10.2921 52.6991 10.9466 51.8918 10.9466H22.657C21.8498 10.9466 21.1953 10.2921 21.1953 9.48485Z"
			fill="#58707F"
		/>
		<path
			d="M24.4844 13.1393C24.4844 12.7357 24.8116 12.4084 25.2152 12.4084H38.3709C38.7745 12.4084 39.1017 12.7357 39.1017 13.1393C39.1017 13.543 38.7745 13.8702 38.3709 13.8702H25.2152C24.8116 13.8702 24.4844 13.543 24.4844 13.1393Z"
			fill="#58707F"
		/>
		<path
			d="M39.8325 13.1393C39.8325 12.7357 40.1597 12.4084 40.5634 12.4084H49.3338C49.7375 12.4084 50.0647 12.7357 50.0647 13.1393C50.0647 13.543 49.7375 13.8702 49.3338 13.8702H40.5634C40.1597 13.8702 39.8325 13.543 39.8325 13.1393Z"
			fill="#58707F"
		/>
		<path
			d="M30.6157 45.3793C30.6157 45.3469 30.6157 45.3307 30.6161 45.317C30.6306 44.7747 31.0669 44.3385 31.6092 44.3239C31.6229 44.3236 31.6391 44.3236 31.6714 44.3236H44.3398C44.3722 44.3236 44.3884 44.3236 44.402 44.3239C44.9444 44.3385 45.3806 44.7747 45.3951 45.317C45.3955 45.3307 45.3955 45.3469 45.3955 45.3793C45.3955 45.4116 45.3955 45.4278 45.3951 45.4415C45.3806 45.9838 44.9444 46.4201 44.402 46.4346C44.3884 46.435 44.3722 46.435 44.3398 46.435H31.6714C31.6391 46.435 31.6229 46.435 31.6092 46.4346C31.0669 46.4201 30.6306 45.9838 30.6161 45.4415C30.6157 45.4278 30.6157 45.4116 30.6157 45.3793Z"
			fill="#58707F"
		/>
		<foreignObject
			x={ 30.3572 }
			y={ 46.4187 }
			width={ 15.2973 }
			height={ 7.38991 }
		>
			<div
				xmlns="http://www.w3.org/1999/xhtml"
				style={ {
					backdropFilter: 'blur(0.63px)',
					clipPath: 'url(#bgblur_0_20430_28754_clip_path)',
					height: '100%',
					width: '100%',
				} }
			/>
		</foreignObject>
		<g data-figma-bg-blur-radius={ 1.26684 }>
			<rect
				x={ 31.7294 }
				y={ 47.7911 }
				width={ 12.5526 }
				height={ 4.64507 }
				rx={ 0.738989 }
				fill="#D6E4ED"
			/>
			<rect
				x={ 31.7294 }
				y={ 47.7911 }
				width={ 12.5526 }
				height={ 4.64507 }
				rx={ 0.738989 }
				stroke="#58707F"
				strokeWidth={ 0.21114 }
			/>
			<path
				d="M40.3547 49.9018V51.0759H40.0317V49.6257H40.34L40.3547 49.9018ZM40.7984 49.6163L40.7957 49.9165C40.776 49.913 40.7546 49.9103 40.7313 49.9085C40.709 49.9067 40.6867 49.9058 40.6643 49.9058C40.6089 49.9058 40.5602 49.9139 40.5182 49.9299C40.4763 49.9451 40.441 49.9675 40.4124 49.997C40.3847 50.0256 40.3632 50.0604 40.348 50.1015C40.3328 50.1426 40.3239 50.1886 40.3212 50.2395L40.2475 50.2449C40.2475 50.1538 40.2565 50.0693 40.2743 49.9916C40.2922 49.9139 40.319 49.8455 40.3547 49.7865C40.3914 49.7276 40.4369 49.6816 40.4914 49.6485C40.5468 49.6154 40.6107 49.5989 40.6831 49.5989C40.7028 49.5989 40.7237 49.6007 40.7461 49.6043C40.7693 49.6078 40.7867 49.6119 40.7984 49.6163Z"
				fill="#58707F"
			/>
			<path
				d="M38.4111 50.3669V50.336C38.4111 50.2315 38.4263 50.1346 38.4567 50.0452C38.4871 49.955 38.5309 49.8768 38.588 49.8107C38.6461 49.7437 38.7167 49.6918 38.7998 49.6552C38.8838 49.6177 38.9785 49.5989 39.0839 49.5989C39.1903 49.5989 39.285 49.6177 39.3681 49.6552C39.4521 49.6918 39.5231 49.7437 39.5812 49.8107C39.6392 49.8768 39.6835 49.955 39.7138 50.0452C39.7442 50.1346 39.7594 50.2315 39.7594 50.336V50.3669C39.7594 50.4714 39.7442 50.5683 39.7138 50.6577C39.6835 50.747 39.6392 50.8252 39.5812 50.8922C39.5231 50.9584 39.4525 51.0102 39.3694 51.0477C39.2863 51.0843 39.192 51.1027 39.0866 51.1027C38.9803 51.1027 38.8851 51.0843 38.8011 51.0477C38.718 51.0102 38.6475 50.9584 38.5894 50.8922C38.5313 50.8252 38.4871 50.747 38.4567 50.6577C38.4263 50.5683 38.4111 50.4714 38.4111 50.3669ZM38.7341 50.336V50.3669C38.7341 50.4321 38.7408 50.4937 38.7542 50.5518C38.7676 50.6099 38.7886 50.6608 38.8172 50.7046C38.8458 50.7484 38.8825 50.7828 38.9271 50.8078C38.9718 50.8328 39.025 50.8453 39.0866 50.8453C39.1465 50.8453 39.1983 50.8328 39.2421 50.8078C39.2868 50.7828 39.3234 50.7484 39.352 50.7046C39.3806 50.6608 39.4016 50.6099 39.415 50.5518C39.4293 50.4937 39.4364 50.4321 39.4364 50.3669V50.336C39.4364 50.2717 39.4293 50.211 39.415 50.1538C39.4016 50.0957 39.3801 50.0443 39.3506 49.9996C39.3221 49.955 39.2854 49.9201 39.2407 49.8951C39.197 49.8692 39.1447 49.8562 39.0839 49.8562C39.0232 49.8562 38.9705 49.8692 38.9258 49.8951C38.882 49.9201 38.8458 49.955 38.8172 49.9996C38.7886 50.0443 38.7676 50.0957 38.7542 50.1538C38.7408 50.211 38.7341 50.2717 38.7341 50.336Z"
				fill="#58707F"
			/>
			<path
				d="M36.854 50.3669V50.336C36.854 50.2315 36.8692 50.1346 36.8996 50.0452C36.93 49.955 36.9737 49.8768 37.0309 49.8107C37.089 49.7437 37.1596 49.6918 37.2427 49.6552C37.3267 49.6177 37.4214 49.5989 37.5268 49.5989C37.6331 49.5989 37.7278 49.6177 37.8109 49.6552C37.8949 49.6918 37.966 49.7437 38.024 49.8107C38.0821 49.8768 38.1263 49.955 38.1567 50.0452C38.1871 50.1346 38.2023 50.2315 38.2023 50.336V50.3669C38.2023 50.4714 38.1871 50.5683 38.1567 50.6577C38.1263 50.747 38.0821 50.8252 38.024 50.8922C37.966 50.9584 37.8954 51.0102 37.8123 51.0477C37.7292 51.0843 37.6349 51.1027 37.5295 51.1027C37.4232 51.1027 37.328 51.0843 37.244 51.0477C37.1609 51.0102 37.0903 50.9584 37.0323 50.8922C36.9742 50.8252 36.93 50.747 36.8996 50.6577C36.8692 50.5683 36.854 50.4714 36.854 50.3669ZM37.177 50.336V50.3669C37.177 50.4321 37.1837 50.4937 37.1971 50.5518C37.2105 50.6099 37.2315 50.6608 37.2601 50.7046C37.2887 50.7484 37.3253 50.7828 37.37 50.8078C37.4147 50.8328 37.4678 50.8453 37.5295 50.8453C37.5894 50.8453 37.6412 50.8328 37.685 50.8078C37.7296 50.7828 37.7663 50.7484 37.7949 50.7046C37.8234 50.6608 37.8444 50.6099 37.8578 50.5518C37.8721 50.4937 37.8793 50.4321 37.8793 50.3669V50.336C37.8793 50.2717 37.8721 50.211 37.8578 50.1538C37.8444 50.0957 37.823 50.0443 37.7935 49.9996C37.7649 49.955 37.7283 49.9201 37.6836 49.8951C37.6398 49.8692 37.5876 49.8562 37.5268 49.8562C37.466 49.8562 37.4133 49.8692 37.3687 49.8951C37.3249 49.9201 37.2887 49.955 37.2601 49.9996C37.2315 50.0443 37.2105 50.0957 37.1971 50.1538C37.1837 50.211 37.177 50.2717 37.177 50.336Z"
				fill="#58707F"
			/>
			<path
				d="M35.9545 50.3483H35.4466V50.0816H35.9545C36.043 50.0816 36.1145 50.0673 36.169 50.0387C36.2235 50.0101 36.2632 49.9708 36.2883 49.9207C36.3142 49.8698 36.3271 49.8117 36.3271 49.7465C36.3271 49.6849 36.3142 49.6272 36.2883 49.5736C36.2632 49.5191 36.2235 49.4753 36.169 49.4423C36.1145 49.4092 36.043 49.3927 35.9545 49.3927H35.5498V51.076H35.2134V49.1246H35.9545C36.1055 49.1246 36.2337 49.1514 36.3392 49.205C36.4455 49.2578 36.5264 49.331 36.5818 49.4248C36.6372 49.5178 36.6649 49.6241 36.6649 49.7438C36.6649 49.8698 36.6372 49.9779 36.5818 50.0682C36.5264 50.1584 36.4455 50.2277 36.3392 50.2759C36.2337 50.3242 36.1055 50.3483 35.9545 50.3483Z"
				fill="#58707F"
			/>
		</g>
		<path
			d="M8.76953 66.5139C8.76953 65.9037 9.26417 65.4091 9.87433 65.4091H14.2935C14.9037 65.4091 15.3983 65.9037 15.3983 66.5139C15.3983 67.1241 14.9037 67.6187 14.2935 67.6187H9.87433C9.26417 67.6187 8.76953 67.1241 8.76953 66.5139Z"
			fill="#58707F"
		/>
		<path
			d="M18.4907 68.0172C18.4907 67.8423 18.6325 67.7005 18.8074 67.7005H34.8106C34.9855 67.7005 35.1273 67.8423 35.1273 68.0172C35.1273 68.1922 34.9855 68.3339 34.8106 68.3339H18.8074C18.6325 68.3339 18.4907 68.1922 18.4907 68.0172Z"
			fill="#D6E4ED"
		/>
		<path
			d="M18.4907 68.0172C18.4907 67.8423 18.6325 67.7005 18.8074 67.7005H29.4091C29.584 67.7005 29.7258 67.8423 29.7258 68.0172C29.7258 68.1922 29.584 68.3339 29.4091 68.3339H18.8074C18.6325 68.3339 18.4907 68.1922 18.4907 68.0172Z"
			fill="#58707F"
		/>
		<path
			d="M18.5522 65.3209C18.5522 65.0158 18.7996 64.7685 19.1046 64.7685H23.8787C24.1837 64.7685 24.4311 65.0158 24.4311 65.3209C24.4311 65.626 24.1837 65.8733 23.8787 65.8733H19.1046C18.7996 65.8733 18.5522 65.626 18.5522 65.3209Z"
			fill="#58707F"
		/>
		<path
			d="M29.4053 65.3209C29.4053 65.0158 29.6526 64.7685 29.9577 64.7685H34.7317C35.0368 64.7685 35.2841 65.0158 35.2841 65.3209C35.2841 65.626 35.0368 65.8733 34.7317 65.8733H29.9577C29.6526 65.8733 29.4053 65.626 29.4053 65.3209Z"
			fill="#58707F"
		/>
		<path
			d="M40.7236 66.5139C40.7236 65.9037 41.2183 65.4091 41.8284 65.4091H46.2476C46.8578 65.4091 47.3524 65.9037 47.3524 66.5139C47.3524 67.1241 46.8578 67.6187 46.2476 67.6187H41.8284C41.2183 67.6187 40.7236 67.1241 40.7236 66.5139Z"
			fill="#58707F"
		/>
		<path
			d="M50.4468 68.0172C50.4468 67.8423 50.5886 67.7005 50.7635 67.7005H66.7666C66.9415 67.7005 67.0833 67.8423 67.0833 68.0172C67.0833 68.1921 66.9415 68.3339 66.7666 68.3339H50.7635C50.5886 68.3339 50.4468 68.1921 50.4468 68.0172Z"
			fill="#D6E4ED"
		/>
		<path
			d="M50.4468 68.0172C50.4468 67.8423 50.5886 67.7005 50.7635 67.7005H61.3651C61.5401 67.7005 61.6819 67.8423 61.6819 68.0172C61.6819 68.1921 61.5401 68.3339 61.3651 68.3339H50.7635C50.5886 68.3339 50.4468 68.1921 50.4468 68.0172Z"
			fill="#58707F"
		/>
		<path
			d="M50.5063 65.3209C50.5063 65.0158 50.7537 64.7685 51.0587 64.7685H55.8328C56.1378 64.7685 56.3852 65.0158 56.3852 65.3209C56.3852 65.626 56.1378 65.8733 55.8328 65.8733H51.0587C50.7537 65.8733 50.5063 65.626 50.5063 65.3209Z"
			fill="#58707F"
		/>
		<path
			d="M61.3604 65.3209C61.3604 65.0158 61.6077 64.7685 61.9128 64.7685H66.6868C66.9919 64.7685 67.2392 65.0158 67.2392 65.3209C67.2392 65.626 66.9919 65.8733 66.6868 65.8733H61.9128C61.6077 65.8733 61.3604 65.626 61.3604 65.3209Z"
			fill="#58707F"
		/>
		<path
			d="M8.76953 74.3024C8.76953 73.6922 9.26417 73.1976 9.87433 73.1976H14.2935C14.9037 73.1976 15.3983 73.6922 15.3983 74.3024C15.3983 74.9126 14.9037 75.4072 14.2935 75.4072H9.87433C9.26417 75.4072 8.76953 74.9126 8.76953 74.3024Z"
			fill="#58707F"
		/>
		<path
			d="M18.4907 75.8051C18.4907 75.6302 18.6325 75.4884 18.8074 75.4884H34.8106C34.9855 75.4884 35.1273 75.6302 35.1273 75.8051C35.1273 75.98 34.9855 76.1218 34.8106 76.1218H18.8074C18.6325 76.1218 18.4907 75.98 18.4907 75.8051Z"
			fill="#D6E4ED"
		/>
		<path
			d="M18.4907 75.8051C18.4907 75.6302 18.6325 75.4884 18.8074 75.4884H29.4091C29.584 75.4884 29.7258 75.6302 29.7258 75.8051C29.7258 75.98 29.584 76.1218 29.4091 76.1218H18.8074C18.6325 76.1218 18.4907 75.98 18.4907 75.8051Z"
			fill="#58707F"
		/>
		<path
			d="M18.5522 73.1092C18.5522 72.8041 18.7996 72.5568 19.1046 72.5568H23.8787C24.1837 72.5568 24.4311 72.8041 24.4311 73.1092C24.4311 73.4143 24.1837 73.6616 23.8787 73.6616H19.1046C18.7996 73.6616 18.5522 73.4143 18.5522 73.1092Z"
			fill="#58707F"
		/>
		<path
			d="M29.4053 73.1092C29.4053 72.8041 29.6526 72.5568 29.9577 72.5568H34.7317C35.0368 72.5568 35.2841 72.8041 35.2841 73.1092C35.2841 73.4143 35.0368 73.6616 34.7317 73.6616H29.9577C29.6526 73.6616 29.4053 73.4143 29.4053 73.1092Z"
			fill="#58707F"
		/>
		<path
			d="M40.7236 74.3022C40.7236 73.692 41.2183 73.1974 41.8284 73.1974H46.2476C46.8578 73.1974 47.3524 73.692 47.3524 74.3022C47.3524 74.9124 46.8578 75.407 46.2476 75.407H41.8284C41.2183 75.407 40.7236 74.9124 40.7236 74.3022Z"
			fill="#58707F"
		/>
		<path
			d="M50.4468 75.8049C50.4468 75.63 50.5886 75.4882 50.7635 75.4882H66.7666C66.9415 75.4882 67.0833 75.63 67.0833 75.8049C67.0833 75.9798 66.9415 76.1216 66.7666 76.1216H50.7635C50.5886 76.1216 50.4468 75.9798 50.4468 75.8049Z"
			fill="#D6E4ED"
		/>
		<path
			d="M50.4468 75.8049C50.4468 75.63 50.5886 75.4882 50.7635 75.4882H61.3651C61.5401 75.4882 61.6819 75.63 61.6819 75.8049C61.6819 75.9798 61.5401 76.1216 61.3651 76.1216H50.7635C50.5886 76.1216 50.4468 75.9798 50.4468 75.8049Z"
			fill="#58707F"
		/>
		<path
			d="M50.5063 73.109C50.5063 72.8039 50.7537 72.5566 51.0587 72.5566H55.8328C56.1378 72.5566 56.3852 72.8039 56.3852 73.109C56.3852 73.4141 56.1378 73.6614 55.8328 73.6614H51.0587C50.7537 73.6614 50.5063 73.4141 50.5063 73.109Z"
			fill="#58707F"
		/>
		<path
			d="M61.3604 73.109C61.3604 72.8039 61.6077 72.5566 61.9128 72.5566H66.6868C66.9919 72.5566 67.2392 72.8039 67.2392 73.109C67.2392 73.4141 66.9919 73.6614 66.6868 73.6614H61.9128C61.6077 73.6614 61.3604 73.4141 61.3604 73.109Z"
			fill="#58707F"
		/>
		<path
			d="M8.76953 82.0903C8.76953 81.4802 9.26417 80.9855 9.87433 80.9855H14.2935C14.9037 80.9855 15.3983 81.4802 15.3983 82.0903C15.3983 82.7005 14.9037 83.1951 14.2935 83.1951H9.87433C9.26417 83.1951 8.76953 82.7005 8.76953 82.0903Z"
			fill="#58707F"
		/>
		<path
			d="M18.4907 83.5927C18.4907 83.4178 18.6325 83.276 18.8074 83.276H34.8106C34.9855 83.276 35.1273 83.4178 35.1273 83.5927C35.1273 83.7676 34.9855 83.9094 34.8106 83.9094H18.8074C18.6325 83.9094 18.4907 83.7676 18.4907 83.5927Z"
			fill="#D6E4ED"
		/>
		<path
			d="M18.4907 83.5927C18.4907 83.4178 18.6325 83.276 18.8074 83.276H29.4091C29.584 83.276 29.7258 83.4178 29.7258 83.5927C29.7258 83.7676 29.584 83.9094 29.4091 83.9094H18.8074C18.6325 83.9094 18.4907 83.7676 18.4907 83.5927Z"
			fill="#58707F"
		/>
		<path
			d="M18.5522 80.8971C18.5522 80.592 18.7996 80.3447 19.1046 80.3447H23.8787C24.1837 80.3447 24.4311 80.592 24.4311 80.8971C24.4311 81.2021 24.1837 81.4495 23.8787 81.4495H19.1046C18.7996 81.4495 18.5522 81.2021 18.5522 80.8971Z"
			fill="#58707F"
		/>
		<path
			d="M29.4053 80.8971C29.4053 80.592 29.6526 80.3447 29.9577 80.3447H34.7317C35.0368 80.3447 35.2841 80.592 35.2841 80.8971C35.2841 81.2021 35.0368 81.4495 34.7317 81.4495H29.9577C29.6526 81.4495 29.4053 81.2021 29.4053 80.8971Z"
			fill="#58707F"
		/>
		<path
			d="M40.7236 82.0907C40.7236 81.4805 41.2183 80.9859 41.8284 80.9859H46.2476C46.8578 80.9859 47.3524 81.4805 47.3524 82.0907C47.3524 82.7008 46.8578 83.1955 46.2476 83.1955H41.8284C41.2183 83.1955 40.7236 82.7008 40.7236 82.0907Z"
			fill="#58707F"
		/>
		<path
			d="M50.4468 83.5928C50.4468 83.4179 50.5886 83.2761 50.7635 83.2761H66.7666C66.9415 83.2761 67.0833 83.4179 67.0833 83.5928C67.0833 83.7677 66.9415 83.9095 66.7666 83.9095H50.7635C50.5886 83.9095 50.4468 83.7677 50.4468 83.5928Z"
			fill="#D6E4ED"
		/>
		<path
			d="M50.4468 83.5928C50.4468 83.4179 50.5886 83.2761 50.7635 83.2761H61.3651C61.5401 83.2761 61.6819 83.4179 61.6819 83.5928C61.6819 83.7677 61.5401 83.9095 61.3651 83.9095H50.7635C50.5886 83.9095 50.4468 83.7677 50.4468 83.5928Z"
			fill="#58707F"
		/>
		<path
			d="M50.5063 80.8972C50.5063 80.5921 50.7537 80.3448 51.0587 80.3448H55.8328C56.1378 80.3448 56.3852 80.5921 56.3852 80.8972C56.3852 81.2022 56.1378 81.4496 55.8328 81.4496H51.0587C50.7537 81.4496 50.5063 81.2022 50.5063 80.8972Z"
			fill="#58707F"
		/>
		<path
			d="M61.3604 80.8972C61.3604 80.5921 61.6077 80.3448 61.9128 80.3448H66.6868C66.9919 80.3448 67.2392 80.5921 67.2392 80.8972C67.2392 81.2022 66.9919 81.4496 66.6868 81.4496H61.9128C61.6077 81.4496 61.3604 81.2022 61.3604 80.8972Z"
			fill="#58707F"
		/>
		<path
			d="M8.85547 56.6835C8.85547 56.3785 9.10279 56.1311 9.40787 56.1311H66.1946C66.4997 56.1311 66.747 56.3785 66.747 56.6835C66.747 56.9886 66.4997 57.2359 66.1946 57.2359H9.40787C9.10279 57.2359 8.85547 56.9886 8.85547 56.6835Z"
			fill="#58707F"
		/>
		<path
			d="M11.9487 59.8997C11.9487 59.5946 12.196 59.3473 12.5011 59.3473H63.101C63.4061 59.3473 63.6534 59.5946 63.6534 59.8997C63.6534 60.2048 63.4061 60.4521 63.101 60.4521H12.5011C12.196 60.4521 11.9487 60.2048 11.9487 59.8997Z"
			fill="#58707F"
		/>
		<path
			d="M45.9081 40.747C46.1378 41.0108 46.5392 41.0396 46.7912 40.7969C48.4903 39.1611 49.7023 37.0799 50.2843 34.7856C50.9183 32.2862 50.7745 29.6528 49.8721 27.2373C48.9697 24.8218 47.3517 22.7392 45.2343 21.2677C43.1168 19.7962 40.6007 19.0059 38.0222 19.0024C35.4436 18.9988 32.9254 19.7822 30.8039 21.2479C28.6824 22.7136 27.0587 24.7918 26.1497 27.2048C25.2407 29.6178 25.0897 32.2508 25.7168 34.7519C26.2925 37.0478 27.4988 39.1323 29.1934 40.7728C29.4448 41.0161 29.8462 40.9885 30.0767 40.7253C30.3071 40.4621 30.2792 40.0631 30.0292 39.8184C28.5278 38.3488 27.4586 36.4896 26.9456 34.4438C26.3812 32.1928 26.5171 29.8231 27.3352 27.6514C28.1533 25.4797 29.6147 23.6093 31.524 22.2902C33.4333 20.9711 35.6997 20.266 38.0204 20.2692C40.3411 20.2724 42.6056 20.9837 44.5113 22.308C46.417 23.6324 47.8732 25.5067 48.6854 27.6807C49.4975 29.8546 49.6269 32.2246 49.0563 34.4741C48.5378 36.5185 47.4634 38.3748 45.958 39.8403C45.7074 40.0843 45.6784 40.4832 45.9081 40.747Z"
			fill="white"
		/>
		<path
			d="M38.0231 18.1576C40.7735 18.1614 43.4571 19.0046 45.7157 20.5741C47.9743 22.1436 49.7003 24.3651 50.6629 26.9416C51.6254 29.518 51.7785 32.3269 51.1024 34.9929C50.4816 37.4402 49.1893 39.6606 47.3769 41.4055C46.7568 42.0025 45.7994 41.9081 45.2711 41.3015C44.7277 40.6774 44.8183 39.7707 45.3686 39.235L45.6255 38.9767C46.885 37.6629 47.7875 36.0412 48.2377 34.2667C48.766 32.1839 48.6462 29.9892 47.8942 27.9763C47.1422 25.9634 45.7936 24.2277 44.029 23.0015C42.2645 21.7752 40.1675 21.1169 38.0188 21.114C35.87 21.1111 33.7713 21.7633 32.0034 22.9847C30.2355 24.2061 28.8826 25.9385 28.1251 27.9494C27.3677 29.9601 27.2416 32.1542 27.7642 34.2383C28.2391 36.1325 29.2294 37.8539 30.6194 39.2146C31.1682 39.7518 31.257 40.6592 30.7119 41.2818C30.1819 41.8871 29.2238 41.978 28.6053 41.3793C26.7979 39.6295 25.5114 37.4061 24.8973 34.9572C24.2284 32.2894 24.3898 29.4812 25.3594 26.9074C26.329 24.3336 28.0604 22.1164 30.3233 20.553C32.5862 18.9896 35.2727 18.1538 38.0231 18.1576ZM38.0217 19.0024C35.4432 18.9989 32.925 19.7822 30.8035 21.2479C28.6821 22.7135 27.0586 24.792 26.1496 27.205L25.988 27.6598C25.2247 29.9465 25.1287 32.4072 25.7166 34.752C26.2923 37.0479 27.4987 39.132 29.1933 40.7725C29.429 41.0007 29.7966 40.991 30.0315 40.7718L30.0766 40.7252C30.2925 40.4784 30.2813 40.1122 30.073 39.8658L30.0286 39.8186C28.6211 38.4407 27.5938 36.7202 27.0482 34.8248L26.9456 34.4435C26.4165 32.3332 26.5024 30.1187 27.1894 28.0607L27.3349 27.6518C28.1019 25.6157 29.4341 23.8441 31.171 22.5438L31.5239 22.2906C33.4332 20.9714 35.6995 20.266 38.0202 20.2692L38.4546 20.2779C40.6225 20.3635 42.7242 21.0665 44.5107 22.308C46.4164 23.6324 47.873 25.5069 48.6852 27.6809C49.4972 29.8547 49.6268 32.2247 49.0563 34.4741L48.9522 34.8554C48.4014 36.7491 47.3692 38.4665 45.958 39.8404C45.7073 40.0844 45.678 40.4832 45.9078 40.747C46.1231 40.9943 46.4891 41.035 46.7416 40.8394L46.7911 40.7972C48.4903 39.1614 49.7018 37.0798 50.2838 34.7855C50.8782 32.4423 50.7891 29.9813 50.032 27.6925L49.8719 27.237C49.0259 24.9725 47.5506 23.0006 45.6247 21.5506L45.234 21.2675C43.1165 19.796 40.6002 19.0059 38.0217 19.0024Z"
			fill="#58707F"
		/>
		<path
			d="M30.1807 22.5262C29.9532 22.2604 29.5522 22.2281 29.2981 22.4685C28.1319 23.5719 27.1847 24.8883 26.5086 26.3486C25.7437 28.0008 25.344 29.7984 25.3365 31.6191C25.3291 33.4397 25.7142 35.2405 26.4656 36.8989C27.1297 38.3647 28.0662 39.6888 29.2233 40.8016C29.4754 41.0441 29.8767 41.0151 30.1063 40.7512C30.3359 40.4872 30.3067 40.0884 30.0559 39.8445C29.0354 38.8521 28.2084 37.676 27.6195 36.3761C26.9432 34.8835 26.5967 33.2628 26.6034 31.6242C26.61 29.9857 26.9698 28.3678 27.6582 26.8808C28.2578 25.5857 29.0943 24.4164 30.1228 23.4324C30.3756 23.1906 30.4081 22.792 30.1807 22.5262Z"
			fill="#58707F"
		/>
		<path
			d="M28.8382 21.7521C29.4603 21.2783 30.3314 21.4042 30.8217 21.9769C31.3597 22.6057 31.261 23.5118 30.7061 24.0427C29.7538 24.9538 28.9793 26.0365 28.4242 27.2356C27.7868 28.6124 27.4539 30.1104 27.4477 31.6276C27.4415 33.1448 27.7624 34.6456 28.3885 36.0276C28.9339 37.2312 29.6994 38.3205 30.6442 39.2394C31.1946 39.7747 31.2861 40.6808 30.7432 41.3051C30.2152 41.912 29.2578 42.0072 28.6374 41.4106C27.4031 40.2236 26.4047 38.8106 25.6963 37.2471C24.8949 35.4783 24.4834 33.5578 24.4913 31.6159C24.4992 29.6739 24.9263 27.7558 25.7421 25.9935C26.4632 24.436 27.4737 23.0322 28.7174 21.8554L28.8382 21.7521ZM30.1807 22.5263C29.9533 22.2605 29.5522 22.2284 29.2981 22.4688C28.1319 23.5722 27.1844 24.8883 26.5083 26.3486L26.3693 26.66C25.6952 28.2255 25.3431 29.912 25.3361 31.6188C25.3287 33.4394 25.7141 35.2402 26.4654 36.8986C27.1295 38.3644 28.066 39.6888 29.2231 40.8016C29.4594 41.0288 29.8265 41.0175 30.0606 40.7979L30.1058 40.7514C30.321 40.5039 30.3089 40.1378 30.0999 39.892L30.0555 39.8447C29.0989 38.9144 28.3121 37.8224 27.7322 36.6184L27.6194 36.3761C26.9432 34.8836 26.5962 33.2625 26.6029 31.6239C26.6092 30.0879 26.9261 28.5702 27.5328 27.1613L27.658 26.8805C28.2575 25.5855 29.0941 24.4161 30.1225 23.4322C30.3751 23.1904 30.4079 22.7921 30.1807 22.5263Z"
			fill="#58707F"
		/>
		<path
			d="M28.0815 22.6974C28.0815 21.7645 28.8378 21.0083 29.7707 21.0083C30.7035 21.0083 31.4598 21.7645 31.4598 22.6974C31.4598 23.6303 30.7035 24.3865 29.7707 24.3865C28.8378 24.3865 28.0815 23.6303 28.0815 22.6974Z"
			fill="#58707F"
		/>
		<path
			d="M31.46 22.6971C31.4599 21.7644 30.7032 21.0083 29.7704 21.0083C28.8378 21.0084 28.0818 21.7645 28.0816 22.6971C28.0816 23.5717 28.7462 24.2915 29.598 24.378L29.7704 24.3867C30.6449 24.3867 31.3647 23.722 31.4513 22.8703L31.46 22.6971ZM32.3041 22.6971C32.3041 24.0964 31.1698 25.2307 29.7704 25.2307C28.3713 25.2306 27.2368 24.0963 27.2368 22.6971C27.237 21.298 28.3714 20.1636 29.7704 20.1635C31.1697 20.1635 32.3039 21.2979 32.3041 22.6971Z"
			fill="#58707F"
		/>
		<path
			d="M42.6895 32.5076V33.0643H40.2251V32.5893L41.3905 31.3398C41.5076 31.2094 41.6 31.0948 41.6676 30.9958C41.7352 30.8952 41.7839 30.8053 41.8136 30.7261C41.8449 30.6453 41.8606 30.5686 41.8606 30.496C41.8606 30.3872 41.8424 30.294 41.8061 30.2164C41.7699 30.1372 41.7162 30.0762 41.6453 30.0333C41.576 29.9904 41.4903 29.969 41.388 29.969C41.2791 29.969 41.1851 29.9954 41.1059 30.0482C41.0284 30.101 40.969 30.1744 40.9278 30.2684C40.8882 30.3624 40.8684 30.4688 40.8684 30.5876H40.1533C40.1533 30.3731 40.2045 30.1768 40.3067 29.9987C40.409 29.8189 40.5533 29.6762 40.7397 29.5706C40.9261 29.4634 41.1472 29.4098 41.4028 29.4098C41.6552 29.4098 41.868 29.451 42.0412 29.5335C42.2161 29.6143 42.348 29.7315 42.4371 29.8849C42.5278 30.0366 42.5732 30.2181 42.5732 30.4292C42.5732 30.548 42.5542 30.6643 42.5163 30.7781C42.4783 30.8903 42.4239 31.0024 42.353 31.1146C42.2837 31.2251 42.1996 31.3373 42.1006 31.4511C42.0016 31.5649 41.8919 31.6829 41.7715 31.8049L41.1455 32.5076H42.6895Z"
			fill="#58707F"
		/>
		<path
			d="M39.8387 31.7181V32.2773H37.2431L37.2085 31.8443L38.7104 29.4616H39.277L38.6634 30.4884L37.9161 31.7181H39.8387ZM39.4304 29.4616V33.0642H38.7178V29.4616H39.4304Z"
			fill="#58707F"
		/>
		<path
			d="M36.1419 29.4543V33.0642H35.4293V30.2757L34.5732 30.5479V29.9862L36.0652 29.4543H36.1419Z"
			fill="#58707F"
		/>
		<path
			d="M35.9414 26.3346C35.9414 26.0295 36.1887 25.7822 36.4938 25.7822H40.692C40.9971 25.7822 41.2444 26.0295 41.2444 26.3346C41.2444 26.6397 40.9971 26.887 40.692 26.887H36.4938C36.1887 26.887 35.9414 26.6397 35.9414 26.3346Z"
			fill="#58707F"
		/>
		<path
			d="M33.1436 36.0569C33.1436 35.7518 33.3909 35.5045 33.696 35.5045H42.7553C43.0604 35.5045 43.3077 35.7518 43.3077 36.0569C43.3077 36.362 43.0604 36.6093 42.7553 36.6093H33.696C33.3909 36.6093 33.1436 36.362 33.1436 36.0569Z"
			fill="#58707F"
		/>
		<path
			d="M8.86865 89.3119C8.86865 89.3119 8.86865 89.3119 8.86865 89.3119C8.86865 88.7289 9.3413 88.2562 9.92435 88.2562C9.92435 88.2562 9.92435 88.2562 9.92435 88.2562H27.8712C27.8712 88.2562 27.8712 88.2562 27.8712 88.2562C28.4543 88.2562 28.9269 88.7289 28.9269 89.3119C28.9269 89.3119 28.9269 89.3119 28.9269 89.3119C28.9269 89.3119 28.9269 89.3119 28.9269 89.3119C28.9269 89.895 28.4543 90.3676 27.8712 90.3676H9.92435C9.92435 90.3676 9.92435 90.3676 9.92435 90.3676C9.3413 90.3676 8.86865 89.895 8.86865 89.3119C8.86865 89.3119 8.86865 89.3119 8.86865 89.3119Z"
			fill="#58707F"
		/>
		<path
			d="M59.5425 89.312C59.5425 89.312 59.5425 89.312 59.5425 89.312C59.5425 88.7289 60.0151 88.2563 60.5982 88.2563C60.5982 88.2563 60.5982 88.2563 60.5982 88.2563H66.5101C66.5101 88.2563 66.5101 88.2563 66.5101 88.2563C67.0931 88.2563 67.5658 88.7289 67.5658 89.312C67.5658 89.312 67.5658 89.312 67.5658 89.312C67.5658 89.312 67.5658 89.312 67.5658 89.312C67.5658 89.895 67.0931 90.3677 66.5101 90.3677H66.5101H60.5982C60.5982 90.3677 60.5982 90.3677 60.5982 90.3677C60.0151 90.3677 59.5425 89.895 59.5425 89.312C59.5425 89.312 59.5425 89.312 59.5425 89.312Z"
			fill="#58707F"
		/>
		<path
			d="M49.8296 89.312C49.8296 89.312 49.8296 89.312 49.8296 89.312C49.8296 88.7289 50.3022 88.2563 50.8853 88.2563C50.8853 88.2563 50.8853 88.2563 50.8853 88.2563H56.7972C56.7972 88.2563 56.7972 88.2563 56.7972 88.2563C57.3802 88.2563 57.8529 88.7289 57.8529 89.312C57.8529 89.312 57.8529 89.312 57.8529 89.312C57.8529 89.312 57.8529 89.312 57.8529 89.312C57.8529 89.895 57.3802 90.3677 56.7972 90.3677H56.7972H50.8853C50.8853 90.3677 50.8853 90.3677 50.8853 90.3677C50.3022 90.3677 49.8296 89.895 49.8296 89.312C49.8296 89.312 49.8296 89.312 49.8296 89.312Z"
			fill="#58707F"
		/>
		<path
			d="M8.86816 95.4348C8.86816 95.085 9.15176 94.8014 9.50158 94.8014H21.7477C22.0975 94.8014 22.3811 95.085 22.3811 95.4348C22.3811 95.7847 22.0975 96.0683 21.7477 96.0683H9.50158C9.15176 96.0683 8.86816 95.7847 8.86816 95.4348Z"
			fill="#58707F"
		/>
		<path
			d="M8.86816 98.1796C8.86816 97.8297 9.15176 97.5461 9.50158 97.5461H19.0029C19.3527 97.5461 19.6363 97.8297 19.6363 98.1796C19.6363 98.5294 19.3527 98.813 19.0029 98.813H9.50158C9.15175 98.813 8.86816 98.5294 8.86816 98.1796Z"
			fill="#58707F"
		/>
		<path
			d="M40.8042 100.297C40.8794 100.384 41.0109 100.393 41.0934 100.314C41.6497 99.7781 42.0466 99.0967 42.2371 98.3454C42.4447 97.527 42.3976 96.6648 42.1022 95.8739C41.8067 95.0829 41.2769 94.401 40.5836 93.9192C39.8903 93.4374 39.0664 93.1786 38.2221 93.1775C37.3778 93.1763 36.5532 93.4328 35.8586 93.9127C35.164 94.3926 34.6323 95.0731 34.3347 95.8632C34.037 96.6533 33.9876 97.5154 34.1929 98.3344C34.3814 99.0861 34.7764 99.7687 35.3313 100.306C35.4136 100.386 35.545 100.376 35.6205 100.29C35.6959 100.204 35.6868 100.073 35.6049 99.9933C35.1133 99.5121 34.7632 98.9034 34.5953 98.2335C34.4105 97.4964 34.455 96.7205 34.7228 96.0094C34.9907 95.2984 35.4692 94.6859 36.0944 94.254C36.7196 93.8221 37.4617 93.5912 38.2215 93.5923C38.9814 93.5933 39.7229 93.8262 40.3469 94.2598C40.9709 94.6935 41.4477 95.3072 41.7136 96.019C41.9795 96.7309 42.0219 97.5069 41.8351 98.2434C41.6653 98.9128 41.3135 99.5206 40.8206 100C40.7385 100.08 40.729 100.211 40.8042 100.297Z"
			fill="white"
		/>
		<path
			d="M38.2225 92.901C39.123 92.9022 40.002 93.178 40.7415 93.6919C41.4811 94.2059 42.0461 94.9337 42.3613 95.7773C42.6764 96.6209 42.7267 97.5407 42.5053 98.4135C42.3021 99.2148 41.8785 99.9414 41.2851 100.513C41.0822 100.708 40.7691 100.678 40.596 100.479C40.4181 100.275 40.4479 99.978 40.628 99.8026L40.7925 99.6301C41.1627 99.2163 41.4298 98.7179 41.5674 98.1756C41.7404 97.4936 41.7008 96.7748 41.4546 96.1157C41.2084 95.4567 40.7669 94.8887 40.1893 94.4872C39.6115 94.0857 38.9246 93.8697 38.221 93.8687C37.5175 93.8678 36.8301 94.0815 36.2513 94.4814C35.6725 94.8813 35.2296 95.4486 34.9816 96.1069C34.7336 96.7653 34.6926 97.4837 34.8637 98.1661C35.0192 98.7864 35.3435 99.3505 35.7987 99.796C35.9781 99.972 36.0069 100.269 35.8285 100.473C35.655 100.671 35.3412 100.701 35.1388 100.505C34.5469 99.9319 34.1262 99.2037 33.9251 98.4019C33.706 97.5284 33.7582 96.6084 34.0757 95.7657C34.3931 94.923 34.9604 94.1973 35.7012 93.6854C36.4422 93.1735 37.3219 92.8998 38.2225 92.901ZM38.2225 93.1775C37.3782 93.1763 36.553 93.4332 35.8584 93.9131L35.7303 94.0048C35.0984 94.4779 34.6138 95.1224 34.3347 95.8632L34.2816 96.0123C34.0318 96.761 34.0004 97.5666 34.1928 98.3342C34.3813 99.086 34.7767 99.769 35.3316 100.306C35.4139 100.386 35.5451 100.376 35.6204 100.29C35.6865 100.215 35.6878 100.105 35.6321 100.025L35.6052 99.9932C35.1751 99.5722 34.8528 99.0537 34.6665 98.4819L34.5952 98.2338C34.4104 97.4968 34.4547 96.7205 34.7225 96.0094C34.9569 95.3873 35.3531 94.8409 35.8671 94.4246L36.0941 94.2544C36.7193 93.8225 37.4619 93.5912 38.2217 93.5922L38.5055 93.6031C39.165 93.6543 39.8012 93.8808 40.3472 94.2602C40.971 94.6938 41.4478 95.3072 41.7137 96.0189C41.9796 96.7307 42.022 97.5068 41.8352 98.2433L41.7631 98.4914C41.5753 99.0627 41.2521 99.5806 40.8209 100.001C40.7388 100.08 40.729 100.211 40.8041 100.297C40.8699 100.373 40.9788 100.39 41.0602 100.34L41.0937 100.313C41.6499 99.7778 42.0463 99.0962 42.2368 98.3451C42.4314 97.578 42.4024 96.7726 42.1546 96.0233L42.1022 95.8741C41.8252 95.1326 41.3422 94.4869 40.7117 94.0121L40.5836 93.9189C39.9337 93.4673 39.169 93.2116 38.3804 93.1804L38.2225 93.1775Z"
			fill="#58707F"
		/>
		<path
			d="M35.6545 94.3313C35.5801 94.2442 35.4487 94.2337 35.3655 94.3124C34.9837 94.6737 34.6735 95.1047 34.4522 95.5829C34.2017 96.1238 34.0708 96.7124 34.0684 97.3086C34.066 97.9047 34.1921 98.4944 34.4381 99.0374C34.6555 99.5173 34.9622 99.9509 35.341 100.315C35.4236 100.395 35.555 100.385 35.6302 100.299C35.7054 100.212 35.6958 100.082 35.6137 100.002C35.2795 99.6769 35.0088 99.2918 34.8159 98.8662C34.5945 98.3775 34.481 97.8468 34.4832 97.3103C34.4854 96.7738 34.6032 96.244 34.8286 95.7571C35.0249 95.3331 35.2988 94.9502 35.6356 94.628C35.7184 94.5488 35.729 94.4183 35.6545 94.3313Z"
			fill="#58707F"
		/>
		<path
			d="M35.2568 94.0492C35.4277 93.9458 35.6424 93.966 35.7945 94.0841L35.8651 94.1518L35.9211 94.2325C36.0304 94.4296 35.9861 94.6756 35.8272 94.8278C35.5154 95.1261 35.2617 95.4807 35.0799 95.8734C34.8713 96.3241 34.7618 96.8145 34.7598 97.3112C34.7578 97.8079 34.8633 98.2994 35.0683 98.7519C35.2469 99.146 35.4975 99.5025 35.8068 99.8033C35.9871 99.9786 36.0166 100.276 35.8389 100.48C35.6661 100.679 35.3529 100.71 35.1498 100.515C34.7457 100.126 34.4184 99.6633 34.1864 99.1514C33.924 98.5722 33.7894 97.9433 33.792 97.3075C33.7946 96.6717 33.9345 96.0437 34.2017 95.4666C34.4378 94.9567 34.7688 94.4971 35.176 94.1118L35.2568 94.0492ZM35.6548 94.3315C35.5803 94.2445 35.4491 94.2339 35.3659 94.3126C34.9841 94.6739 34.6734 95.1049 34.452 95.583L34.3639 95.7882C34.1712 96.2713 34.0707 96.7869 34.0685 97.3083C34.0661 97.9043 34.1922 98.4942 34.4382 99.0371C34.6556 99.5171 34.9623 99.9512 35.3412 100.316C35.4134 100.385 35.5229 100.386 35.5995 100.327L35.63 100.299C35.6959 100.223 35.6969 100.114 35.6409 100.034L35.614 100.002C35.2799 99.677 35.0087 99.2918 34.8158 98.8661C34.6221 98.4386 34.5109 97.9789 34.4876 97.5113L34.4833 97.3104C34.4852 96.841 34.576 96.3767 34.7496 95.9418L34.8289 95.7569C35.0007 95.386 35.2315 95.0462 35.5122 94.7514L35.6359 94.6284C35.7186 94.5492 35.7291 94.4185 35.6548 94.3315Z"
			fill="#58707F"
		/>
		<path
			d="M34.9668 94.3874C34.9668 94.0819 35.2144 93.8343 35.5199 93.8343C35.8253 93.8343 36.0729 94.0819 36.0729 94.3874C36.0729 94.6928 35.8253 94.9404 35.5199 94.9404C35.2144 94.9404 34.9668 94.6928 34.9668 94.3874Z"
			fill="#58707F"
		/>
		<path
			d="M36.0729 94.3873C36.0729 94.0819 35.8254 93.8343 35.5199 93.8343C35.2145 93.8343 34.967 94.0819 34.9669 94.3873C34.9669 94.6927 35.2145 94.9403 35.5199 94.9403C35.8254 94.9403 36.0729 94.6928 36.0729 94.3873ZM36.3494 94.3873C36.3494 94.8455 35.9781 95.2168 35.5199 95.2168C35.0618 95.2168 34.6904 94.8455 34.6904 94.3873C34.6905 93.9292 35.0618 93.5578 35.5199 93.5578C35.9781 93.5578 36.3494 93.9292 36.3494 94.3873Z"
			fill="#58707F"
		/>
		<path
			d="M39.7808 97.9687V98.2458H38.5543V98.0093L39.1343 97.3874C39.1926 97.3226 39.2386 97.2655 39.2722 97.2163C39.3059 97.1662 39.3301 97.1214 39.3449 97.082C39.3605 97.0418 39.3683 97.0036 39.3683 96.9675C39.3683 96.9133 39.3592 96.8669 39.3412 96.8283C39.3231 96.7889 39.2964 96.7586 39.2611 96.7372C39.2267 96.7159 39.184 96.7052 39.1331 96.7052C39.0789 96.7052 39.0321 96.7183 38.9927 96.7446C38.9541 96.7709 38.9245 96.8074 38.904 96.8542C38.8843 96.901 38.8745 96.954 38.8745 97.0131H38.5186C38.5186 96.9063 38.544 96.8086 38.5949 96.72C38.6458 96.6305 38.7176 96.5595 38.8104 96.5069C38.9032 96.4536 39.0132 96.4269 39.1404 96.4269C39.2661 96.4269 39.372 96.4474 39.4582 96.4885C39.5452 96.5287 39.6109 96.587 39.6552 96.6633C39.7004 96.7389 39.7229 96.8292 39.7229 96.9343C39.7229 96.9934 39.7135 97.0512 39.6946 97.1079C39.6757 97.1637 39.6486 97.2195 39.6133 97.2754C39.5789 97.3304 39.537 97.3862 39.4877 97.4429C39.4385 97.4995 39.3839 97.5582 39.3239 97.619L39.0124 97.9687H39.7808Z"
			fill="#58707F"
		/>
		<path
			d="M38.3613 97.5759V97.8542H37.0695L37.0522 97.6387L37.7998 96.4528H38.0818L37.7764 96.9638L37.4044 97.5759H38.3613ZM38.1581 96.4528V98.2458H37.8034V96.4528H38.1581Z"
			fill="#58707F"
		/>
		<path
			d="M36.5215 96.4489V98.2456H36.1668V96.8577L35.7407 96.9932V96.7137L36.4833 96.4489H36.5215Z"
			fill="#58707F"
		/>
		<path
			d="M54.0522 96.8072C54.0522 96.4574 54.3358 96.1738 54.6857 96.1738H66.9318C67.2816 96.1738 67.5652 96.4574 67.5652 96.8072C67.5652 97.157 67.2816 97.4406 66.9318 97.4406H54.6857C54.3358 97.4406 54.0522 97.157 54.0522 96.8072Z"
			fill="#58707F"
		/>
		<path
			d="M8.86816 104.936C8.86816 104.586 9.15176 104.303 9.50158 104.303H21.7477C22.0975 104.303 22.3811 104.586 22.3811 104.936C22.3811 105.286 22.0975 105.569 21.7477 105.569H9.50158C9.15176 105.569 8.86816 105.286 8.86816 104.936Z"
			fill="#58707F"
		/>
		<path
			d="M8.86816 107.681C8.86816 107.331 9.15176 107.047 9.50158 107.047H19.0029C19.3527 107.047 19.6363 107.331 19.6363 107.681C19.6363 108.031 19.3527 108.314 19.0029 108.314H9.50158C9.15175 108.314 8.86816 108.031 8.86816 107.681Z"
			fill="#58707F"
		/>
		<path
			d="M40.8042 109.799C40.8794 109.886 41.0109 109.895 41.0934 109.816C41.6497 109.28 42.0466 108.598 42.2371 107.847C42.4447 107.029 42.3976 106.167 42.1022 105.376C41.8067 104.585 41.2769 103.903 40.5836 103.421C39.8903 102.939 39.0664 102.68 38.2221 102.679C37.3778 102.678 36.5532 102.935 35.8586 103.415C35.164 103.894 34.6323 104.575 34.3347 105.365C34.037 106.155 33.9876 107.017 34.1929 107.836C34.3814 108.588 34.7764 109.271 35.3313 109.808C35.4136 109.887 35.545 109.878 35.6205 109.792C35.6959 109.706 35.6868 109.575 35.6049 109.495C35.1133 109.014 34.7632 108.405 34.5953 107.735C34.4105 106.998 34.455 106.222 34.7228 105.511C34.9907 104.8 35.4692 104.188 36.0944 103.756C36.7196 103.324 37.4617 103.093 38.2215 103.094C38.9814 103.095 39.7229 103.328 40.3469 103.762C40.9709 104.195 41.4477 104.809 41.7136 105.521C41.9795 106.233 42.0219 107.009 41.8351 107.745C41.6653 108.415 41.3135 109.022 40.8206 109.502C40.7385 109.582 40.729 109.713 40.8042 109.799Z"
			fill="white"
		/>
		<path
			d="M38.2225 102.403C39.123 102.404 40.002 102.68 40.7415 103.194C41.4811 103.708 42.0461 104.436 42.3613 105.279C42.6764 106.123 42.7267 107.042 42.5053 107.915C42.3021 108.717 41.8785 109.443 41.2851 110.015C41.0822 110.21 40.7691 110.179 40.596 109.981C40.4181 109.777 40.4479 109.48 40.628 109.304L40.7925 109.132C41.1627 108.718 41.4298 108.22 41.5674 107.677C41.7404 106.995 41.7008 106.277 41.4546 105.617C41.2084 104.959 40.7669 104.391 40.1893 103.989C39.6115 103.588 38.9246 103.372 38.221 103.371C37.5175 103.37 36.8301 103.583 36.2513 103.983C35.6725 104.383 35.2296 104.95 34.9816 105.609C34.7336 106.267 34.6926 106.986 34.8637 107.668C35.0192 108.288 35.3435 108.852 35.7987 109.298C35.9781 109.474 36.0069 109.771 35.8285 109.975C35.655 110.173 35.3412 110.203 35.1388 110.007C34.5469 109.434 34.1262 108.705 33.9251 107.904C33.706 107.03 33.7582 106.11 34.0757 105.268C34.3931 104.425 34.9604 103.699 35.7012 103.187C36.4422 102.675 37.3219 102.402 38.2225 102.403ZM38.2225 102.679C37.3782 102.678 36.553 102.935 35.8584 103.415L35.7303 103.507C35.0984 103.98 34.6138 104.624 34.3347 105.365L34.2816 105.514C34.0318 106.263 34.0004 107.068 34.1928 107.836C34.3813 108.588 34.7767 109.271 35.3316 109.808C35.4139 109.887 35.5451 109.878 35.6204 109.792C35.6865 109.716 35.6878 109.607 35.6321 109.527L35.6052 109.495C35.1751 109.074 34.8528 108.556 34.6665 107.984L34.5952 107.736C34.4104 106.999 34.4547 106.222 34.7225 105.511C34.9569 104.889 35.3531 104.343 35.8671 103.926L36.0941 103.756C36.7193 103.324 37.4619 103.093 38.2217 103.094L38.5055 103.105C39.165 103.156 39.8012 103.383 40.3472 103.762C40.971 104.196 41.4478 104.809 41.7137 105.521C41.9796 106.232 42.022 107.009 41.8352 107.745L41.7631 107.993C41.5753 108.565 41.2521 109.082 40.8209 109.502C40.7388 109.582 40.729 109.713 40.8041 109.799C40.8699 109.875 40.9788 109.892 41.0602 109.841L41.0937 109.815C41.6499 109.28 42.0463 108.598 42.2368 107.847C42.4314 107.08 42.4024 106.274 42.1546 105.525L42.1022 105.376C41.8252 104.634 41.3422 103.989 40.7117 103.514L40.5836 103.421C39.9337 102.969 39.169 102.713 38.3804 102.682L38.2225 102.679Z"
			fill="#58707F"
		/>
		<path
			d="M35.6545 103.833C35.5801 103.746 35.4487 103.736 35.3655 103.814C34.9837 104.176 34.6735 104.607 34.4522 105.085C34.2017 105.626 34.0708 106.214 34.0684 106.81C34.066 107.407 34.1921 107.996 34.4381 108.539C34.6555 109.019 34.9622 109.453 35.341 109.817C35.4236 109.897 35.555 109.887 35.6302 109.801C35.7054 109.714 35.6958 109.584 35.6137 109.504C35.2795 109.179 35.0088 108.794 34.8159 108.368C34.5945 107.879 34.481 107.349 34.4832 106.812C34.4854 106.276 34.6032 105.746 34.8286 105.259C35.0249 104.835 35.2988 104.452 35.6356 104.13C35.7184 104.051 35.729 103.92 35.6545 103.833Z"
			fill="#58707F"
		/>
		<path
			d="M35.2568 103.551C35.4277 103.448 35.6424 103.468 35.7945 103.586L35.8651 103.654L35.9211 103.734C36.0304 103.931 35.9861 104.177 35.8272 104.33C35.5154 104.628 35.2617 104.983 35.0799 105.375C34.8713 105.826 34.7618 106.316 34.7598 106.813C34.7578 107.31 34.8633 107.801 35.0683 108.254C35.2469 108.648 35.4975 109.004 35.8068 109.305C35.9871 109.48 36.0166 109.777 35.8389 109.982C35.6661 110.18 35.3529 110.212 35.1498 110.017C34.7457 109.628 34.4184 109.165 34.1864 108.653C33.924 108.074 33.7894 107.445 33.792 106.809C33.7946 106.173 33.9345 105.545 34.2017 104.968C34.4378 104.458 34.7688 103.999 35.176 103.614L35.2568 103.551ZM35.6548 103.833C35.5803 103.746 35.4491 103.736 35.3659 103.814C34.9841 104.176 34.6734 104.607 34.452 105.085L34.3639 105.29C34.1712 105.773 34.0707 106.289 34.0685 106.81C34.0661 107.406 34.1922 107.996 34.4382 108.539C34.6556 109.019 34.9623 109.453 35.3412 109.817C35.4134 109.887 35.5229 109.888 35.5995 109.829L35.63 109.801C35.6959 109.725 35.6969 109.616 35.6409 109.536L35.614 109.504C35.2799 109.179 35.0087 108.794 34.8158 108.368C34.6221 107.94 34.5109 107.481 34.4876 107.013L34.4833 106.812C34.4852 106.343 34.576 105.879 34.7496 105.444L34.8289 105.259C35.0007 104.888 35.2315 104.548 35.5122 104.253L35.6359 104.13C35.7186 104.051 35.7291 103.92 35.6548 103.833Z"
			fill="#58707F"
		/>
		<path
			d="M34.9668 103.889C34.9668 103.584 35.2144 103.336 35.5199 103.336C35.8253 103.336 36.0729 103.584 36.0729 103.889C36.0729 104.195 35.8253 104.442 35.5199 104.442C35.2144 104.442 34.9668 104.195 34.9668 103.889Z"
			fill="#58707F"
		/>
		<path
			d="M36.0729 103.889C36.0729 103.584 35.8254 103.336 35.5199 103.336C35.2145 103.336 34.967 103.584 34.9669 103.889C34.9669 104.195 35.2145 104.442 35.5199 104.442C35.8254 104.442 36.0729 104.195 36.0729 103.889ZM36.3494 103.889C36.3494 104.347 35.9781 104.719 35.5199 104.719C35.0618 104.719 34.6904 104.347 34.6904 103.889C34.6905 103.431 35.0618 103.06 35.5199 103.06C35.9781 103.06 36.3494 103.431 36.3494 103.889Z"
			fill="#58707F"
		/>
		<path
			d="M39.7808 107.47V107.747H38.5543V107.511L39.1343 106.889C39.1926 106.824 39.2386 106.767 39.2722 106.718C39.3059 106.668 39.3301 106.623 39.3449 106.584C39.3605 106.543 39.3683 106.505 39.3683 106.469C39.3683 106.415 39.3592 106.369 39.3412 106.33C39.3231 106.291 39.2964 106.26 39.2611 106.239C39.2267 106.218 39.184 106.207 39.1331 106.207C39.0789 106.207 39.0321 106.22 38.9927 106.246C38.9541 106.273 38.9245 106.309 38.904 106.356C38.8843 106.403 38.8745 106.456 38.8745 106.515H38.5186C38.5186 106.408 38.544 106.31 38.5949 106.222C38.6458 106.132 38.7176 106.061 38.8104 106.009C38.9032 105.955 39.0132 105.929 39.1404 105.929C39.2661 105.929 39.372 105.949 39.4582 105.99C39.5452 106.03 39.6109 106.089 39.6552 106.165C39.7004 106.241 39.7229 106.331 39.7229 106.436C39.7229 106.495 39.7135 106.553 39.6946 106.61C39.6757 106.665 39.6486 106.721 39.6133 106.777C39.5789 106.832 39.537 106.888 39.4877 106.945C39.4385 107.001 39.3839 107.06 39.3239 107.121L39.0124 107.47H39.7808Z"
			fill="#58707F"
		/>
		<path
			d="M38.3613 107.078V107.356H37.0695L37.0522 107.14L37.7998 105.954H38.0818L37.7764 106.466L37.4044 107.078H38.3613ZM38.1581 105.954V107.747H37.8034V105.954H38.1581Z"
			fill="#58707F"
		/>
		<path
			d="M36.5215 105.951V107.747H36.1668V106.359L35.7407 106.495V106.215L36.4833 105.951H36.5215Z"
			fill="#58707F"
		/>
		<path
			d="M54.0522 106.308C54.0522 105.959 54.3358 105.675 54.6857 105.675H66.9318C67.2816 105.675 67.5652 105.959 67.5652 106.308C67.5652 106.658 67.2816 106.942 66.9318 106.942H54.6857C54.3358 106.942 54.0522 106.658 54.0522 106.308Z"
			fill="#58707F"
		/>
		<path
			d="M8.86816 114.437C8.86816 114.088 9.15176 113.804 9.50158 113.804H21.7477C22.0975 113.804 22.3811 114.088 22.3811 114.437C22.3811 114.787 22.0975 115.071 21.7477 115.071H9.50158C9.15176 115.071 8.86816 114.787 8.86816 114.437Z"
			fill="#58707F"
		/>
		<path
			d="M8.86816 117.182C8.86816 116.832 9.15176 116.549 9.50158 116.549H19.8474C20.1973 116.549 20.4808 116.832 20.4808 117.182C20.4808 117.532 20.1973 117.816 19.8474 117.816H9.50158C9.15175 117.816 8.86816 117.532 8.86816 117.182Z"
			fill="#58707F"
		/>
		<path
			d="M40.8042 119.3C40.8794 119.387 41.0109 119.396 41.0934 119.317C41.6497 118.781 42.0466 118.1 42.2371 117.348C42.4447 116.53 42.3976 115.668 42.1022 114.877C41.8067 114.086 41.2769 113.404 40.5836 112.922C39.8903 112.44 39.0664 112.182 38.2221 112.181C37.3778 112.179 36.5532 112.436 35.8586 112.916C35.164 113.396 34.6323 114.076 34.3347 114.866C34.037 115.656 33.9876 116.518 34.1929 117.337C34.3814 118.089 34.7764 118.772 35.3313 119.309C35.4136 119.389 35.545 119.38 35.6205 119.293C35.6959 119.207 35.6868 119.077 35.6049 118.996C35.1133 118.515 34.7632 117.906 34.5953 117.237C34.4105 116.499 34.455 115.724 34.7228 115.012C34.9907 114.301 35.4692 113.689 36.0944 113.257C36.7196 112.825 37.4617 112.594 38.2215 112.595C38.9814 112.596 39.7229 112.829 40.3469 113.263C40.9709 113.697 41.4477 114.31 41.7136 115.022C41.9795 115.734 42.0219 116.51 41.8351 117.246C41.6653 117.916 41.3135 118.524 40.8206 119.004C40.7385 119.083 40.729 119.214 40.8042 119.3Z"
			fill="white"
		/>
		<path
			d="M38.2225 111.904C39.123 111.905 40.002 112.181 40.7415 112.695C41.4811 113.209 42.0461 113.937 42.3613 114.78C42.6764 115.624 42.7267 116.544 42.5053 117.417C42.3021 118.218 41.8785 118.944 41.2851 119.516C41.0822 119.711 40.7691 119.681 40.596 119.482C40.4181 119.278 40.4479 118.981 40.628 118.806L40.7925 118.633C41.1627 118.219 41.4298 117.721 41.5674 117.179C41.7404 116.497 41.7008 115.778 41.4546 115.119C41.2084 114.46 40.7669 113.892 40.1893 113.49C39.6115 113.089 38.9246 112.873 38.221 112.872C37.5175 112.871 36.8301 113.085 36.2513 113.484C35.6725 113.884 35.2296 114.452 34.9816 115.11C34.7336 115.768 34.6926 116.487 34.8637 117.169C35.0192 117.789 35.3435 118.354 35.7987 118.799C35.9781 118.975 36.0069 119.272 35.8285 119.476C35.655 119.674 35.3412 119.704 35.1388 119.508C34.5469 118.935 34.1262 118.207 33.9251 117.405C33.706 116.531 33.7582 115.611 34.0757 114.769C34.3931 113.926 34.9604 113.2 35.7012 112.688C36.4422 112.176 37.3219 111.903 38.2225 111.904ZM38.2225 112.18C37.3782 112.179 36.553 112.436 35.8584 112.916L35.7303 113.008C35.0984 113.481 34.6138 114.125 34.3347 114.866L34.2816 115.015C34.0318 115.764 34.0004 116.57 34.1928 117.337C34.3813 118.089 34.7767 118.772 35.3316 119.309C35.4139 119.389 35.5451 119.379 35.6204 119.293C35.6865 119.218 35.6878 119.108 35.6321 119.028L35.6052 118.996C35.1751 118.575 34.8528 118.057 34.6665 117.485L34.5952 117.237C34.4104 116.5 34.4547 115.724 34.7225 115.012C34.9569 114.39 35.3531 113.844 35.8671 113.428L36.0941 113.257C36.7193 112.825 37.4619 112.594 38.2217 112.595L38.5055 112.606C39.165 112.657 39.8012 112.884 40.3472 113.263C40.971 113.697 41.4478 114.31 41.7137 115.022C41.9796 115.734 42.022 116.51 41.8352 117.246L41.7631 117.494C41.5753 118.066 41.2521 118.584 40.8209 119.004C40.7388 119.083 40.729 119.214 40.8041 119.3C40.8699 119.376 40.9788 119.393 41.0602 119.343L41.0937 119.316C41.6499 118.781 42.0463 118.099 42.2368 117.348C42.4314 116.581 42.4024 115.776 42.1546 115.026L42.1022 114.877C41.8252 114.136 41.3422 113.49 40.7117 113.015L40.5836 112.922C39.9337 112.47 39.169 112.215 38.3804 112.183L38.2225 112.18Z"
			fill="#58707F"
		/>
		<path
			d="M35.6545 113.334C35.5801 113.247 35.4487 113.237 35.3655 113.315C34.9837 113.677 34.6735 114.108 34.4522 114.586C34.2017 115.127 34.0708 115.715 34.0684 116.312C34.066 116.908 34.1921 117.497 34.4381 118.04C34.6555 118.52 34.9622 118.954 35.341 119.318C35.4236 119.398 35.555 119.388 35.6302 119.302C35.7054 119.215 35.6958 119.085 35.6137 119.005C35.2795 118.68 35.0088 118.295 34.8159 117.869C34.5945 117.381 34.481 116.85 34.4832 116.313C34.4854 115.777 34.6032 115.247 34.8286 114.76C35.0249 114.336 35.2988 113.953 35.6356 113.631C35.7184 113.552 35.729 113.421 35.6545 113.334Z"
			fill="#58707F"
		/>
		<path
			d="M35.2568 113.052C35.4277 112.949 35.6424 112.969 35.7945 113.087L35.8651 113.155L35.9211 113.236C36.0304 113.433 35.9861 113.679 35.8272 113.831C35.5154 114.129 35.2617 114.484 35.0799 114.876C34.8713 115.327 34.7618 115.818 34.7598 116.314C34.7578 116.811 34.8633 117.302 35.0683 117.755C35.2469 118.149 35.4975 118.505 35.8068 118.806C35.9871 118.982 36.0166 119.279 35.8389 119.483C35.6661 119.682 35.3529 119.713 35.1498 119.518C34.7457 119.129 34.4184 118.666 34.1864 118.154C33.924 117.575 33.7894 116.946 33.792 116.311C33.7946 115.675 33.9345 115.047 34.2017 114.47C34.4378 113.96 34.7688 113.5 35.176 113.115L35.2568 113.052ZM35.6548 113.335C35.5803 113.248 35.4491 113.237 35.3659 113.316C34.9841 113.677 34.6734 114.108 34.452 114.586L34.3639 114.791C34.1712 115.274 34.0707 115.79 34.0685 116.311C34.0661 116.907 34.1922 117.497 34.4382 118.04C34.6556 118.52 34.9623 118.954 35.3412 119.319C35.4134 119.388 35.5229 119.389 35.5995 119.33L35.63 119.302C35.6959 119.226 35.6969 119.117 35.6409 119.037L35.614 119.005C35.2799 118.68 35.0087 118.295 34.8158 117.869C34.6221 117.442 34.5109 116.982 34.4876 116.514L34.4833 116.313C34.4852 115.844 34.576 115.38 34.7496 114.945L34.8289 114.76C35.0007 114.389 35.2315 114.049 35.5122 113.754L35.6359 113.631C35.7186 113.552 35.7291 113.422 35.6548 113.335Z"
			fill="#58707F"
		/>
		<path
			d="M34.9668 113.39C34.9668 113.085 35.2144 112.837 35.5199 112.837C35.8253 112.837 36.0729 113.085 36.0729 113.39C36.0729 113.696 35.8253 113.943 35.5199 113.943C35.2144 113.943 34.9668 113.696 34.9668 113.39Z"
			fill="#58707F"
		/>
		<path
			d="M36.0729 113.39C36.0729 113.085 35.8254 112.837 35.5199 112.837C35.2145 112.837 34.967 113.085 34.9669 113.39C34.9669 113.696 35.2145 113.943 35.5199 113.943C35.8254 113.943 36.0729 113.696 36.0729 113.39ZM36.3494 113.39C36.3494 113.849 35.9781 114.22 35.5199 114.22C35.0618 114.22 34.6904 113.849 34.6904 113.39C34.6905 112.932 35.0618 112.561 35.5199 112.561C35.9781 112.561 36.3494 112.932 36.3494 113.39Z"
			fill="#58707F"
		/>
		<path
			d="M39.7808 116.971V117.249H38.5543V117.012L39.1343 116.39C39.1926 116.325 39.2386 116.268 39.2722 116.219C39.3059 116.169 39.3301 116.124 39.3449 116.085C39.3605 116.045 39.3683 116.006 39.3683 115.97C39.3683 115.916 39.3592 115.87 39.3412 115.831C39.3231 115.792 39.2964 115.761 39.2611 115.74C39.2267 115.719 39.184 115.708 39.1331 115.708C39.0789 115.708 39.0321 115.721 38.9927 115.747C38.9541 115.774 38.9245 115.81 38.904 115.857C38.8843 115.904 38.8745 115.957 38.8745 116.016H38.5186C38.5186 115.909 38.544 115.811 38.5949 115.723C38.6458 115.633 38.7176 115.562 38.8104 115.51C38.9032 115.456 39.0132 115.43 39.1404 115.43C39.2661 115.43 39.372 115.45 39.4582 115.491C39.5452 115.531 39.6109 115.59 39.6552 115.666C39.7004 115.742 39.7229 115.832 39.7229 115.937C39.7229 115.996 39.7135 116.054 39.6946 116.111C39.6757 116.166 39.6486 116.222 39.6133 116.278C39.5789 116.333 39.537 116.389 39.4877 116.446C39.4385 116.502 39.3839 116.561 39.3239 116.622L39.0124 116.971H39.7808Z"
			fill="#58707F"
		/>
		<path
			d="M38.3618 116.579V116.857H37.07L37.0527 116.641L37.8002 115.455H38.0822L37.7768 115.967L37.4049 116.579H38.3618ZM38.1586 115.455V117.249H37.8039V115.455H38.1586Z"
			fill="#58707F"
		/>
		<path
			d="M36.522 115.452V117.248H36.1673V115.86L35.7412 115.996V115.716L36.4838 115.452H36.522Z"
			fill="#58707F"
		/>
		<path
			d="M54.0522 115.81C54.0522 115.46 54.3358 115.176 54.6857 115.176H66.9318C67.2816 115.176 67.5652 115.46 67.5652 115.81C67.5652 116.16 67.2816 116.443 66.9318 116.443H54.6857C54.3358 116.443 54.0522 116.16 54.0522 115.81Z"
			fill="#58707F"
		/>
		<defs>
			<clipPath
				id="bgblur_0_20430_28754_clip_path"
				transform="translate(-30.3572 -46.4187)"
			>
				<rect
					x={ 31.7294 }
					y={ 47.7911 }
					width={ 12.5526 }
					height={ 4.64507 }
					rx={ 0.738989 }
				/>
			</clipPath>
		</defs>
	</svg>
);

export const AqiMinimalThreeIcon = ( { isPopup = false } ) => (
	<svg
		width={ isPopup ? 102 : 76 }
		height={ isPopup ? 172 : 128 }
		viewBox="0 0 76 128"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x={ 0.558824 }
			y={ 0.558824 }
			width={ 74.8824 }
			height={ 126.882 }
			rx={ 1.67647 }
			fill="white"
		/>
		<rect
			x={ 0.558824 }
			y={ 0.558824 }
			width={ 74.8824 }
			height={ 126.882 }
			rx={ 1.67647 }
			stroke="#8796A1"
			strokeWidth={ 1.11765 }
		/>
		<path
			d="M4.43408 6.25545C4.43408 5.26013 4.43408 4.76247 4.74329 4.45327C5.0525 4.14406 5.55016 4.14406 6.54548 4.14406H69.4651C70.4604 4.14406 70.9581 4.14406 71.2673 4.45327C71.5765 4.76247 71.5765 5.26013 71.5765 6.25546V121.538C71.5765 122.533 71.5765 123.031 71.2673 123.34C70.9581 123.649 70.4604 123.649 69.4651 123.649H6.54548C5.55016 123.649 5.0525 123.649 4.74329 123.34C4.43408 123.031 4.43408 122.533 4.43408 121.538V6.25545Z"
			fill="white"
		/>
		<path
			d="M69.465 122.919V123.649H6.54568V122.919H69.465ZM70.846 121.538V6.25565C70.846 5.73763 70.8446 5.42222 70.814 5.19476C70.7999 5.08967 70.7825 5.0328 70.7704 5.00339C70.7607 4.97993 70.7545 4.97373 70.7507 4.96992C70.7469 4.96613 70.7408 4.95996 70.7172 4.95028C70.6879 4.93819 70.6311 4.92076 70.5259 4.90662C70.2984 4.87607 69.9831 4.8746 69.465 4.8746H6.54568C6.02764 4.8746 5.71225 4.87608 5.48479 4.90662C5.37965 4.92075 5.32282 4.93819 5.29342 4.95028C5.26986 4.95997 5.26375 4.96612 5.25995 4.96992C5.25615 4.97372 5.24999 4.97984 5.2403 5.00339C5.22821 5.03279 5.21078 5.08963 5.19664 5.19476C5.16611 5.42222 5.16463 5.73762 5.16463 6.25565V121.538C5.16463 122.056 5.16608 122.371 5.19664 122.599C5.21078 122.704 5.22821 122.761 5.2403 122.79C5.24995 122.813 5.25616 122.82 5.25995 122.823C5.26376 122.827 5.2701 122.834 5.29342 122.843C5.32284 122.855 5.37976 122.873 5.48479 122.887C5.71224 122.917 6.02766 122.919 6.54568 122.919V123.649L5.88717 123.644C5.36105 123.631 5.03327 123.581 4.80372 123.395L4.74333 123.34C4.5114 123.108 4.45366 122.77 4.43918 122.196L4.43408 121.538V6.25565C4.43408 5.3227 4.4341 4.8268 4.68875 4.5137L4.74333 4.4533C4.97519 4.22144 5.31299 4.16366 5.88717 4.14915L6.54568 4.14406H69.465C70.4603 4.14406 70.9581 4.1441 71.2673 4.4533C71.5765 4.76251 71.5766 5.26038 71.5766 6.25565V121.538L71.5715 122.196C71.557 122.77 71.4993 123.108 71.2673 123.34L71.2069 123.395C70.9773 123.581 70.6493 123.631 70.1228 123.644L69.465 123.649V122.919C69.9831 122.919 70.2984 122.917 70.5259 122.887C70.631 122.873 70.6879 122.855 70.7172 122.843C70.7407 122.833 70.7469 122.827 70.7507 122.823C70.7545 122.82 70.7607 122.813 70.7704 122.79C70.7825 122.761 70.7999 122.704 70.814 122.599C70.8446 122.371 70.846 122.056 70.846 121.538Z"
			fill="#58707F"
		/>
		<path
			d="M21.3247 9.69603C21.3247 8.88874 21.9791 8.2343 22.7864 8.2343H52.0212C52.8285 8.2343 53.4829 8.88874 53.4829 9.69603C53.4829 10.5033 52.8285 11.1578 52.0212 11.1578H22.7864C21.9791 11.1578 21.3247 10.5033 21.3247 9.69603Z"
			fill="#58707F"
		/>
		<path
			d="M24.6138 13.3504C24.6138 12.9467 24.941 12.6195 25.3446 12.6195H38.5003C38.9039 12.6195 39.2311 12.9467 39.2311 13.3504C39.2311 13.754 38.9039 14.0812 38.5003 14.0812H25.3446C24.941 14.0812 24.6138 13.754 24.6138 13.3504Z"
			fill="#58707F"
		/>
		<path
			d="M39.9619 13.3504C39.9619 12.9467 40.2891 12.6195 40.6928 12.6195H49.4632C49.8668 12.6195 50.1941 12.9467 50.1941 13.3504C50.1941 13.754 49.8668 14.0812 49.4632 14.0812H40.6928C40.2891 14.0812 39.9619 13.754 39.9619 13.3504Z"
			fill="#58707F"
		/>
		<rect
			x={ 9.07882 }
			y={ 40.4739 }
			width={ 27.6593 }
			height={ 10.557 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M10.979 45.7523C10.979 43.8866 12.4915 42.3741 14.3572 42.3741C16.223 42.3741 17.7355 43.8866 17.7355 45.7523C17.7355 47.6181 16.223 49.1306 14.3572 49.1306C12.4915 49.1306 10.979 47.6181 10.979 45.7523Z"
			fill="#58707F"
		/>
		<path
			d="M19.4248 44.0632C19.4248 43.7717 19.6611 43.5354 19.9527 43.5354H22.2752C22.5667 43.5354 22.803 43.7717 22.803 44.0632C22.803 44.3548 22.5667 44.5911 22.2752 44.5911H19.9527C19.6611 44.5911 19.4248 44.3548 19.4248 44.0632Z"
			fill="#58707F"
		/>
		<path
			d="M33.7822 44.0632C33.7822 43.7717 34.0186 43.5354 34.3101 43.5354C34.6016 43.5354 34.8379 43.7717 34.8379 44.0632C34.8379 44.3548 34.6016 44.5911 34.3101 44.5911C34.0186 44.5911 33.7822 44.3548 33.7822 44.0632Z"
			fill="#58707F"
		/>
		<path
			d="M19.4248 47.4415C19.4248 47.15 19.6611 46.9136 19.9527 46.9136H34.3102C34.6017 46.9136 34.838 47.15 34.838 47.4415C34.838 47.733 34.6017 47.9693 34.3102 47.9693H19.9527C19.6611 47.9693 19.4248 47.733 19.4248 47.4415Z"
			fill="#58707F"
		/>
		<rect
			x={ 39.694 }
			y={ 40.4739 }
			width={ 27.6593 }
			height={ 10.557 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M41.5942 45.7523C41.5942 43.8865 43.1067 42.3741 44.9725 42.3741C46.8382 42.3741 48.3507 43.8865 48.3507 45.7523C48.3507 47.618 46.8382 49.1305 44.9725 49.1305C43.1067 49.1305 41.5942 47.618 41.5942 45.7523Z"
			fill="#58707F"
		/>
		<path
			d="M50.04 44.0632C50.04 43.7717 50.2764 43.5354 50.5679 43.5354H52.8904C53.1819 43.5354 53.4183 43.7717 53.4183 44.0632C53.4183 44.3548 53.1819 44.5911 52.8904 44.5911H50.5679C50.2764 44.5911 50.04 44.3548 50.04 44.0632Z"
			fill="#58707F"
		/>
		<path
			d="M64.3975 44.0632C64.3975 43.7717 64.6338 43.5354 64.9253 43.5354C65.2168 43.5354 65.4532 43.7717 65.4532 44.0632C65.4532 44.3548 65.2168 44.5911 64.9253 44.5911C64.6338 44.5911 64.3975 44.3548 64.3975 44.0632Z"
			fill="#58707F"
		/>
		<path
			d="M50.04 47.4415C50.04 47.15 50.2764 46.9136 50.5679 46.9136H64.9254C65.2169 46.9136 65.4532 47.15 65.4532 47.4415C65.4532 47.733 65.2169 47.9693 64.9254 47.9693H50.5679C50.2764 47.9693 50.04 47.733 50.04 47.4415Z"
			fill="#58707F"
		/>
		<rect
			x={ 9.07882 }
			y={ 53.9868 }
			width={ 27.6593 }
			height={ 10.557 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M10.979 59.2653C10.979 57.3995 12.4915 55.8871 14.3572 55.8871C16.223 55.8871 17.7355 57.3995 17.7355 59.2653C17.7355 61.131 16.223 62.6435 14.3572 62.6435C12.4915 62.6435 10.979 61.131 10.979 59.2653Z"
			fill="#58707F"
		/>
		<path
			d="M19.4248 57.5762C19.4248 57.2847 19.6611 57.0483 19.9527 57.0483H22.2752C22.5667 57.0483 22.803 57.2847 22.803 57.5762C22.803 57.8677 22.5667 58.104 22.2752 58.104H19.9527C19.6611 58.104 19.4248 57.8677 19.4248 57.5762Z"
			fill="#58707F"
		/>
		<path
			d="M33.7822 57.5762C33.7822 57.2847 34.0186 57.0483 34.3101 57.0483C34.6016 57.0483 34.8379 57.2847 34.8379 57.5762C34.8379 57.8677 34.6016 58.104 34.3101 58.104C34.0186 58.104 33.7822 57.8677 33.7822 57.5762Z"
			fill="#58707F"
		/>
		<path
			d="M19.4248 60.9544C19.4248 60.6629 19.6611 60.4266 19.9527 60.4266H34.3102C34.6017 60.4266 34.838 60.6629 34.838 60.9544C34.838 61.2459 34.6017 61.4823 34.3102 61.4823H19.9527C19.6611 61.4823 19.4248 61.2459 19.4248 60.9544Z"
			fill="#58707F"
		/>
		<rect
			x={ 39.694 }
			y={ 53.9868 }
			width={ 27.6593 }
			height={ 10.557 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M41.5942 59.2654C41.5942 57.3997 43.1067 55.8872 44.9725 55.8872C46.8382 55.8872 48.3507 57.3997 48.3507 59.2654C48.3507 61.1312 46.8382 62.6436 44.9725 62.6436C43.1067 62.6436 41.5942 61.1312 41.5942 59.2654Z"
			fill="#58707F"
		/>
		<path
			d="M50.04 57.5762C50.04 57.2847 50.2764 57.0483 50.5679 57.0483H52.8904C53.1819 57.0483 53.4183 57.2847 53.4183 57.5762C53.4183 57.8677 53.1819 58.104 52.8904 58.104H50.5679C50.2764 58.104 50.04 57.8677 50.04 57.5762Z"
			fill="#58707F"
		/>
		<path
			d="M64.3975 57.5762C64.3975 57.2846 64.6338 57.0483 64.9253 57.0483C65.2168 57.0483 65.4532 57.2846 65.4532 57.5762C65.4532 57.8677 65.2168 58.104 64.9253 58.104C64.6338 58.104 64.3975 57.8677 64.3975 57.5762Z"
			fill="#58707F"
		/>
		<path
			d="M50.04 60.9544C50.04 60.6629 50.2764 60.4266 50.5679 60.4266H64.9254C65.2169 60.4266 65.4532 60.6629 65.4532 60.9544C65.4532 61.2459 65.2169 61.4823 64.9254 61.4823H50.5679C50.2764 61.4823 50.04 61.2459 50.04 60.9544Z"
			fill="#58707F"
		/>
		<rect
			x={ 9.07882 }
			y={ 67.4997 }
			width={ 27.6593 }
			height={ 10.557 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M10.979 72.7782C10.979 70.9125 12.4915 69.4 14.3572 69.4C16.223 69.4 17.7355 70.9125 17.7355 72.7782C17.7355 74.644 16.223 76.1565 14.3572 76.1565C12.4915 76.1565 10.979 74.644 10.979 72.7782Z"
			fill="#58707F"
		/>
		<path
			d="M19.4248 71.0891C19.4248 70.7976 19.6611 70.5613 19.9527 70.5613H22.2752C22.5667 70.5613 22.803 70.7976 22.803 71.0891C22.803 71.3807 22.5667 71.617 22.2752 71.617H19.9527C19.6611 71.617 19.4248 71.3807 19.4248 71.0891Z"
			fill="#58707F"
		/>
		<path
			d="M33.7822 71.0891C33.7822 70.7976 34.0186 70.5613 34.3101 70.5613C34.6016 70.5613 34.8379 70.7976 34.8379 71.0891C34.8379 71.3807 34.6016 71.617 34.3101 71.617C34.0186 71.617 33.7822 71.3807 33.7822 71.0891Z"
			fill="#58707F"
		/>
		<path
			d="M19.4248 74.4674C19.4248 74.1758 19.6611 73.9395 19.9527 73.9395H34.3102C34.6017 73.9395 34.838 74.1758 34.838 74.4674C34.838 74.7589 34.6017 74.9952 34.3102 74.9952H19.9527C19.6611 74.9952 19.4248 74.7589 19.4248 74.4674Z"
			fill="#58707F"
		/>
		<rect
			x={ 39.694 }
			y={ 67.4997 }
			width={ 27.6593 }
			height={ 10.557 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M41.5942 72.7781C41.5942 70.9124 43.1067 69.3999 44.9725 69.3999C46.8382 69.3999 48.3507 70.9124 48.3507 72.7781C48.3507 74.6439 46.8382 76.1563 44.9725 76.1563C43.1067 76.1563 41.5942 74.6439 41.5942 72.7781Z"
			fill="#58707F"
		/>
		<path
			d="M50.04 71.0891C50.04 70.7975 50.2764 70.5612 50.5679 70.5612H52.8904C53.1819 70.5612 53.4183 70.7975 53.4183 71.0891C53.4183 71.3806 53.1819 71.6169 52.8904 71.6169H50.5679C50.2764 71.6169 50.04 71.3806 50.04 71.0891Z"
			fill="#58707F"
		/>
		<path
			d="M64.3975 71.0891C64.3975 70.7975 64.6338 70.5612 64.9253 70.5612C65.2168 70.5612 65.4532 70.7975 65.4532 71.0891C65.4532 71.3806 65.2168 71.6169 64.9253 71.6169C64.6338 71.6169 64.3975 71.3806 64.3975 71.0891Z"
			fill="#58707F"
		/>
		<path
			d="M50.04 74.4673C50.04 74.1758 50.2764 73.9395 50.5679 73.9395H64.9254C65.2169 73.9395 65.4532 74.1758 65.4532 74.4673C65.4532 74.7588 65.2169 74.9952 64.9254 74.9952H50.5679C50.2764 74.9952 50.04 74.7588 50.04 74.4673Z"
			fill="#58707F"
		/>
		<foreignObject
			x={ 7.60035 }
			y={ 16.826 }
			width={ 20.4805 }
			height={ 20.4805 }
		>
			<div
				xmlns="http://www.w3.org/1999/xhtml"
				style={ {
					backdropFilter: 'blur(0.63px)',
					clipPath: 'url(#bgblur_0_20430_28755_clip_path)',
					height: '100%',
					width: '100%',
				} }
			/>
		</foreignObject>
		<path
			data-figma-bg-blur-radius={ 1.26684 }
			d="M26.8141 27.0663C26.8141 32.0221 22.7965 36.0397 17.8406 36.0397C12.8847 36.0397 8.86719 32.0221 8.86719 27.0663C8.86719 22.1104 12.8847 18.0928 17.8406 18.0928C22.7965 18.0928 26.8141 22.1104 26.8141 27.0663Z"
			fill="white"
			fillOpacity={ 0.1 }
		/>
		<foreignObject
			x={ 7.60035 }
			y={ 16.826 }
			width={ 20.4809 }
			height={ 20.4808 }
		>
			<div
				xmlns="http://www.w3.org/1999/xhtml"
				style={ {
					backdropFilter: 'blur(0.63px)',
					clipPath: 'url(#bgblur_1_20430_28755_clip_path)',
					height: '100%',
					width: '100%',
				} }
			/>
		</foreignObject>
		<path
			data-figma-bg-blur-radius={ 1.26684 }
			d="M25.1247 27.066C25.1246 23.0431 21.8633 19.7817 17.8404 19.7817C13.8176 19.7818 10.5562 23.0432 10.556 27.066C10.556 31.0889 13.8175 34.3502 17.8404 34.3504V36.0399L17.609 36.037C12.7601 35.9142 8.86719 31.9445 8.86719 27.066C8.86732 22.1103 12.8847 18.093 17.8404 18.0928C22.7962 18.0928 26.8142 22.1102 26.8143 27.066L26.8114 27.2981C26.6884 32.1469 22.7188 36.0399 17.8404 36.0399V34.3504C21.8634 34.3504 25.1247 31.089 25.1247 27.066Z"
			fill="#D6E4ED"
		/>
		<path
			d="M13.0321 19.4894C13.4259 19.2395 13.9478 19.3561 14.1977 19.7499C14.4477 20.1438 14.3311 20.6657 13.9372 20.9156C12.6055 21.7608 11.5843 23.0157 11.0267 24.4912C10.4692 25.9667 10.4055 27.5832 10.8455 29.0979C11.2856 30.6126 12.2058 31.9439 13.4672 32.891C14.7285 33.838 16.263 34.3499 17.8403 34.3499C18.3067 34.3499 18.6851 34.7283 18.6851 35.1947C18.6851 35.632 18.3527 35.9919 17.9269 36.0351L17.8403 36.0395L17.4772 36.0322C15.6625 35.9587 13.9098 35.3354 12.4529 34.2415C10.899 33.0748 9.76577 31.4354 9.22363 29.5694C8.68149 27.7033 8.75941 25.7116 9.44628 23.8938C10.1331 22.0762 11.3915 20.5306 13.0321 19.4894Z"
			fill="#58707F"
		/>
		<path
			d="M21.9406 28.405V28.9196H19.501V28.4792L20.6713 27.2148C20.7934 27.0763 20.8899 26.9558 20.9608 26.8536C21.0317 26.7513 21.082 26.6589 21.1117 26.5765C21.1431 26.4923 21.1587 26.4123 21.1587 26.3364C21.1587 26.2259 21.1389 26.1294 21.0993 26.047C21.0598 25.9628 21.002 25.8977 20.9261 25.8515C20.8519 25.8053 20.7604 25.7822 20.6515 25.7822C20.5311 25.7822 20.428 25.8102 20.3422 25.8663C20.2581 25.9208 20.1938 25.9966 20.1492 26.094C20.1063 26.1913 20.0849 26.3026 20.0849 26.428H19.4292C19.4292 26.2152 19.4787 26.0214 19.5777 25.8465C19.6766 25.67 19.8185 25.529 20.0032 25.4234C20.188 25.3179 20.4074 25.2651 20.6614 25.2651C20.9088 25.2651 21.1183 25.3063 21.2899 25.3888C21.4614 25.4696 21.5917 25.5851 21.6808 25.7352C21.7699 25.8853 21.8144 26.0643 21.8144 26.2721C21.8144 26.3876 21.7954 26.5014 21.7575 26.6136C21.7196 26.7257 21.666 26.8371 21.5967 26.9476C21.529 27.0565 21.4482 27.167 21.3542 27.2792C21.2602 27.3913 21.1554 27.506 21.04 27.6231L20.3373 28.405H21.9406Z"
			fill="#58707F"
		/>
		<path
			d="M19.1076 27.6056V28.1202H16.5121L16.4849 27.7244L18.0115 25.3169H18.5336L17.9694 26.2744L17.1504 27.6056H19.1076ZM18.6796 25.3169V28.9194H18.0239V25.3169H18.6796Z"
			fill="#58707F"
		/>
		<path
			d="M15.3938 25.3069V28.9194H14.7381V26.0715L13.8696 26.3585V25.829L15.3196 25.3069H15.3938Z"
			fill="#58707F"
		/>
		<path
			d="M29.5596 23.0546C29.5596 23.0222 29.5596 23.0061 29.5599 22.9924C29.5745 22.45 30.0107 22.0138 30.553 21.9993C30.5667 21.9989 30.5829 21.9989 30.6153 21.9989H44.5505C44.5829 21.9989 44.599 21.9989 44.6127 21.9993C45.1551 22.0138 45.5913 22.45 45.6058 22.9924C45.6062 23.0061 45.6062 23.0222 45.6062 23.0546C45.6062 23.087 45.6062 23.1032 45.6058 23.1169C45.5913 23.6592 45.1551 24.0954 44.6127 24.1099C44.599 24.1103 44.5829 24.1103 44.5505 24.1103H30.6153C30.5829 24.1103 30.5667 24.1103 30.553 24.1099C30.0107 24.0954 29.5745 23.6592 29.5599 23.1169C29.5596 23.1032 29.5596 23.087 29.5596 23.0546Z"
			fill="#58707F"
		/>
		<foreignObject
			x={ 46.0115 }
			y={ 19.3597 }
			width={ 15.2973 }
			height={ 7.38988 }
		>
			<div
				xmlns="http://www.w3.org/1999/xhtml"
				style={ {
					backdropFilter: 'blur(0.63px)',
					clipPath: 'url(#bgblur_2_20430_28755_clip_path)',
					height: '100%',
					width: '100%',
				} }
			/>
		</foreignObject>
		<g data-figma-bg-blur-radius={ 1.26684 }>
			<rect
				x={ 47.3837 }
				y={ 20.7321 }
				width={ 12.5526 }
				height={ 4.64507 }
				rx={ 0.738989 }
				fill="#D6E4ED"
			/>
			<rect
				x={ 47.3837 }
				y={ 20.7321 }
				width={ 12.5526 }
				height={ 4.64507 }
				rx={ 0.738989 }
				stroke="#58707F"
				strokeWidth={ 0.21114 }
			/>
			<path
				d="M56.009 22.8428V24.0169H55.686V22.5667H55.9943L56.009 22.8428ZM56.4527 22.5573L56.45 22.8576C56.4303 22.854 56.4089 22.8513 56.3856 22.8495C56.3633 22.8477 56.341 22.8468 56.3186 22.8468C56.2632 22.8468 56.2145 22.8549 56.1725 22.871C56.1305 22.8861 56.0953 22.9085 56.0667 22.938C56.039 22.9666 56.0175 23.0014 56.0023 23.0425C55.9871 23.0836 55.9782 23.1296 55.9755 23.1806L55.9018 23.1859C55.9018 23.0948 55.9107 23.0103 55.9286 22.9326C55.9465 22.8549 55.9733 22.7865 56.009 22.7276C56.0457 22.6686 56.0912 22.6226 56.1457 22.5895C56.2011 22.5564 56.265 22.5399 56.3374 22.5399C56.357 22.5399 56.378 22.5417 56.4004 22.5453C56.4236 22.5489 56.441 22.5529 56.4527 22.5573Z"
				fill="#58707F"
			/>
			<path
				d="M54.0649 23.3079V23.2771C54.0649 23.1725 54.0801 23.0756 54.1105 22.9862C54.1409 22.896 54.1847 22.8178 54.2419 22.7517C54.2999 22.6847 54.3705 22.6328 54.4536 22.5962C54.5376 22.5587 54.6323 22.5399 54.7377 22.5399C54.8441 22.5399 54.9388 22.5587 55.0219 22.5962C55.1059 22.6328 55.1769 22.6847 55.235 22.7517C55.293 22.8178 55.3373 22.896 55.3677 22.9862C55.398 23.0756 55.4132 23.1725 55.4132 23.2771V23.3079C55.4132 23.4124 55.398 23.5094 55.3677 23.5987C55.3373 23.6881 55.293 23.7662 55.235 23.8333C55.1769 23.8994 55.1063 23.9512 55.0232 23.9887C54.9401 24.0254 54.8459 24.0437 54.7404 24.0437C54.6341 24.0437 54.5389 24.0254 54.455 23.9887C54.3719 23.9512 54.3013 23.8994 54.2432 23.8333C54.1851 23.7662 54.1409 23.6881 54.1105 23.5987C54.0801 23.5094 54.0649 23.4124 54.0649 23.3079ZM54.3879 23.2771V23.3079C54.3879 23.3731 54.3946 23.4348 54.408 23.4928C54.4214 23.5509 54.4424 23.6018 54.471 23.6456C54.4996 23.6894 54.5363 23.7238 54.5809 23.7488C54.6256 23.7738 54.6788 23.7863 54.7404 23.7863C54.8003 23.7863 54.8521 23.7738 54.8959 23.7488C54.9406 23.7238 54.9772 23.6894 55.0058 23.6456C55.0344 23.6018 55.0554 23.5509 55.0688 23.4928C55.0831 23.4348 55.0902 23.3731 55.0902 23.3079V23.2771C55.0902 23.2127 55.0831 23.152 55.0688 23.0948C55.0554 23.0367 55.0339 22.9853 55.0045 22.9406C54.9759 22.896 54.9392 22.8611 54.8946 22.8361C54.8508 22.8102 54.7985 22.7972 54.7377 22.7972C54.677 22.7972 54.6243 22.8102 54.5796 22.8361C54.5358 22.8611 54.4996 22.896 54.471 22.9406C54.4424 22.9853 54.4214 23.0367 54.408 23.0948C54.3946 23.152 54.3879 23.2127 54.3879 23.2771Z"
				fill="#58707F"
			/>
			<path
				d="M52.5083 23.3079V23.2771C52.5083 23.1725 52.5235 23.0756 52.5539 22.9862C52.5842 22.896 52.628 22.8178 52.6852 22.7517C52.7433 22.6847 52.8139 22.6328 52.897 22.5962C52.981 22.5587 53.0757 22.5399 53.1811 22.5399C53.2874 22.5399 53.3821 22.5587 53.4652 22.5962C53.5492 22.6328 53.6203 22.6847 53.6783 22.7517C53.7364 22.8178 53.7806 22.896 53.811 22.9862C53.8414 23.0756 53.8566 23.1725 53.8566 23.2771V23.3079C53.8566 23.4124 53.8414 23.5094 53.811 23.5987C53.7806 23.6881 53.7364 23.7662 53.6783 23.8333C53.6203 23.8994 53.5497 23.9512 53.4666 23.9887C53.3835 24.0254 53.2892 24.0437 53.1838 24.0437C53.0775 24.0437 52.9823 24.0254 52.8983 23.9887C52.8152 23.9512 52.7446 23.8994 52.6866 23.8333C52.6285 23.7662 52.5842 23.6881 52.5539 23.5987C52.5235 23.5094 52.5083 23.4124 52.5083 23.3079ZM52.8313 23.2771V23.3079C52.8313 23.3731 52.838 23.4348 52.8514 23.4928C52.8648 23.5509 52.8858 23.6018 52.9144 23.6456C52.943 23.6894 52.9796 23.7238 53.0243 23.7488C53.069 23.7738 53.1221 23.7863 53.1838 23.7863C53.2436 23.7863 53.2955 23.7738 53.3393 23.7488C53.3839 23.7238 53.4206 23.6894 53.4492 23.6456C53.4777 23.6018 53.4987 23.5509 53.5121 23.4928C53.5264 23.4348 53.5336 23.3731 53.5336 23.3079V23.2771C53.5336 23.2127 53.5264 23.152 53.5121 23.0948C53.4987 23.0367 53.4773 22.9853 53.4478 22.9406C53.4192 22.896 53.3826 22.8611 53.3379 22.8361C53.2941 22.8102 53.2419 22.7972 53.1811 22.7972C53.1203 22.7972 53.0676 22.8102 53.023 22.8361C52.9792 22.8611 52.943 22.896 52.9144 22.9406C52.8858 22.9853 52.8648 23.0367 52.8514 23.0948C52.838 23.152 52.8313 23.2127 52.8313 23.2771Z"
				fill="#58707F"
			/>
			<path
				d="M51.6088 23.2893H51.1009V23.0226H51.6088C51.6973 23.0226 51.7688 23.0083 51.8233 22.9797C51.8778 22.9511 51.9175 22.9118 51.9425 22.8617C51.9685 22.8108 51.9814 22.7527 51.9814 22.6875C51.9814 22.6258 51.9685 22.5682 51.9425 22.5146C51.9175 22.4601 51.8778 22.4163 51.8233 22.3833C51.7688 22.3502 51.6973 22.3337 51.6088 22.3337H51.2041V24.017H50.8677V22.0656H51.6088C51.7598 22.0656 51.888 22.0924 51.9935 22.146C52.0998 22.1988 52.1807 22.272 52.2361 22.3658C52.2915 22.4588 52.3192 22.5651 52.3192 22.6848C52.3192 22.8108 52.2915 22.9189 52.2361 23.0092C52.1807 23.0994 52.0998 23.1686 51.9935 23.2169C51.888 23.2651 51.7598 23.2893 51.6088 23.2893Z"
				fill="#58707F"
			/>
		</g>
		<path
			d="M29.5596 29.6001C29.5596 29.3086 29.7959 29.0723 30.0874 29.0723H67.0369C67.3284 29.0723 67.5647 29.3086 67.5647 29.6001C67.5647 29.8917 67.3284 30.128 67.0369 30.128H30.0874C29.7959 30.128 29.5596 29.8917 29.5596 29.6001Z"
			fill="#58707F"
		/>
		<path
			d="M29.5596 32.7672C29.5596 32.4757 29.7959 32.2394 30.0874 32.2394H57.5356C57.8271 32.2394 58.0634 32.4757 58.0634 32.7672C58.0634 33.0588 57.8271 33.2951 57.5356 33.2951H30.0874C29.7959 33.2951 29.5596 33.0588 29.5596 32.7672Z"
			fill="#58707F"
		/>
		<path
			d="M8.86768 83.5464C8.86768 83.5464 8.86768 83.5464 8.86768 83.5464C8.86768 82.9633 9.34033 82.4907 9.92337 82.4907C9.92337 82.4907 9.92337 82.4907 9.92337 82.4907H27.8702C27.8702 82.4907 27.8702 82.4907 27.8702 82.4907C28.4533 82.4907 28.9259 82.9633 28.9259 83.5464C28.9259 83.5464 28.9259 83.5464 28.9259 83.5464C28.9259 83.5464 28.9259 83.5464 28.9259 83.5464C28.9259 84.1294 28.4533 84.6021 27.8702 84.6021H9.92337C9.92337 84.6021 9.92337 84.6021 9.92337 84.6021C9.34033 84.6021 8.86768 84.1294 8.86768 83.5464C8.86768 83.5464 8.86768 83.5464 8.86768 83.5464Z"
			fill="#58707F"
		/>
		<path
			d="M59.5415 83.5464C59.5415 83.5464 59.5415 83.5464 59.5415 83.5464C59.5415 82.9633 60.0142 82.4907 60.5972 82.4907C60.5972 82.4907 60.5972 82.4907 60.5972 82.4907H66.5091C66.5091 82.4907 66.5091 82.4907 66.5091 82.4907C67.0922 82.4907 67.5648 82.9633 67.5648 83.5464C67.5648 83.5464 67.5648 83.5464 67.5648 83.5464C67.5648 83.5464 67.5648 83.5464 67.5648 83.5464C67.5648 84.1294 67.0922 84.6021 66.5091 84.6021H66.5091H60.5972C60.5972 84.6021 60.5972 84.6021 60.5972 84.6021C60.0142 84.6021 59.5415 84.1294 59.5415 83.5464C59.5415 83.5464 59.5415 83.5464 59.5415 83.5464Z"
			fill="#58707F"
		/>
		<path
			d="M49.8286 83.5464C49.8286 83.5464 49.8286 83.5464 49.8286 83.5464C49.8286 82.9633 50.3013 82.4907 50.8843 82.4907C50.8843 82.4907 50.8843 82.4907 50.8843 82.4907H56.7962C56.7962 82.4907 56.7962 82.4907 56.7962 82.4907C57.3793 82.4907 57.8519 82.9633 57.8519 83.5464C57.8519 83.5464 57.8519 83.5464 57.8519 83.5464C57.8519 83.5464 57.8519 83.5464 57.8519 83.5464C57.8519 84.1294 57.3793 84.6021 56.7962 84.6021H56.7962H50.8843C50.8843 84.6021 50.8843 84.6021 50.8843 84.6021C50.3013 84.6021 49.8286 84.1294 49.8286 83.5464C49.8286 83.5464 49.8286 83.5464 49.8286 83.5464Z"
			fill="#58707F"
		/>
		<g clipPath="url(#clip3_20430_28755)">
			<g clipPath="url(#clip4_20430_28755)">
				<path
					d="M10.979 94.4199C10.979 94.1867 11.1681 93.9976 11.4013 93.9976C11.6345 93.9976 11.8236 94.1867 11.8236 94.4199V97.7981C11.8236 98.0314 11.6345 98.2204 11.4013 98.2204C11.1681 98.2204 10.979 98.0314 10.979 97.7981V94.4199Z"
					fill="#58707F"
				/>
				<path
					d="M15.0962 96.2145H12.9846V96.0035H15.0962V96.2145Z"
					fill="#58707F"
				/>
				<path
					d="M10.979 100.543C10.979 100.31 11.1681 100.121 11.4013 100.121C11.6345 100.121 11.8236 100.31 11.8236 100.543V103.077C11.8236 103.31 11.6345 103.499 11.4013 103.499C11.1681 103.499 10.979 103.31 10.979 103.077V100.543Z"
					fill="#58707F"
				/>
				<path
					d="M15.0962 101.915H12.9846V101.704H15.0962V101.915Z"
					fill="#58707F"
				/>
				<path
					d="M10.979 106.666C10.979 106.433 11.1681 106.244 11.4013 106.244C11.6345 106.244 11.8236 106.433 11.8236 106.666V109.622C11.8236 109.855 11.6345 110.044 11.4013 110.044C11.1681 110.044 10.979 109.855 10.979 109.622V106.666Z"
					fill="#58707F"
				/>
				<path
					d="M15.0962 108.249H12.9846V108.038H15.0962V108.249Z"
					fill="#58707F"
				/>
				<path
					d="M10.979 111.944C10.979 111.711 11.1681 111.522 11.4013 111.522C11.6345 111.522 11.8236 111.711 11.8236 111.944V114.267C11.8236 114.5 11.6345 114.689 11.4013 114.689C11.1681 114.689 10.979 114.5 10.979 114.267V111.944Z"
					fill="#58707F"
				/>
				<path
					d="M15.0962 113.211H12.9846V113H15.0962V113.211Z"
					fill="#58707F"
				/>
			</g>
			<path
				d="M15.2017 90.6198L15.4127 90.6198L15.4127 113L15.2017 113L15.2017 90.6198Z"
				fill="#58707F"
			/>
			<path
				d="M17.1021 95.4758C17.1021 95.0094 17.4802 94.6313 17.9466 94.6313H19.4246C19.891 94.6313 20.2691 95.0094 20.2691 95.4758V113.212H17.1021V95.4758Z"
				fill="#58707F"
			/>
			<path
				d="M23.376 98.643C23.376 98.1765 23.7541 97.7984 24.2205 97.7984H25.6985C26.1649 97.7984 26.5431 98.1765 26.5431 98.643V113.212H23.376V98.643Z"
				fill="#58707F"
			/>
			<path
				d="M29.6499 94.8424C29.6499 94.376 30.028 93.9979 30.4945 93.9979H31.9724C32.4389 93.9979 32.817 94.376 32.817 94.8424V113.212H29.6499V94.8424Z"
				fill="#58707F"
			/>
			<path
				d="M35.9238 104.344C35.9238 103.877 36.3019 103.499 36.7684 103.499H38.2464C38.7128 103.499 39.0909 103.877 39.0909 104.344V113.212H35.9238V104.344Z"
				fill="#58707F"
			/>
			<path
				d="M42.1973 95.4758C42.1973 95.0094 42.5754 94.6313 43.0418 94.6313H44.5198C44.9862 94.6313 45.3644 95.0094 45.3644 95.4758V113.212H42.1973V95.4758Z"
				fill="#58707F"
			/>
			<path
				d="M48.4712 96.9538C48.4712 96.4874 48.8493 96.1093 49.3158 96.1093H50.7937C51.2602 96.1093 51.6383 96.4874 51.6383 96.9538V113.212H48.4712V96.9538Z"
				fill="#58707F"
			/>
			<path
				d="M54.7451 96.9538C54.7451 96.4874 55.1232 96.1093 55.5897 96.1093H57.0677C57.5341 96.1093 57.9122 96.4874 57.9122 96.9538V113.212H54.7451V96.9538Z"
				fill="#58707F"
			/>
			<path
				d="M61.019 96.1093C61.019 95.6428 61.3972 95.2647 61.8636 95.2647H63.3416C63.808 95.2647 64.1861 95.6428 64.1861 96.1093V113.212H61.019V96.1093Z"
				fill="#58707F"
			/>
			<path
				opacity={ 0.5 }
				d="M49.8281 88.7196C49.8281 88.7779 49.7809 88.8258 49.7226 88.8258C49.6643 88.8258 49.6171 88.7779 49.6171 88.7196L49.6171 88.2976C49.6171 88.2393 49.6644 88.1921 49.7226 88.1921C49.7809 88.1921 49.8281 88.2393 49.8281 88.2976L49.8281 88.7196ZM49.8281 90.1982C49.828 90.2564 49.7808 90.3037 49.7226 90.3037C49.6644 90.3036 49.6173 90.2563 49.6171 90.1982L49.6171 89.3534C49.6171 89.2951 49.6643 89.2479 49.7226 89.2479C49.7809 89.2479 49.8281 89.2951 49.8281 89.3534L49.8281 90.1982ZM49.8281 91.676C49.8281 91.7342 49.7809 91.7815 49.7226 91.7815C49.6644 91.7815 49.6172 91.7342 49.6171 91.676L49.6171 90.8312C49.6172 90.773 49.6644 90.7257 49.7226 90.7257C49.7809 90.7257 49.8281 90.773 49.8281 90.8312L49.8281 91.676ZM49.8281 93.1538C49.8281 93.2121 49.7809 93.2593 49.7226 93.2593C49.6643 93.2593 49.6171 93.2121 49.6171 93.1538L49.6171 92.309C49.6173 92.2509 49.6644 92.2036 49.7226 92.2035C49.7808 92.2035 49.828 92.2509 49.8281 92.309L49.8281 93.1538ZM49.8281 94.6316C49.8281 94.69 49.7809 94.7372 49.7226 94.7372C49.6643 94.7371 49.6171 94.6899 49.6171 94.6316L49.6171 93.7876C49.6171 93.7293 49.6643 93.6814 49.7226 93.6814C49.7809 93.6814 49.8281 93.7293 49.8281 93.7876L49.8281 94.6316ZM49.8281 96.1095C49.8281 96.1678 49.7809 96.2157 49.7226 96.2157C49.6643 96.2157 49.6171 96.1678 49.6171 96.1095L49.6171 95.2654C49.6171 95.2071 49.6643 95.1599 49.7226 95.1599C49.7809 95.1599 49.8281 95.2071 49.8281 95.2654L49.8281 96.1095ZM49.8281 97.588L49.8201 97.6288C49.8041 97.6667 49.7664 97.6935 49.7226 97.6935C49.6788 97.6935 49.6411 97.6668 49.6251 97.6288L49.6171 97.588L49.6171 96.7432C49.6171 96.685 49.6643 96.6378 49.7226 96.6377C49.7809 96.6377 49.8281 96.6849 49.8281 96.7432L49.8281 97.588ZM49.8281 99.0659L49.8201 99.1066C49.8042 99.1446 49.7665 99.1714 49.7226 99.1714C49.6788 99.1713 49.6411 99.1446 49.6251 99.1066L49.6171 99.0659L49.6171 98.2211C49.6172 98.1629 49.6644 98.1156 49.7226 98.1156C49.7809 98.1156 49.828 98.1628 49.8281 98.2211L49.8281 99.0659ZM49.8281 100.544C49.8281 100.602 49.7809 100.649 49.7226 100.649C49.6643 100.649 49.6171 100.602 49.6171 100.544L49.6171 99.6989C49.6173 99.6407 49.6644 99.5934 49.7226 99.5934C49.7808 99.5934 49.828 99.6407 49.8281 99.6989L49.8281 100.544ZM49.8281 102.022C49.8281 102.08 49.7809 102.127 49.7226 102.127C49.6643 102.127 49.6171 102.08 49.6171 102.022L49.6171 101.177C49.6171 101.119 49.6643 101.072 49.7226 101.072C49.7809 101.072 49.8281 101.119 49.8281 101.177L49.8281 102.022ZM49.8281 103.5C49.8279 103.558 49.7808 103.606 49.7226 103.606C49.6645 103.606 49.6173 103.558 49.6171 103.5L49.6171 102.655C49.6171 102.597 49.6643 102.55 49.7226 102.55C49.7809 102.55 49.8281 102.597 49.8281 102.655L49.8281 103.5ZM49.8281 104.978C49.828 105.036 49.7809 105.083 49.7226 105.083C49.6644 105.083 49.6172 105.036 49.6171 104.978L49.6171 104.133C49.6171 104.075 49.6643 104.028 49.7226 104.028C49.7809 104.028 49.8281 104.075 49.8281 104.133L49.8281 104.978ZM49.8281 106.456C49.8281 106.514 49.7809 106.561 49.7226 106.561C49.6644 106.561 49.6171 106.514 49.6171 106.456L49.6171 105.611C49.6172 105.553 49.6644 105.505 49.7226 105.505C49.7809 105.505 49.828 105.553 49.8281 105.611L49.8281 106.456ZM49.8281 107.934C49.8281 107.992 49.7809 108.039 49.7226 108.039C49.6643 108.039 49.6171 107.992 49.6171 107.934L49.6171 107.089C49.6173 107.031 49.6644 106.983 49.7226 106.983C49.7808 106.983 49.828 107.031 49.8281 107.089L49.8281 107.934ZM49.8281 109.411C49.8281 109.47 49.7809 109.517 49.7226 109.517C49.6643 109.517 49.6171 109.47 49.6171 109.411L49.6171 108.567C49.6171 108.509 49.6643 108.462 49.7226 108.462C49.7809 108.462 49.8281 108.509 49.8281 108.567L49.8281 109.411ZM49.8281 110.89L49.8201 110.931C49.8041 110.969 49.7664 110.995 49.7226 110.995C49.6789 110.995 49.6411 110.969 49.6251 110.931L49.6171 110.89L49.6171 110.045C49.6171 109.987 49.6643 109.94 49.7226 109.94C49.7809 109.94 49.8281 109.987 49.8281 110.045L49.8281 110.89ZM49.8281 112.368L49.8201 112.408C49.8041 112.446 49.7664 112.473 49.7226 112.473C49.6788 112.473 49.6411 112.446 49.6251 112.408L49.6171 112.368L49.6171 111.523C49.6171 111.465 49.6644 111.417 49.7226 111.417C49.7809 111.417 49.8281 111.465 49.8281 111.523L49.8281 112.368ZM49.8281 113.846L49.8201 113.886C49.8042 113.924 49.7665 113.951 49.7226 113.951C49.6788 113.951 49.641 113.924 49.6251 113.886L49.6171 113.846L49.6171 113.001C49.6172 112.943 49.6644 112.895 49.7226 112.895C49.7809 112.895 49.828 112.943 49.8281 113.001L49.8281 113.846ZM49.8281 115.323C49.8281 115.382 49.7809 115.429 49.7226 115.429C49.6643 115.429 49.6171 115.382 49.6171 115.323L49.6171 114.479C49.6173 114.42 49.6645 114.373 49.7226 114.373C49.7808 114.373 49.8279 114.42 49.8281 114.479L49.8281 115.323ZM49.8281 116.379C49.8281 116.438 49.7809 116.485 49.7226 116.485C49.6643 116.485 49.6171 116.437 49.6171 116.379L49.6171 115.957C49.6171 115.899 49.6643 115.852 49.7226 115.852C49.7809 115.852 49.8281 115.899 49.8281 115.957L49.8281 116.379Z"
				fill="white"
			/>
			<rect
				x={ 41.6936 }
				y={ 93.5701 }
				width={ 11.8238 }
				height={ 7.38989 }
				rx={ 0.422279 }
				fill="#D6E4ED"
			/>
			<rect
				x={ 41.6936 }
				y={ 93.5701 }
				width={ 11.8238 }
				height={ 7.38989 }
				rx={ 0.422279 }
				stroke="#58707F"
				strokeWidth={ 0.422279 }
			/>
			<path
				d="M43.5938 95.9982C43.5938 95.7067 43.8301 95.4704 44.1216 95.4704H47.9221C48.2136 95.4704 48.45 95.7067 48.45 95.9982C48.45 96.2898 48.2136 96.5261 47.9221 96.5261H44.1216C43.8301 96.5261 43.5938 96.2898 43.5938 95.9982Z"
				fill="#58707F"
			/>
			<path
				d="M43.5938 98.5319C43.5938 98.2404 43.8301 98.0041 44.1216 98.0041H51.0892C51.3807 98.0041 51.6171 98.2404 51.6171 98.5319C51.6171 98.8235 51.3807 99.0598 51.0892 99.0598H44.1216C43.8301 99.0598 43.5938 98.8235 43.5938 98.5319Z"
				fill="#58707F"
			/>
			<path
				d="M67.1426 113V113.211H15.4136V113H67.1426Z"
				fill="#58707F"
			/>
			<path
				d="M18.6861 113.106V115.217H18.4751V113.106H18.6861Z"
				fill="#58707F"
			/>
			<path
				d="M15.6245 116.906C15.6245 116.615 15.8608 116.379 16.1524 116.379H21.0086C21.3001 116.379 21.5364 116.615 21.5364 116.906C21.5364 117.198 21.3001 117.434 21.0086 117.434H16.1524C15.8608 117.434 15.6245 117.198 15.6245 116.906Z"
				fill="#58707F"
			/>
			<path
				d="M31.3551 113.106V115.217H31.144V113.106H31.3551Z"
				fill="#58707F"
			/>
			<path
				d="M28.2935 116.906C28.2935 116.615 28.5298 116.379 28.8213 116.379H33.6775C33.969 116.379 34.2054 116.615 34.2054 116.906C34.2054 117.198 33.969 117.434 33.6775 117.434H28.8213C28.5298 117.434 28.2935 117.198 28.2935 116.906Z"
				fill="#58707F"
			/>
			<path
				d="M44.023 113.106V115.217H43.812V113.106H44.023Z"
				fill="#58707F"
			/>
			<path
				d="M40.9614 116.906C40.9614 116.615 41.1978 116.379 41.4893 116.379H46.3455C46.637 116.379 46.8733 116.615 46.8733 116.906C46.8733 117.198 46.637 117.434 46.3455 117.434H41.4893C41.1978 117.434 40.9614 117.198 40.9614 116.906Z"
				fill="#58707F"
			/>
			<path
				d="M56.4805 113.106V115.217H56.2695V113.106H56.4805Z"
				fill="#58707F"
			/>
			<path
				d="M53.4189 116.906C53.4189 116.615 53.6553 116.379 53.9468 116.379H58.803C59.0945 116.379 59.3309 116.615 59.3309 116.906C59.3309 117.198 59.0945 117.434 58.803 117.434H53.9468C53.6553 117.434 53.4189 117.198 53.4189 116.906Z"
				fill="#58707F"
			/>
		</g>
		<rect
			x={ 9.07882 }
			y={ 88.1915 }
			width={ 58.2745 }
			height={ 31.4598 }
			rx={ 0.21114 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<defs>
			<clipPath
				id="bgblur_0_20430_28755_clip_path"
				transform="translate(-7.60035 -16.826)"
			>
				<path d="M26.8141 27.0663C26.8141 32.0221 22.7965 36.0397 17.8406 36.0397C12.8847 36.0397 8.86719 32.0221 8.86719 27.0663C8.86719 22.1104 12.8847 18.0928 17.8406 18.0928C22.7965 18.0928 26.8141 22.1104 26.8141 27.0663Z" />
			</clipPath>
			<clipPath
				id="bgblur_1_20430_28755_clip_path"
				transform="translate(-7.60035 -16.826)"
			>
				<path d="M25.1247 27.066C25.1246 23.0431 21.8633 19.7817 17.8404 19.7817C13.8176 19.7818 10.5562 23.0432 10.556 27.066C10.556 31.0889 13.8175 34.3502 17.8404 34.3504V36.0399L17.609 36.037C12.7601 35.9142 8.86719 31.9445 8.86719 27.066C8.86732 22.1103 12.8847 18.093 17.8404 18.0928C22.7962 18.0928 26.8142 22.1102 26.8143 27.066L26.8114 27.2981C26.6884 32.1469 22.7188 36.0399 17.8404 36.0399V34.3504C21.8634 34.3504 25.1247 31.089 25.1247 27.066Z" />
			</clipPath>
			<clipPath
				id="bgblur_2_20430_28755_clip_path"
				transform="translate(-46.0115 -19.3597)"
			>
				<rect
					x={ 47.3837 }
					y={ 20.7321 }
					width={ 12.5526 }
					height={ 4.64507 }
					rx={ 0.738989 }
				/>
			</clipPath>
			<clipPath id="clip3_20430_28755">
				<rect
					x={ 8.86768 }
					y={ 87.9803 }
					width={ 58.6968 }
					height={ 31.8821 }
					rx={ 0.422279 }
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip4_20430_28755">
				<rect
					width={ 4.22279 }
					height={ 27.8704 }
					fill="white"
					transform="translate(10.979 87.8748)"
				/>
			</clipPath>
		</defs>
	</svg>
);

export const AqiMinimalFourIcon = ( { isPopup = false } ) => (
	<svg
		width={ isPopup ? 102 : 76 }
		height={ isPopup ? 172 : 128 }
		viewBox="0 0 76 128"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x={ 0.558824 }
			y={ 0.558824 }
			width={ 74.8824 }
			height={ 126.882 }
			rx={ 1.67647 }
			fill="white"
		/>
		<rect
			x={ 0.558824 }
			y={ 0.558824 }
			width={ 74.8824 }
			height={ 126.882 }
			rx={ 1.67647 }
			stroke="#8796A1"
			strokeWidth={ 1.11765 }
		/>
		<path
			d="M4.43408 6.25544C4.43408 5.26012 4.43408 4.76246 4.74329 4.45325C5.0525 4.14404 5.55016 4.14404 6.54548 4.14404H69.4651C70.4604 4.14404 70.9581 4.14404 71.2673 4.45325C71.5765 4.76246 71.5765 5.26012 71.5765 6.25544V121.538C71.5765 122.533 71.5765 123.031 71.2673 123.34C70.9581 123.649 70.4604 123.649 69.4651 123.649H6.54548C5.55016 123.649 5.0525 123.649 4.74329 123.34C4.43408 123.031 4.43408 122.533 4.43408 121.538V6.25544Z"
			fill="white"
		/>
		<path
			d="M69.465 122.919V123.649H6.54568V122.919H69.465ZM70.846 121.538V6.25564C70.846 5.73761 70.8446 5.42221 70.814 5.19475C70.7999 5.08965 70.7825 5.03279 70.7704 5.00338C70.7607 4.97992 70.7545 4.97371 70.7507 4.96991C70.7469 4.96611 70.7408 4.95994 70.7172 4.95026C70.6879 4.93817 70.6311 4.92074 70.5259 4.9066C70.2984 4.87605 69.9831 4.87459 69.465 4.87459H6.54568C6.02764 4.87459 5.71225 4.87607 5.48479 4.9066C5.37965 4.92074 5.32282 4.93817 5.29342 4.95026C5.26986 4.95995 5.26375 4.96611 5.25995 4.96991C5.25615 4.97371 5.24999 4.97982 5.2403 5.00338C5.22821 5.03278 5.21078 5.08962 5.19664 5.19475C5.16611 5.42221 5.16463 5.7376 5.16463 6.25564V121.538C5.16463 122.056 5.16608 122.371 5.19664 122.599C5.21078 122.704 5.22821 122.761 5.2403 122.79C5.24995 122.813 5.25616 122.82 5.25995 122.823C5.26376 122.827 5.2701 122.834 5.29342 122.843C5.32284 122.855 5.37976 122.873 5.48479 122.887C5.71224 122.917 6.02766 122.919 6.54568 122.919V123.649L5.88717 123.644C5.36105 123.631 5.03327 123.581 4.80372 123.395L4.74333 123.34C4.5114 123.108 4.45366 122.77 4.43918 122.196L4.43408 121.538V6.25564C4.43408 5.32268 4.4341 4.82679 4.68875 4.51368L4.74333 4.45329C4.97519 4.22142 5.31299 4.16364 5.88717 4.14914L6.54568 4.14404H69.465C70.4603 4.14404 70.9581 4.14408 71.2673 4.45329C71.5765 4.7625 71.5766 5.26037 71.5766 6.25564V121.538L71.5715 122.196C71.557 122.77 71.4993 123.108 71.2673 123.34L71.2069 123.395C70.9773 123.581 70.6493 123.631 70.1228 123.644L69.465 123.649V122.919C69.9831 122.919 70.2984 122.917 70.5259 122.887C70.631 122.873 70.6879 122.855 70.7172 122.843C70.7407 122.833 70.7469 122.827 70.7507 122.823C70.7545 122.82 70.7607 122.813 70.7704 122.79C70.7825 122.761 70.7999 122.704 70.814 122.599C70.8446 122.371 70.846 122.056 70.846 121.538Z"
			fill="#58707F"
		/>
		<path
			d="M21.1133 9.81775C21.1133 9.05979 21.7277 8.44534 22.4857 8.44534H51.8341C52.5921 8.44534 53.2065 9.05979 53.2065 9.81775C53.2065 10.5757 52.5921 11.1902 51.8341 11.1902H22.4857C21.7277 11.1902 21.1133 10.5757 21.1133 9.81775Z"
			fill="#58707F"
		/>
		<path
			d="M24.2803 13.4071C24.2803 12.999 24.6111 12.6682 25.0193 12.6682H38.1099C38.5181 12.6682 38.8489 12.999 38.8489 13.4071C38.8489 13.8153 38.5181 14.1461 38.1099 14.1461H25.0193C24.6111 14.1461 24.2803 13.8153 24.2803 13.4071Z"
			fill="#58707F"
		/>
		<path
			d="M39.6934 13.4071C39.6934 12.999 40.0242 12.6682 40.4323 12.6682H49.3002C49.7083 12.6682 50.0392 12.999 50.0392 13.4071C50.0392 13.8153 49.7083 14.1461 49.3002 14.1461H40.4323C40.0242 14.1461 39.6934 13.8153 39.6934 13.4071Z"
			fill="#58707F"
		/>
		<rect
			x={ 8.86739 }
			y={ 18.3688 }
			width={ 58.2745 }
			height={ 19.0026 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M14.7303 22.4663C15.9382 21.7746 17.324 21.4564 18.7127 21.5524C20.1013 21.6483 21.4307 22.1542 22.532 23.0055C23.6332 23.8567 24.457 25.0156 24.8997 26.3351C25.3425 27.6547 25.3841 29.0761 25.0191 30.4193C24.654 31.7625 23.899 32.9674 22.8493 33.8814C22.5562 34.1365 22.112 34.1059 21.8568 33.813C21.6015 33.5199 21.632 33.0751 21.9252 32.8198C22.7649 32.0885 23.3693 31.1243 23.6613 30.0497C23.9532 28.9752 23.9194 27.8382 23.5653 26.7826C23.211 25.727 22.5522 24.7997 21.6712 24.1187C20.7902 23.4378 19.7267 23.0335 18.6159 22.9567C17.5049 22.88 16.3959 23.1346 15.4296 23.688C14.4633 24.2414 13.683 25.0689 13.187 26.0659C12.691 27.0628 12.5013 28.1842 12.6427 29.2886C12.7842 30.3932 13.2503 31.4313 13.9816 32.2712C14.2367 32.5643 14.2063 33.0092 13.9132 33.2644C13.62 33.5196 13.1752 33.4884 12.92 33.1953C12.0059 32.1455 11.4232 30.8483 11.2464 29.4676C11.0696 28.0869 11.3067 26.6849 11.9267 25.4387C12.5468 24.1924 13.5224 23.158 14.7303 22.4663Z"
			fill="#D6E4ED"
		/>
		<path
			d="M15.4615 22.1054C15.8008 21.9956 16.1748 22.159 16.3215 22.4925C16.4778 22.8482 16.3163 23.263 15.9606 23.4195C15.0925 23.8013 14.3348 24.3963 13.7581 25.1491C13.1813 25.9019 12.8043 26.7888 12.6615 27.7263C12.5188 28.6638 12.6151 29.6222 12.9417 30.5125C13.2478 31.3471 13.7466 32.0968 14.3969 32.7005L14.5294 32.8191L14.581 32.8693C14.825 33.1296 14.8371 33.5375 14.5978 33.8123C14.3584 34.087 13.9525 34.131 13.6613 33.9251L13.6045 33.8807L13.4394 33.7322C12.6264 32.9776 12.003 32.0404 11.6203 30.9971C11.2121 29.8841 11.0911 28.6858 11.2696 27.5139C11.448 26.342 11.9202 25.2343 12.6411 24.2934C13.3621 23.3524 14.3088 22.6088 15.3938 22.1316L15.4615 22.1054Z"
			fill="#58707F"
		/>
		<path
			d="M20.8949 30.0794V30.4041H19.4574V30.127L20.1372 29.3981C20.2055 29.3221 20.2594 29.2553 20.2988 29.1975C20.3383 29.1388 20.3667 29.0864 20.384 29.0402C20.4023 28.993 20.4114 28.9483 20.4114 28.906C20.4114 28.8425 20.4008 28.7881 20.3797 28.7429C20.3585 28.6967 20.3272 28.6611 20.2859 28.6361C20.2454 28.611 20.1954 28.5985 20.1358 28.5985C20.0722 28.5985 20.0174 28.6139 19.9712 28.6447C19.926 28.6755 19.8913 28.7183 19.8673 28.7732C19.8442 28.828 19.8327 28.8901 19.8327 28.9594H19.4155C19.4155 28.8343 19.4454 28.7198 19.505 28.6159C19.5647 28.511 19.6489 28.4277 19.7576 28.3662C19.8663 28.3036 19.9953 28.2723 20.1444 28.2723C20.2916 28.2723 20.4158 28.2964 20.5168 28.3445C20.6188 28.3917 20.6958 28.46 20.7477 28.5495C20.8007 28.638 20.8271 28.7438 20.8271 28.867C20.8271 28.9363 20.816 29.0041 20.7939 29.0705C20.7718 29.1359 20.74 29.2014 20.6987 29.2668C20.6582 29.3313 20.6092 29.3967 20.5514 29.4631C20.4937 29.5295 20.4297 29.5983 20.3595 29.6695L19.9943 30.0794H20.8949Z"
			fill="#58707F"
		/>
		<path
			d="M19.2325 29.6189V29.9451H17.7184L17.6982 29.6925L18.5743 28.3026H18.9049L18.5469 28.9015L18.111 29.6189H19.2325ZM18.9944 28.3026V30.4041H18.5787V28.3026H18.9944Z"
			fill="#58707F"
		/>
		<path
			d="M17.0762 28.2982V30.4041H16.6605V28.7774L16.1611 28.9362V28.6086L17.0315 28.2982H17.0762Z"
			fill="#58707F"
		/>
		<path
			d="M16.7627 25.9699C16.7627 25.7367 16.9518 25.5476 17.185 25.5476H19.7187C19.9519 25.5476 20.1409 25.7367 20.1409 25.9699C20.1409 26.2031 19.9519 26.3922 19.7187 26.3922H17.185C16.9518 26.3922 16.7627 26.2031 16.7627 25.9699Z"
			fill="#58707F"
		/>
		<path
			d="M28.0107 24.1751C28.0107 24.1428 28.0107 24.1266 28.0111 24.1129C28.0257 23.5706 28.4619 23.1344 29.0042 23.1198C29.0179 23.1194 29.0341 23.1194 29.0664 23.1194H40.2568C40.2892 23.1194 40.3054 23.1194 40.3191 23.1198C40.8614 23.1344 41.2976 23.5706 41.3122 24.1129C41.3125 24.1266 41.3125 24.1428 41.3125 24.1751C41.3125 24.2075 41.3125 24.2237 41.3122 24.2374C41.2976 24.7797 40.8614 25.2159 40.3191 25.2305C40.3054 25.2308 40.2892 25.2308 40.2568 25.2308H29.0664C29.0341 25.2308 29.0179 25.2308 29.0042 25.2305C28.4619 25.2159 28.0257 24.7797 28.0111 24.2374C28.0107 24.2237 28.0107 24.2075 28.0107 24.1751Z"
			fill="#58707F"
		/>
		<foreignObject
			x={ 41.718 }
			y={ 20.4802 }
			width={ 15.2978 }
			height={ 7.38991 }
		>
			<div
				xmlns="http://www.w3.org/1999/xhtml"
				style={ {
					backdropFilter: 'blur(0.63px)',
					clipPath: 'url(#bgblur_0_20430_28756_clip_path)',
					height: '100%',
					width: '100%',
				} }
			/>
		</foreignObject>
		<g data-figma-bg-blur-radius={ 1.26684 }>
			<rect
				x={ 43.0902 }
				y={ 21.8526 }
				width={ 12.5531 }
				height={ 4.64507 }
				rx={ 0.738989 }
				fill="#D6E4ED"
			/>
			<rect
				x={ 43.0902 }
				y={ 21.8526 }
				width={ 12.5531 }
				height={ 4.64507 }
				rx={ 0.738989 }
				stroke="#58707F"
				strokeWidth={ 0.21114 }
			/>
			<path
				d="M51.7161 23.9633V25.1374H51.3931V23.6872H51.7013L51.7161 23.9633ZM52.1597 23.6779L52.157 23.9781C52.1373 23.9745 52.1159 23.9718 52.0927 23.97C52.0703 23.9682 52.048 23.9673 52.0257 23.9673C51.9703 23.9673 51.9216 23.9754 51.8796 23.9915C51.8376 24.0067 51.8023 24.029 51.7737 24.0585C51.746 24.0871 51.7246 24.1219 51.7094 24.163C51.6942 24.2041 51.6852 24.2501 51.6826 24.3011L51.6088 24.3064C51.6088 24.2153 51.6178 24.1309 51.6357 24.0531C51.6535 23.9754 51.6803 23.907 51.7161 23.8481C51.7527 23.7891 51.7983 23.7431 51.8528 23.71C51.9082 23.677 51.9721 23.6604 52.0444 23.6604C52.0641 23.6604 52.0851 23.6622 52.1074 23.6658C52.1306 23.6694 52.1481 23.6734 52.1597 23.6779Z"
				fill="#58707F"
			/>
			<path
				d="M49.772 24.4284V24.3976C49.772 24.293 49.7872 24.1961 49.8175 24.1067C49.8479 24.0165 49.8917 23.9383 49.9489 23.8722C50.007 23.8052 50.0775 23.7534 50.1606 23.7167C50.2446 23.6792 50.3393 23.6604 50.4448 23.6604C50.5511 23.6604 50.6458 23.6792 50.7289 23.7167C50.8129 23.7534 50.8839 23.8052 50.942 23.8722C51.0001 23.9383 51.0443 24.0165 51.0747 24.1067C51.1051 24.1961 51.1203 24.293 51.1203 24.3976V24.4284C51.1203 24.5329 51.1051 24.6299 51.0747 24.7192C51.0443 24.8086 51.0001 24.8868 50.942 24.9538C50.8839 25.0199 50.8133 25.0717 50.7302 25.1092C50.6472 25.1459 50.5529 25.1642 50.4475 25.1642C50.3411 25.1642 50.246 25.1459 50.162 25.1092C50.0789 25.0717 50.0083 25.0199 49.9502 24.9538C49.8921 24.8868 49.8479 24.8086 49.8175 24.7192C49.7872 24.6299 49.772 24.5329 49.772 24.4284ZM50.095 24.3976V24.4284C50.095 24.4936 50.1017 24.5553 50.1151 24.6133C50.1285 24.6714 50.1495 24.7223 50.1781 24.7661C50.2067 24.8099 50.2433 24.8443 50.288 24.8693C50.3326 24.8943 50.3858 24.9069 50.4475 24.9069C50.5073 24.9069 50.5591 24.8943 50.6029 24.8693C50.6476 24.8443 50.6842 24.8099 50.7128 24.7661C50.7414 24.7223 50.7624 24.6714 50.7758 24.6133C50.7901 24.5553 50.7973 24.4936 50.7973 24.4284V24.3976C50.7973 24.3332 50.7901 24.2725 50.7758 24.2153C50.7624 24.1572 50.741 24.1058 50.7115 24.0612C50.6829 24.0165 50.6463 23.9816 50.6016 23.9566C50.5578 23.9307 50.5055 23.9178 50.4448 23.9178C50.384 23.9178 50.3313 23.9307 50.2866 23.9566C50.2428 23.9816 50.2067 24.0165 50.1781 24.0612C50.1495 24.1058 50.1285 24.1572 50.1151 24.2153C50.1017 24.2725 50.095 24.3332 50.095 24.3976Z"
				fill="#58707F"
			/>
			<path
				d="M48.2148 24.4284V24.3976C48.2148 24.293 48.23 24.1961 48.2604 24.1067C48.2908 24.0165 48.3346 23.9383 48.3918 23.8722C48.4498 23.8052 48.5204 23.7534 48.6035 23.7167C48.6875 23.6792 48.7822 23.6604 48.8876 23.6604C48.994 23.6604 49.0887 23.6792 49.1718 23.7167C49.2558 23.7534 49.3268 23.8052 49.3849 23.8722C49.443 23.9383 49.4872 24.0165 49.5176 24.1067C49.5479 24.1961 49.5631 24.293 49.5631 24.3976V24.4284C49.5631 24.5329 49.5479 24.6299 49.5176 24.7192C49.4872 24.8086 49.443 24.8868 49.3849 24.9538C49.3268 25.0199 49.2562 25.0717 49.1731 25.1092C49.09 25.1459 48.9958 25.1642 48.8903 25.1642C48.784 25.1642 48.6888 25.1459 48.6049 25.1092C48.5218 25.0717 48.4512 25.0199 48.3931 24.9538C48.335 24.8868 48.2908 24.8086 48.2604 24.7192C48.23 24.6299 48.2148 24.5329 48.2148 24.4284ZM48.5378 24.3976V24.4284C48.5378 24.4936 48.5445 24.5553 48.5579 24.6133C48.5713 24.6714 48.5923 24.7223 48.6209 24.7661C48.6495 24.8099 48.6862 24.8443 48.7308 24.8693C48.7755 24.8943 48.8287 24.9069 48.8903 24.9069C48.9502 24.9069 49.002 24.8943 49.0458 24.8693C49.0905 24.8443 49.1271 24.8099 49.1557 24.7661C49.1843 24.7223 49.2053 24.6714 49.2187 24.6133C49.233 24.5553 49.2401 24.4936 49.2401 24.4284V24.3976C49.2401 24.3332 49.233 24.2725 49.2187 24.2153C49.2053 24.1572 49.1838 24.1058 49.1544 24.0612C49.1258 24.0165 49.0891 23.9816 49.0445 23.9566C49.0007 23.9307 48.9484 23.9178 48.8876 23.9178C48.8269 23.9178 48.7742 23.9307 48.7295 23.9566C48.6857 23.9816 48.6495 24.0165 48.6209 24.0612C48.5923 24.1058 48.5713 24.1572 48.5579 24.2153C48.5445 24.2725 48.5378 24.3332 48.5378 24.3976Z"
				fill="#58707F"
			/>
			<path
				d="M47.3154 24.4098H46.8074V24.1431H47.3154C47.4038 24.1431 47.4753 24.1288 47.5298 24.1002C47.5843 24.0716 47.6241 24.0323 47.6491 23.9823C47.675 23.9313 47.688 23.8733 47.688 23.808C47.688 23.7464 47.675 23.6887 47.6491 23.6351C47.6241 23.5806 47.5843 23.5369 47.5298 23.5038C47.4753 23.4707 47.4038 23.4542 47.3154 23.4542H46.9106V25.1375H46.5742V23.1862H47.3154C47.4664 23.1862 47.5946 23.213 47.7 23.2666C47.8063 23.3193 47.8872 23.3926 47.9426 23.4864C47.998 23.5793 48.0257 23.6856 48.0257 23.8053C48.0257 23.9313 47.998 24.0394 47.9426 24.1297C47.8872 24.2199 47.8063 24.2892 47.7 24.3374C47.5946 24.3857 47.4664 24.4098 47.3154 24.4098Z"
				fill="#58707F"
			/>
		</g>
		<path
			d="M28.0107 30.0871C28.0107 29.7956 28.2471 29.5593 28.5386 29.5593H63.7989C64.0904 29.5593 64.3268 29.7956 64.3268 30.0871C64.3268 30.3787 64.0904 30.615 63.7989 30.615H28.5386C28.2471 30.615 28.0107 30.3787 28.0107 30.0871Z"
			fill="#58707F"
		/>
		<path
			d="M28.0107 33.2542C28.0107 32.9627 28.2471 32.7264 28.5386 32.7264H55.9867C56.2783 32.7264 56.5146 32.9627 56.5146 33.2542C56.5146 33.5458 56.2783 33.7821 55.9867 33.7821H28.5386C28.2471 33.7821 28.0107 33.5458 28.0107 33.2542Z"
			fill="#58707F"
		/>
		<rect
			x={ 8.8669 }
			y={ 41.8053 }
			width={ 27.6593 }
			height={ 11.1904 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M11.8228 45.817C11.8228 45.2339 12.2954 44.7613 12.8785 44.7613H25.3357C25.9187 44.7613 26.3914 45.2339 26.3914 45.817C26.3914 46.4 25.9187 46.8727 25.3357 46.8727H12.8785C12.2954 46.8727 11.8228 46.4 11.8228 45.817Z"
			fill="#58707F"
		/>
		<path
			d="M11.8228 49.512C11.8228 49.2205 12.0591 48.9841 12.3506 48.9841H28.8195C29.111 48.9841 29.3473 49.2205 29.3473 49.512C29.3473 49.8035 29.111 50.0398 28.8195 50.0398H12.3506C12.0591 50.0398 11.8228 49.8035 11.8228 49.512Z"
			fill="#58707F"
		/>
		<rect
			x={ 39.4821 }
			y={ 41.8053 }
			width={ 27.6593 }
			height={ 11.1904 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M42.438 45.817C42.438 45.2339 42.9106 44.7613 43.4937 44.7613H55.9509C56.534 44.7613 57.0066 45.2339 57.0066 45.817C57.0066 46.4 56.534 46.8727 55.9509 46.8727H43.4937C42.9106 46.8727 42.438 46.4 42.438 45.817Z"
			fill="#58707F"
		/>
		<path
			d="M42.438 49.512C42.438 49.2205 42.6743 48.9841 42.9658 48.9841H59.4347C59.7263 48.9841 59.9626 49.2205 59.9626 49.512C59.9626 49.8035 59.7263 50.0398 59.4347 50.0398H42.9658C42.6743 50.0398 42.438 49.8035 42.438 49.512Z"
			fill="#58707F"
		/>
		<rect
			x={ 8.8669 }
			y={ 55.9514 }
			width={ 27.6593 }
			height={ 11.1904 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M11.8228 59.963C11.8228 59.38 12.2954 58.9073 12.8785 58.9073H25.3357C25.9187 58.9073 26.3914 59.38 26.3914 59.963C26.3914 60.5461 25.9187 61.0187 25.3357 61.0187H12.8785C12.2954 61.0187 11.8228 60.5461 11.8228 59.963Z"
			fill="#58707F"
		/>
		<path
			d="M11.8228 63.658C11.8228 63.3665 12.0591 63.1301 12.3506 63.1301H28.8195C29.111 63.1301 29.3473 63.3665 29.3473 63.658C29.3473 63.9495 29.111 64.1858 28.8195 64.1858H12.3506C12.0591 64.1858 11.8228 63.9495 11.8228 63.658Z"
			fill="#58707F"
		/>
		<rect
			x={ 39.4821 }
			y={ 55.9514 }
			width={ 27.6593 }
			height={ 11.1904 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M42.438 59.963C42.438 59.38 42.9106 58.9073 43.4937 58.9073H55.9509C56.534 58.9073 57.0066 59.38 57.0066 59.963C57.0066 60.5461 56.534 61.0187 55.9509 61.0187H43.4937C42.9106 61.0187 42.438 60.5461 42.438 59.963Z"
			fill="#58707F"
		/>
		<path
			d="M42.438 63.658C42.438 63.3665 42.6743 63.1301 42.9658 63.1301H59.4347C59.7263 63.1301 59.9626 63.3665 59.9626 63.658C59.9626 63.9495 59.7263 64.1858 59.4347 64.1858H42.9658C42.6743 64.1858 42.438 63.9495 42.438 63.658Z"
			fill="#58707F"
		/>
		<rect
			x={ 8.8669 }
			y={ 70.098 }
			width={ 27.6593 }
			height={ 11.1904 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M11.8228 74.1097C11.8228 73.5266 12.2954 73.054 12.8785 73.054H25.3357C25.9187 73.054 26.3914 73.5266 26.3914 74.1097C26.3914 74.6927 25.9187 75.1654 25.3357 75.1654H12.8785C12.2954 75.1654 11.8228 74.6927 11.8228 74.1097Z"
			fill="#58707F"
		/>
		<path
			d="M11.8228 77.8046C11.8228 77.5131 12.0591 77.2768 12.3506 77.2768H28.8195C29.111 77.2768 29.3473 77.5131 29.3473 77.8046C29.3473 78.0961 29.111 78.3325 28.8195 78.3325H12.3506C12.0591 78.3325 11.8228 78.0961 11.8228 77.8046Z"
			fill="#58707F"
		/>
		<rect
			x={ 39.4821 }
			y={ 70.098 }
			width={ 27.6593 }
			height={ 11.1904 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M42.438 74.1097C42.438 73.5266 42.9106 73.054 43.4937 73.054H55.9509C56.534 73.054 57.0066 73.5266 57.0066 74.1097C57.0066 74.6927 56.534 75.1654 55.9509 75.1654H43.4937C42.9106 75.1654 42.438 74.6927 42.438 74.1097Z"
			fill="#58707F"
		/>
		<path
			d="M42.438 77.8046C42.438 77.5131 42.6743 77.2768 42.9658 77.2768H59.4347C59.7263 77.2768 59.9626 77.5131 59.9626 77.8046C59.9626 78.0961 59.7263 78.3325 59.4347 78.3325H42.9658C42.6743 78.3325 42.438 78.0961 42.438 77.8046Z"
			fill="#58707F"
		/>
		<path
			d="M8.65527 86.5669C8.65527 86.5669 8.65527 86.5669 8.65527 86.5669C8.65527 85.9839 9.12793 85.5112 9.71097 85.5112C9.71097 85.5112 9.71097 85.5112 9.71097 85.5112H27.6578C27.6578 85.5112 27.6578 85.5112 27.6578 85.5112C28.2409 85.5112 28.7135 85.9839 28.7135 86.5669C28.7135 86.5669 28.7135 86.5669 28.7135 86.5669C28.7135 86.5669 28.7135 86.5669 28.7135 86.5669C28.7135 87.15 28.2409 87.6226 27.6578 87.6226H9.71097C9.71097 87.6226 9.71097 87.6226 9.71097 87.6226C9.12793 87.6226 8.65527 87.15 8.65527 86.5669C8.65527 86.5669 8.65527 86.5669 8.65527 86.5669Z"
			fill="#58707F"
		/>
		<path
			d="M59.3291 86.5668C59.3291 86.5668 59.3291 86.5668 59.3291 86.5668C59.3291 85.9838 59.8018 85.5111 60.3848 85.5111C60.3848 85.5111 60.3848 85.5111 60.3848 85.5111H66.2967C66.2967 85.5111 66.2967 85.5111 66.2967 85.5111C66.8798 85.5111 67.3524 85.9838 67.3524 86.5668C67.3524 86.5668 67.3524 86.5668 67.3524 86.5668C67.3524 86.5668 67.3524 86.5668 67.3524 86.5668C67.3524 87.1499 66.8798 87.6225 66.2967 87.6225H66.2967H60.3848C60.3848 87.6225 60.3848 87.6225 60.3848 87.6225C59.8018 87.6225 59.3291 87.1499 59.3291 86.5668C59.3291 86.5668 59.3291 86.5668 59.3291 86.5668Z"
			fill="#58707F"
		/>
		<path
			d="M49.6162 86.5668C49.6162 86.5668 49.6162 86.5668 49.6162 86.5668C49.6162 85.9838 50.0889 85.5111 50.6719 85.5111C50.6719 85.5111 50.6719 85.5111 50.6719 85.5111H56.5838C56.5838 85.5111 56.5838 85.5111 56.5838 85.5111C57.1669 85.5111 57.6395 85.9838 57.6395 86.5668C57.6395 86.5668 57.6395 86.5668 57.6395 86.5668C57.6395 86.5668 57.6395 86.5668 57.6395 86.5668C57.6395 87.1499 57.1669 87.6225 56.5838 87.6225H56.5838H50.6719C50.6719 87.6225 50.6719 87.6225 50.6719 87.6225C50.0889 87.6225 49.6162 87.1499 49.6162 86.5668C49.6162 86.5668 49.6162 86.5668 49.6162 86.5668Z"
			fill="#58707F"
		/>
		<rect
			x={ 8.8669 }
			y={ 91.0007 }
			width={ 17.4542 }
			height={ 28.3349 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M12.21 94.8014C12.21 94.4516 12.4936 94.168 12.8434 94.168H22.3447C22.6945 94.168 22.9781 94.4516 22.9781 94.8014C22.9781 95.1512 22.6945 95.4348 22.3447 95.4348H12.8434C12.4936 95.4348 12.21 95.1512 12.21 94.8014Z"
			fill="#58707F"
		/>
		<path
			d="M13.0547 97.335C13.0547 96.9852 13.3383 96.7016 13.6881 96.7016H21.5003C21.8501 96.7016 22.1337 96.9852 22.1337 97.335C22.1337 97.6849 21.8501 97.9685 21.5003 97.9685H13.6881C13.3383 97.9685 13.0547 97.6849 13.0547 97.335Z"
			fill="#58707F"
		/>
		<path
			d="M14.5514 101.312C15.6023 100.71 16.8082 100.433 18.0164 100.517C19.2245 100.6 20.3806 101.04 21.3387 101.78C22.2969 102.521 23.0142 103.529 23.3994 104.677C23.7846 105.825 23.821 107.062 23.5035 108.231C23.1859 109.399 22.5285 110.447 21.6152 111.243C21.3602 111.465 20.9736 111.438 20.7515 111.183C20.5295 110.928 20.5562 110.541 20.8112 110.319L20.9458 110.198C21.6065 109.578 22.0829 108.786 22.3211 107.909C22.575 106.974 22.5462 105.986 22.2381 105.067C21.9299 104.149 21.3565 103.342 20.59 102.75C19.8235 102.157 18.8985 101.805 17.932 101.738C16.9655 101.671 16.0011 101.893 15.1604 102.374C14.3197 102.856 13.6404 103.576 13.2089 104.443C12.7773 105.31 12.6129 106.286 12.7359 107.247C12.859 108.208 13.2639 109.111 13.9001 109.842L13.4381 110.244L12.9768 110.646C12.1815 109.733 11.6746 108.604 11.5208 107.403C11.3669 106.202 11.573 104.982 12.1123 103.898C12.6517 102.814 13.5006 101.914 14.5514 101.312ZM13.9001 109.842C14.1222 110.097 14.0954 110.484 13.8405 110.706C13.5855 110.928 13.1988 110.901 12.9768 110.646L13.9001 109.842Z"
			fill="#D6E4ED"
		/>
		<path
			d="M15.1294 101.02C15.4389 100.884 15.8002 101.025 15.9363 101.334C16.0723 101.644 15.9321 102.005 15.6227 102.141L15.344 102.274C14.705 102.605 14.1452 103.073 13.7061 103.646C13.2044 104.301 12.8764 105.072 12.7522 105.888C12.6281 106.704 12.7119 107.537 12.996 108.312C13.28 109.086 13.7549 109.777 14.377 110.318C14.6319 110.541 14.6586 110.927 14.4367 111.182C14.2285 111.421 13.8759 111.46 13.6225 111.28L13.573 111.242L13.4289 111.113C12.7217 110.457 12.1792 109.641 11.8463 108.734C11.4912 107.765 11.3862 106.723 11.5414 105.703C11.6967 104.684 12.1068 103.72 12.734 102.901C13.3613 102.082 14.1853 101.435 15.1294 101.02Z"
			fill="#58707F"
		/>
		<path
			d="M20.7935 107.428V107.85H18.9231V107.49L19.8076 106.541C19.8965 106.443 19.9666 106.356 20.0179 106.28C20.0692 106.204 20.1062 106.136 20.1287 106.076C20.1525 106.014 20.1644 105.956 20.1644 105.901C20.1644 105.818 20.1506 105.748 20.1231 105.689C20.0955 105.629 20.0548 105.582 20.001 105.55C19.9484 105.517 19.8833 105.501 19.8057 105.501C19.7231 105.501 19.6517 105.521 19.5916 105.561C19.5328 105.601 19.4877 105.657 19.4564 105.728C19.4264 105.8 19.4114 105.88 19.4114 105.971H18.8687C18.8687 105.808 18.9075 105.659 18.9851 105.524C19.0627 105.387 19.1722 105.279 19.3137 105.199C19.4552 105.117 19.6229 105.077 19.817 105.077C20.0085 105.077 20.17 105.108 20.3015 105.171C20.4342 105.232 20.5343 105.321 20.6019 105.437C20.6708 105.552 20.7052 105.69 20.7052 105.85C20.7052 105.94 20.6908 106.029 20.662 106.115C20.6332 106.2 20.5919 106.285 20.5381 106.371C20.4855 106.454 20.4217 106.54 20.3465 106.626C20.2714 106.712 20.1882 106.802 20.0968 106.894L19.6217 107.428H20.7935Z"
			fill="#58707F"
		/>
		<path
			d="M18.63 106.829V107.253H16.6601L16.6338 106.924L17.7737 105.116H18.2037L17.738 105.895L17.1709 106.829H18.63ZM18.3201 105.116V107.85H17.7793V105.116H18.3201Z"
			fill="#58707F"
		/>
		<path
			d="M15.8244 105.11V107.85H15.2835V105.734L14.6338 105.94V105.514L15.7661 105.11H15.8244Z"
			fill="#58707F"
		/>
		<path
			d="M13.0547 115.113C13.0547 114.53 13.5273 114.057 14.1104 114.057H21.078C21.661 114.057 22.1337 114.53 22.1337 115.113C22.1337 115.696 21.661 116.169 21.078 116.169H14.1104C13.5273 116.169 13.0547 115.696 13.0547 115.113Z"
			fill="#58707F"
		/>
		<rect
			x={ 29.2771 }
			y={ 91.0008 }
			width={ 17.4542 }
			height={ 28.3349 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M32.6201 94.8013C32.6201 94.4515 32.9037 94.1679 33.2535 94.1679H42.7548C43.1046 94.1679 43.3882 94.4515 43.3882 94.8013C43.3882 95.1512 43.1046 95.4347 42.7548 95.4347H33.2535C32.9037 95.4347 32.6201 95.1512 32.6201 94.8013Z"
			fill="#58707F"
		/>
		<path
			d="M33.4644 97.335C33.4644 96.9852 33.7479 96.7016 34.0978 96.7016H41.9099C42.2598 96.7016 42.5434 96.9852 42.5434 97.335C42.5434 97.6848 42.2598 97.9684 41.9099 97.9684H34.0978C33.7479 97.9684 33.4644 97.6848 33.4644 97.335Z"
			fill="#58707F"
		/>
		<path
			d="M34.961 101.312C36.0119 100.71 37.2179 100.433 38.426 100.517C39.6341 100.6 40.7903 101.04 41.7484 101.781C42.7066 102.521 43.4238 103.529 43.8091 104.677C44.1943 105.825 44.2307 107.062 43.9131 108.231C43.5956 109.4 42.9381 110.448 42.0249 111.243C41.7699 111.465 41.3833 111.438 41.1612 111.183C40.9392 110.928 40.9659 110.541 41.2209 110.319L41.3555 110.198C42.0162 109.578 42.4926 108.786 42.7307 107.909C42.9847 106.975 42.9559 105.986 42.6478 105.067C42.3396 104.149 41.7661 103.342 40.9997 102.75C40.2332 102.157 39.3081 101.805 38.3416 101.738C37.3752 101.672 36.4107 101.893 35.5701 102.374C34.7294 102.856 34.0501 103.576 33.6186 104.443C33.187 105.31 33.0225 106.286 33.1456 107.247C33.2687 108.208 33.6736 109.111 34.3098 109.842L33.8478 110.244L33.3864 110.646C32.5912 109.733 32.0843 108.604 31.9304 107.403C31.7766 106.202 31.9826 104.982 32.522 103.898C33.0614 102.814 33.9102 101.914 34.961 101.312ZM34.3098 109.842C34.5318 110.097 34.5051 110.484 34.2501 110.706C33.9951 110.928 33.6085 110.901 33.3864 110.646L34.3098 109.842Z"
			fill="#D6E4ED"
		/>
		<path
			d="M35.5386 101.02C35.8481 100.884 36.2094 101.025 36.3455 101.335C36.4815 101.644 36.3413 102.005 36.0319 102.141L35.7532 102.275C35.1142 102.605 34.5544 103.073 34.1153 103.646C33.6136 104.301 33.2856 105.072 33.1614 105.888C33.0372 106.704 33.1211 107.537 33.4051 108.312C33.6892 109.086 34.1641 109.777 34.7862 110.319C35.0411 110.541 35.0678 110.927 34.8459 111.182C34.6376 111.421 34.285 111.46 34.0316 111.281L33.9822 111.242L33.8381 111.113C33.1308 110.457 32.5884 109.641 32.2555 108.734C31.9003 107.766 31.7953 106.723 31.9506 105.703C32.1059 104.684 32.516 103.72 33.1432 102.901C33.7705 102.082 34.5945 101.435 35.5386 101.02Z"
			fill="#58707F"
		/>
		<path
			d="M41.2027 107.428V107.85H39.3323V107.49L40.2168 106.542C40.3057 106.443 40.3758 106.356 40.4271 106.28C40.4784 106.204 40.5154 106.136 40.5379 106.076C40.5617 106.014 40.5736 105.956 40.5736 105.901C40.5736 105.819 40.5598 105.748 40.5323 105.689C40.5047 105.629 40.464 105.583 40.4102 105.55C40.3576 105.517 40.2925 105.501 40.2149 105.501C40.1323 105.501 40.0609 105.521 40.0008 105.561C39.942 105.601 39.8969 105.657 39.8656 105.728C39.8356 105.8 39.8205 105.88 39.8205 105.971H39.2778C39.2778 105.808 39.3166 105.659 39.3943 105.524C39.4719 105.387 39.5814 105.279 39.7229 105.199C39.8644 105.117 40.0321 105.077 40.2262 105.077C40.4177 105.077 40.5792 105.108 40.7107 105.171C40.8434 105.232 40.9435 105.321 41.0111 105.437C41.08 105.552 41.1144 105.69 41.1144 105.85C41.1144 105.941 41.1 106.029 41.0712 106.115C41.0424 106.2 41.0011 106.285 40.9473 106.371C40.8947 106.455 40.8308 106.54 40.7557 106.626C40.6806 106.712 40.5974 106.802 40.506 106.895L40.0309 107.428H41.2027Z"
			fill="#58707F"
		/>
		<path
			d="M39.0392 106.829V107.253H37.0693L37.043 106.924L38.1828 105.116H38.6129L38.1472 105.895L37.58 106.829H39.0392ZM38.7293 105.116V107.85H38.1885V105.116H38.7293Z"
			fill="#58707F"
		/>
		<path
			d="M36.2335 105.11V107.85H35.6927V105.734L35.043 105.94V105.514L36.1753 105.11H36.2335Z"
			fill="#58707F"
		/>
		<path
			d="M33.4648 115.113C33.4648 114.53 33.9375 114.057 34.5205 114.057H41.4881C42.0712 114.057 42.5438 114.53 42.5438 115.113C42.5438 115.696 42.0712 116.169 41.4882 116.169H34.5205C33.9375 116.169 33.4648 115.696 33.4648 115.113Z"
			fill="#58707F"
		/>
		<rect
			x={ 49.6872 }
			y={ 91.0007 }
			width={ 17.4542 }
			height={ 28.3349 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M53.0303 94.8014C53.0303 94.4516 53.3139 94.168 53.6637 94.168H63.165C63.5148 94.168 63.7984 94.4516 63.7984 94.8014C63.7984 95.1512 63.5148 95.4348 63.165 95.4348H53.6637C53.3139 95.4348 53.0303 95.1512 53.0303 94.8014Z"
			fill="#58707F"
		/>
		<path
			d="M53.875 97.335C53.875 96.9852 54.1586 96.7016 54.5084 96.7016H62.3206C62.6704 96.7016 62.954 96.9852 62.954 97.335C62.954 97.6849 62.6704 97.9685 62.3206 97.9685H54.5084C54.1586 97.9685 53.875 97.6849 53.875 97.335Z"
			fill="#58707F"
		/>
		<path
			d="M55.3712 101.312C56.4221 100.71 57.628 100.433 58.8362 100.517C60.0443 100.6 61.2004 101.04 62.1586 101.78C63.1167 102.521 63.834 103.529 64.2192 104.677C64.6045 105.825 64.6408 107.062 64.3233 108.231C64.0057 109.399 63.3483 110.447 62.4351 111.243C62.18 111.465 61.7934 111.438 61.5714 111.183C61.3493 110.928 61.376 110.541 61.631 110.319L61.7656 110.198C62.4263 109.578 62.9027 108.786 63.1409 107.909C63.3949 106.974 63.366 105.986 63.0579 105.067C62.7498 104.149 62.1763 103.342 61.4098 102.75C60.6433 102.157 59.7183 101.805 58.7518 101.738C57.7854 101.671 56.8209 101.893 55.9802 102.374C55.1396 102.856 54.4603 103.576 54.0287 104.443C53.5972 105.31 53.4327 106.286 53.5557 107.247C53.6788 108.208 54.0837 109.111 54.72 109.842L54.2579 110.244L53.7966 110.646C53.0013 109.733 52.4944 108.604 52.3406 107.403C52.1868 106.202 52.3928 104.982 52.9322 103.898C53.4716 102.814 54.3204 101.914 55.3712 101.312ZM54.72 109.842C54.942 110.097 54.9153 110.484 54.6603 110.706C54.4053 110.928 54.0187 110.901 53.7966 110.646L54.72 109.842Z"
			fill="#D6E4ED"
		/>
		<path
			d="M55.9487 101.02C56.2583 100.884 56.6195 101.025 56.7557 101.334C56.8917 101.644 56.7514 102.005 56.4421 102.141L56.1634 102.274C55.5244 102.605 54.9646 103.073 54.5255 103.646C54.0237 104.301 53.6957 105.072 53.5715 105.888C53.4474 106.704 53.5312 107.537 53.8153 108.312C54.0994 109.086 54.5743 109.777 55.1963 110.318C55.4513 110.541 55.478 110.927 55.256 111.182C55.0478 111.421 54.6952 111.46 54.4418 111.28L54.3923 111.242L54.2482 111.113C53.541 110.457 52.9986 109.641 52.6656 108.734C52.3105 107.765 52.2055 106.723 52.3608 105.703C52.516 104.684 52.9261 103.72 53.5533 102.901C54.1806 102.082 55.0046 101.435 55.9487 101.02Z"
			fill="#58707F"
		/>
		<path
			d="M61.6113 107.428V107.85H59.741V107.49L60.6255 106.541C60.7143 106.443 60.7845 106.356 60.8358 106.28C60.8871 106.204 60.924 106.136 60.9466 106.076C60.9704 106.014 60.9823 105.956 60.9823 105.901C60.9823 105.818 60.9685 105.748 60.9409 105.689C60.9134 105.629 60.8727 105.582 60.8189 105.55C60.7663 105.517 60.7012 105.501 60.6236 105.501C60.541 105.501 60.4696 105.521 60.4095 105.561C60.3507 105.601 60.3056 105.657 60.2743 105.728C60.2443 105.8 60.2292 105.88 60.2292 105.971H59.6865C59.6865 105.808 59.7253 105.659 59.803 105.524C59.8806 105.387 59.9901 105.279 60.1316 105.199C60.273 105.117 60.4408 105.077 60.6349 105.077C60.8264 105.077 60.9879 105.108 61.1193 105.171C61.252 105.232 61.3522 105.321 61.4198 105.437C61.4887 105.552 61.5231 105.69 61.5231 105.85C61.5231 105.94 61.5087 106.029 61.4799 106.115C61.4511 106.2 61.4098 106.285 61.356 106.371C61.3034 106.454 61.2395 106.54 61.1644 106.626C61.0893 106.712 61.006 106.802 60.9147 106.894L60.4396 107.428H61.6113Z"
			fill="#58707F"
		/>
		<path
			d="M59.4474 106.829V107.253H57.4775L57.4512 106.924L58.591 105.116H59.0211L58.5554 105.895L57.9882 106.829H59.4474ZM59.1375 105.116V107.85H58.5967V105.116H59.1375Z"
			fill="#58707F"
		/>
		<path
			d="M56.6422 105.11V107.85H56.1014V105.734L55.4517 105.94V105.514L56.584 105.11H56.6422Z"
			fill="#58707F"
		/>
		<path
			d="M53.875 115.113C53.875 114.53 54.3477 114.057 54.9307 114.057H61.8983C62.4814 114.057 62.954 114.53 62.954 115.113C62.954 115.696 62.4814 116.169 61.8983 116.169H54.9307C54.3477 116.169 53.875 115.696 53.875 115.113Z"
			fill="#58707F"
		/>
		<defs>
			<clipPath
				id="bgblur_0_20430_28756_clip_path"
				transform="translate(-41.718 -20.4802)"
			>
				<rect
					x={ 43.0902 }
					y={ 21.8526 }
					width={ 12.5531 }
					height={ 4.64507 }
					rx={ 0.738989 }
				/>
			</clipPath>
		</defs>
	</svg>
);

export const AqiMinimalFiveIcon = ( { isPopup = false } ) => (
	<svg
		width={ isPopup ? 102 : 76 }
		height={ isPopup ? 172 : 128 }
		viewBox="0 0 76 128"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x={ 0.558824 }
			y={ 0.558824 }
			width={ 74.8824 }
			height={ 126.882 }
			rx={ 1.67647 }
			fill="white"
		/>
		<rect
			x={ 0.558824 }
			y={ 0.558824 }
			width={ 74.8824 }
			height={ 126.882 }
			rx={ 1.67647 }
			stroke="#8796A1"
			strokeWidth={ 1.11765 }
		/>
		<path
			d="M4.43408 6.25544C4.43408 5.26012 4.43408 4.76246 4.74329 4.45325C5.0525 4.14404 5.55016 4.14404 6.54548 4.14404H69.4651C70.4604 4.14404 70.9581 4.14404 71.2673 4.45325C71.5765 4.76246 71.5765 5.26012 71.5765 6.25544V121.538C71.5765 122.533 71.5765 123.031 71.2673 123.34C70.9581 123.649 70.4604 123.649 69.4651 123.649H6.54548C5.55016 123.649 5.0525 123.649 4.74329 123.34C4.43408 123.031 4.43408 122.533 4.43408 121.538V6.25544Z"
			fill="white"
		/>
		<path
			d="M69.465 122.919V123.649H6.54568V122.919H69.465ZM70.846 121.538V6.25564C70.846 5.73761 70.8446 5.42221 70.814 5.19475C70.7999 5.08965 70.7825 5.03279 70.7704 5.00338C70.7607 4.97992 70.7545 4.97371 70.7507 4.96991C70.7469 4.96611 70.7408 4.95994 70.7172 4.95026C70.6879 4.93817 70.6311 4.92074 70.5259 4.9066C70.2984 4.87605 69.9831 4.87459 69.465 4.87459H6.54568C6.02764 4.87459 5.71225 4.87607 5.48479 4.9066C5.37965 4.92074 5.32282 4.93817 5.29342 4.95026C5.26986 4.95995 5.26375 4.96611 5.25995 4.96991C5.25615 4.97371 5.24999 4.97982 5.2403 5.00338C5.22821 5.03278 5.21078 5.08962 5.19664 5.19475C5.16611 5.42221 5.16463 5.7376 5.16463 6.25564V121.538C5.16463 122.056 5.16608 122.371 5.19664 122.599C5.21078 122.704 5.22821 122.761 5.2403 122.79C5.24995 122.813 5.25616 122.82 5.25995 122.823C5.26376 122.827 5.2701 122.834 5.29342 122.843C5.32284 122.855 5.37976 122.873 5.48479 122.887C5.71224 122.917 6.02766 122.919 6.54568 122.919V123.649L5.88717 123.644C5.36105 123.631 5.03327 123.581 4.80372 123.395L4.74333 123.34C4.5114 123.108 4.45366 122.77 4.43918 122.196L4.43408 121.538V6.25564C4.43408 5.32268 4.4341 4.82679 4.68875 4.51368L4.74333 4.45329C4.97519 4.22142 5.31299 4.16364 5.88717 4.14914L6.54568 4.14404H69.465C70.4603 4.14404 70.9581 4.14408 71.2673 4.45329C71.5765 4.7625 71.5766 5.26037 71.5766 6.25564V121.538L71.5715 122.196C71.557 122.77 71.4993 123.108 71.2673 123.34L71.2069 123.395C70.9773 123.581 70.6493 123.631 70.1228 123.644L69.465 123.649V122.919C69.9831 122.919 70.2984 122.917 70.5259 122.887C70.631 122.873 70.6879 122.855 70.7172 122.843C70.7407 122.833 70.7469 122.827 70.7507 122.823C70.7545 122.82 70.7607 122.813 70.7704 122.79C70.7825 122.761 70.7999 122.704 70.814 122.599C70.8446 122.371 70.846 122.056 70.846 121.538Z"
			fill="#58707F"
		/>
		<path
			d="M8.65625 11.2956C8.65625 10.5376 9.2707 9.92319 10.0287 9.92319H34.0986C34.8565 9.92319 35.471 10.5376 35.471 11.2956C35.471 12.0536 34.8565 12.668 34.0986 12.668H10.0287C9.2707 12.668 8.65625 12.0536 8.65625 11.2956Z"
			fill="#58707F"
		/>
		<foreignObject
			x={ 53.1116 }
			y={ 7.60065 }
			width={ 15.2973 }
			height={ 7.38991 }
		>
			<div
				xmlns="http://www.w3.org/1999/xhtml"
				style={ {
					backdropFilter: 'blur(0.63px)',
					clipPath: 'url(#bgblur_0_20430_28757_clip_path)',
					height: '100%',
					width: '100%',
				} }
			/>
		</foreignObject>
		<g data-figma-bg-blur-radius={ 1.26684 }>
			<rect
				x={ 54.4838 }
				y={ 8.97307 }
				width={ 12.5526 }
				height={ 4.64507 }
				rx={ 0.738989 }
				fill="#D6E4ED"
			/>
			<rect
				x={ 54.4838 }
				y={ 8.97307 }
				width={ 12.5526 }
				height={ 4.64507 }
				rx={ 0.738989 }
				stroke="#58707F"
				strokeWidth={ 0.21114 }
			/>
			<path
				d="M63.1091 11.0837V12.2578H62.7861V10.8076H63.0944L63.1091 11.0837ZM63.5528 10.7982L63.5501 11.0985C63.5304 11.0949 63.509 11.0922 63.4857 11.0904C63.4634 11.0886 63.4411 11.0877 63.4187 11.0877C63.3633 11.0877 63.3146 11.0958 63.2726 11.1119C63.2306 11.1271 63.1954 11.1494 63.1668 11.1789C63.1391 11.2075 63.1176 11.2423 63.1024 11.2834C63.0872 11.3245 63.0783 11.3705 63.0756 11.4215L63.0019 11.4268C63.0019 11.3357 63.0108 11.2512 63.0287 11.1735C63.0466 11.0958 63.0734 11.0274 63.1091 10.9685C63.1458 10.9095 63.1913 10.8635 63.2458 10.8304C63.3012 10.7974 63.3651 10.7808 63.4375 10.7808C63.4571 10.7808 63.4781 10.7826 63.5005 10.7862C63.5237 10.7898 63.5411 10.7938 63.5528 10.7982Z"
				fill="#58707F"
			/>
			<path
				d="M61.1655 11.5488V11.518C61.1655 11.4134 61.1807 11.3165 61.2111 11.2271C61.2415 11.1369 61.2853 11.0587 61.3424 10.9926C61.4005 10.9256 61.4711 10.8737 61.5542 10.8371C61.6382 10.7996 61.7329 10.7808 61.8383 10.7808C61.9447 10.7808 62.0394 10.7996 62.1225 10.8371C62.2064 10.8737 62.2775 10.9256 62.3356 10.9926C62.3936 11.0587 62.4379 11.1369 62.4682 11.2271C62.4986 11.3165 62.5138 11.4134 62.5138 11.518V11.5488C62.5138 11.6533 62.4986 11.7503 62.4682 11.8396C62.4379 11.929 62.3936 12.0071 62.3356 12.0742C62.2775 12.1403 62.2069 12.1921 62.1238 12.2296C62.0407 12.2663 61.9464 12.2846 61.841 12.2846C61.7347 12.2846 61.6395 12.2663 61.5555 12.2296C61.4724 12.1921 61.4019 12.1403 61.3438 12.0742C61.2857 12.0071 61.2415 11.929 61.2111 11.8396C61.1807 11.7503 61.1655 11.6533 61.1655 11.5488ZM61.4885 11.518V11.5488C61.4885 11.614 61.4952 11.6757 61.5086 11.7337C61.522 11.7918 61.543 11.8427 61.5716 11.8865C61.6002 11.9303 61.6368 11.9647 61.6815 11.9897C61.7262 12.0147 61.7794 12.0272 61.841 12.0272C61.9009 12.0272 61.9527 12.0147 61.9965 11.9897C62.0412 11.9647 62.0778 11.9303 62.1064 11.8865C62.135 11.8427 62.156 11.7918 62.1694 11.7337C62.1837 11.6757 62.1908 11.614 62.1908 11.5488V11.518C62.1908 11.4536 62.1837 11.3929 62.1694 11.3357C62.156 11.2776 62.1345 11.2262 62.105 11.1816C62.0764 11.1369 62.0398 11.102 61.9951 11.077C61.9514 11.0511 61.8991 11.0381 61.8383 11.0381C61.7776 11.0381 61.7249 11.0511 61.6802 11.077C61.6364 11.102 61.6002 11.1369 61.5716 11.1816C61.543 11.2262 61.522 11.2776 61.5086 11.3357C61.4952 11.3929 61.4885 11.4536 61.4885 11.518Z"
				fill="#58707F"
			/>
			<path
				d="M59.6084 11.5488V11.518C59.6084 11.4134 59.6236 11.3165 59.654 11.2271C59.6843 11.1369 59.7281 11.0587 59.7853 10.9926C59.8434 10.9256 59.914 10.8737 59.9971 10.8371C60.0811 10.7996 60.1758 10.7808 60.2812 10.7808C60.3875 10.7808 60.4822 10.7996 60.5653 10.8371C60.6493 10.8737 60.7204 10.9256 60.7784 10.9926C60.8365 11.0587 60.8807 11.1369 60.9111 11.2271C60.9415 11.3165 60.9567 11.4134 60.9567 11.518V11.5488C60.9567 11.6533 60.9415 11.7503 60.9111 11.8396C60.8807 11.929 60.8365 12.0071 60.7784 12.0742C60.7204 12.1403 60.6498 12.1921 60.5667 12.2296C60.4836 12.2663 60.3893 12.2846 60.2839 12.2846C60.1776 12.2846 60.0824 12.2663 59.9984 12.2296C59.9153 12.1921 59.8447 12.1403 59.7867 12.0742C59.7286 12.0071 59.6843 11.929 59.654 11.8396C59.6236 11.7503 59.6084 11.6533 59.6084 11.5488ZM59.9314 11.518V11.5488C59.9314 11.614 59.9381 11.6757 59.9515 11.7337C59.9649 11.7918 59.9859 11.8427 60.0145 11.8865C60.0431 11.9303 60.0797 11.9647 60.1244 11.9897C60.1691 12.0147 60.2222 12.0272 60.2839 12.0272C60.3437 12.0272 60.3956 12.0147 60.4393 11.9897C60.484 11.9647 60.5207 11.9303 60.5492 11.8865C60.5778 11.8427 60.5988 11.7918 60.6122 11.7337C60.6265 11.6757 60.6337 11.614 60.6337 11.5488V11.518C60.6337 11.4536 60.6265 11.3929 60.6122 11.3357C60.5988 11.2776 60.5774 11.2262 60.5479 11.1816C60.5193 11.1369 60.4827 11.102 60.438 11.077C60.3942 11.0511 60.342 11.0381 60.2812 11.0381C60.2204 11.0381 60.1677 11.0511 60.1231 11.077C60.0793 11.102 60.0431 11.1369 60.0145 11.1816C59.9859 11.2262 59.9649 11.2776 59.9515 11.3357C59.9381 11.3929 59.9314 11.4536 59.9314 11.518Z"
				fill="#58707F"
			/>
			<path
				d="M58.7089 11.5302H58.201V11.2635H58.7089C58.7974 11.2635 58.8689 11.2492 58.9234 11.2206C58.9779 11.192 59.0176 11.1527 59.0426 11.1026C59.0686 11.0517 59.0815 10.9936 59.0815 10.9284C59.0815 10.8667 59.0686 10.8091 59.0426 10.7555C59.0176 10.701 58.9779 10.6572 58.9234 10.6242C58.8689 10.5911 58.7974 10.5746 58.7089 10.5746H58.3042V12.2579H57.9678V10.3065H58.7089C58.8599 10.3065 58.9881 10.3333 59.0936 10.3869C59.1999 10.4396 59.2808 10.5129 59.3362 10.6067C59.3916 10.6997 59.4193 10.806 59.4193 10.9257C59.4193 11.0517 59.3916 11.1598 59.3362 11.25C59.2808 11.3403 59.1999 11.4095 59.0936 11.4578C58.9881 11.506 58.8599 11.5302 58.7089 11.5302Z"
				fill="#58707F"
			/>
		</g>
		<rect
			x={ 8.86739 }
			y={ 17.9465 }
			width={ 58.2745 }
			height={ 21.3251 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M39.2631 23.6009L38.567 23.4258L38.8342 20.9025H41.4768V21.6543H39.5567L39.4314 22.8216C39.4996 22.7781 39.5985 22.7346 39.7283 22.6911C39.8603 22.6454 40.0087 22.6225 40.1737 22.6225C40.4024 22.6225 40.6069 22.6614 40.7873 22.7392C40.9676 22.8147 41.1205 22.9246 41.2459 23.0688C41.3734 23.213 41.4691 23.3892 41.5329 23.5975C41.5989 23.8035 41.6318 24.0369 41.6318 24.2979C41.6318 24.5267 41.5989 24.7419 41.5329 24.9433C41.4691 25.1424 41.3712 25.3198 41.2393 25.4754C41.1073 25.6288 40.9412 25.7501 40.7411 25.8394C40.541 25.9263 40.3056 25.9698 40.0351 25.9698C39.8306 25.9698 39.6337 25.9389 39.4446 25.8771C39.2576 25.813 39.0894 25.7203 38.9398 25.599C38.7903 25.4754 38.6704 25.3244 38.5802 25.1459C38.4922 24.9673 38.4439 24.7625 38.4351 24.5313H39.2961C39.3115 24.6847 39.3511 24.8151 39.4149 24.9227C39.4787 25.0303 39.5622 25.1127 39.6656 25.1699C39.7712 25.2271 39.8932 25.2557 40.0318 25.2557C40.1572 25.2557 40.2649 25.2317 40.3551 25.1836C40.4475 25.1333 40.5234 25.0635 40.5827 24.9742C40.6421 24.8849 40.6861 24.7797 40.7147 24.6583C40.7433 24.537 40.7576 24.4043 40.7576 24.2601C40.7576 24.1205 40.7411 23.9935 40.7081 23.879C40.6751 23.7623 40.6245 23.6616 40.5564 23.5769C40.4882 23.4922 40.4024 23.427 40.299 23.3812C40.1979 23.3354 40.0791 23.3125 39.9427 23.3125C39.7602 23.3125 39.6194 23.3412 39.5204 23.3984C39.4237 23.4556 39.3379 23.5231 39.2631 23.6009Z"
			fill="#58707F"
		/>
		<path
			d="M37.8744 24.0781V24.7922H34.4137L34.3774 24.2429L36.413 20.9025H37.1091L36.3569 22.2311L35.2649 24.0781H37.8744ZM37.3037 20.9025V25.9012H36.4295V20.9025H37.3037Z"
			fill="#58707F"
		/>
		<path
			d="M27.6587 28.1868C27.6587 27.8952 27.895 27.6589 28.1865 27.6589H47.8225C48.1141 27.6589 48.3504 27.8952 48.3504 28.1868C48.3504 28.4783 48.1141 28.7146 47.8225 28.7146H28.1865C27.895 28.7146 27.6587 28.4783 27.6587 28.1868Z"
			fill="#58707F"
		/>
		<path
			d="M13.4702 32.4095C13.4702 32.2346 13.612 32.0928 13.7869 32.0928H18.6431C18.8181 32.0928 18.9598 32.2346 18.9598 32.4095C18.9598 32.5845 18.8181 32.7263 18.6431 32.7263H13.7869C13.612 32.7263 13.4702 32.5845 13.4702 32.4095Z"
			fill="#58707F"
		/>
		<path
			d="M24.4707 32.4095C24.4707 32.2346 24.6125 32.0928 24.7874 32.0928H29.4325C29.6074 32.0928 29.7492 32.2346 29.7492 32.4095C29.7492 32.5845 29.6074 32.7263 29.4325 32.7263H24.7874C24.6125 32.7263 24.4707 32.5845 24.4707 32.4095Z"
			fill="#58707F"
		/>
		<path
			d="M35.4707 32.4095C35.4707 32.2346 35.6125 32.0928 35.7874 32.0928H40.2213C40.3963 32.0928 40.5381 32.2346 40.5381 32.4095C40.5381 32.5845 40.3963 32.7263 40.2213 32.7263H35.7874C35.6125 32.7263 35.4707 32.5845 35.4707 32.4095Z"
			fill="#58707F"
		/>
		<path
			d="M46.4717 32.4095C46.4717 32.2346 46.6135 32.0928 46.7884 32.0928H51.0112C51.1861 32.0928 51.3279 32.2346 51.3279 32.4095C51.3279 32.5845 51.1861 32.7263 51.0112 32.7263H46.7884C46.6135 32.7263 46.4717 32.5845 46.4717 32.4095Z"
			fill="#58707F"
		/>
		<path
			d="M57.4717 32.4095C57.4717 32.2346 57.6135 32.0928 57.7884 32.0928H61.8C61.975 32.0928 62.1168 32.2346 62.1168 32.4095C62.1168 32.5845 61.975 32.7263 61.8 32.7263H57.7884C57.6135 32.7263 57.4717 32.5845 57.4717 32.4095Z"
			fill="#58707F"
		/>
		<g clipPath="url(#clip1_20430_28757)">
			<path
				d="M10.7671 33.7685H65.2411V34.6131H10.7671V33.7685Z"
				fill="#58707F"
			/>
		</g>
		<path
			d="M18.7905 34.204C18.7905 33.621 19.2632 33.1483 19.8462 33.1483C20.4293 33.1483 20.9019 33.621 20.9019 34.204C20.9019 34.7871 20.4293 35.2597 19.8462 35.2597C19.2632 35.2597 18.7905 34.7871 18.7905 34.204Z"
			fill="#D6E4ED"
		/>
		<path
			d="M20.4794 34.2041C20.4794 33.8543 20.1961 33.5704 19.8463 33.5704C19.4965 33.5704 19.2126 33.8543 19.2126 34.2041C19.2126 34.5539 19.4965 34.8372 19.8463 34.8372V35.2599L19.7386 35.2541C19.2416 35.2038 18.846 34.8089 18.7956 34.3118L18.7905 34.2041C18.7905 33.6211 19.2633 33.1483 19.8463 33.1483L19.954 33.1534C20.4864 33.2074 20.9021 33.6575 20.9021 34.2041L20.8963 34.3118C20.8423 34.8442 20.3929 35.2599 19.8463 35.2599V34.8372C20.1961 34.8371 20.4793 34.5539 20.4794 34.2041Z"
			fill="#58707F"
		/>
		<path
			d="M10.7676 35.9989C10.7676 35.824 10.9094 35.6822 11.0843 35.6822H13.8291C14.004 35.6822 14.1458 35.824 14.1458 35.9989C14.1458 36.1738 14.004 36.3156 13.8291 36.3156H11.0843C10.9094 36.3156 10.7676 36.1738 10.7676 35.9989Z"
			fill="#58707F"
		/>
		<path
			d="M23.5415 35.9989C23.5415 35.824 23.6833 35.6822 23.8582 35.6822H26.603C26.7779 35.6822 26.9197 35.824 26.9197 35.9989C26.9197 36.1738 26.7779 36.3156 26.603 36.3156H23.8582C23.6833 36.3156 23.5415 36.1738 23.5415 35.9989Z"
			fill="#58707F"
		/>
		<path
			d="M36.3154 35.9989C36.3154 35.824 36.4572 35.6822 36.6321 35.6822H39.377C39.5519 35.6822 39.6937 35.824 39.6937 35.9989C39.6937 36.1738 39.5519 36.3156 39.377 36.3156H36.6321C36.4572 36.3156 36.3154 36.1738 36.3154 35.9989Z"
			fill="#58707F"
		/>
		<path
			d="M49.0894 35.9989C49.0894 35.824 49.2312 35.6822 49.4061 35.6822H52.1509C52.3258 35.6822 52.4676 35.824 52.4676 35.9989C52.4676 36.1738 52.3258 36.3156 52.1509 36.3156H49.4061C49.2312 36.3156 49.0894 36.1738 49.0894 35.9989Z"
			fill="#58707F"
		/>
		<path
			d="M61.8633 35.9989C61.8633 35.824 62.0051 35.6822 62.18 35.6822H64.9248C65.0997 35.6822 65.2415 35.824 65.2415 35.9989C65.2415 36.1738 65.0997 36.3156 64.9248 36.3156H62.18C62.0051 36.3156 61.8633 36.1738 61.8633 35.9989Z"
			fill="#58707F"
		/>
		<rect
			x={ 8.86739 }
			y={ 43.9166 }
			width={ 17.4542 }
			height={ 10.7681 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M11.6123 47.7172C11.6123 47.1341 12.085 46.6615 12.668 46.6615H20.0579C20.6409 46.6615 21.1136 47.1341 21.1136 47.7172C21.1136 48.3002 20.6409 48.7729 20.0579 48.7729H12.668C12.085 48.7729 11.6123 48.3002 11.6123 47.7172Z"
			fill="#58707F"
		/>
		<path
			d="M11.6123 51.4119C11.6123 51.1204 11.8486 50.8841 12.1402 50.8841H22.6971C22.9887 50.8841 23.225 51.1204 23.225 51.4119C23.225 51.7035 22.9887 51.9398 22.6971 51.9398H12.1402C11.8486 51.9398 11.6123 51.7035 11.6123 51.4119Z"
			fill="#58707F"
		/>
		<rect
			x={ 29.2775 }
			y={ 43.9166 }
			width={ 17.4542 }
			height={ 10.7681 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M32.0225 47.7172C32.0225 47.1341 32.4951 46.6615 33.0782 46.6615H40.468C41.0511 46.6615 41.5237 47.1341 41.5237 47.7172C41.5237 48.3002 41.0511 48.7729 40.468 48.7729H33.0782C32.4951 48.7729 32.0225 48.3002 32.0225 47.7172Z"
			fill="#58707F"
		/>
		<path
			d="M32.0225 51.4121C32.0225 51.1206 32.2588 50.8842 32.5503 50.8842H43.1073C43.3988 50.8842 43.6351 51.1206 43.6351 51.4121C43.6351 51.7036 43.3988 51.9399 43.1073 51.9399H32.5503C32.2588 51.9399 32.0225 51.7036 32.0225 51.4121Z"
			fill="#58707F"
		/>
		<rect
			x={ 49.6877 }
			y={ 43.9166 }
			width={ 17.4542 }
			height={ 10.7681 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M52.4326 47.7172C52.4326 47.1341 52.9053 46.6615 53.4883 46.6615H60.8782C61.4612 46.6615 61.9339 47.1341 61.9339 47.7172C61.9339 48.3002 61.4613 48.7729 60.8782 48.7729H53.4883C52.9053 48.7729 52.4326 48.3002 52.4326 47.7172Z"
			fill="#58707F"
		/>
		<path
			d="M52.4326 51.4119C52.4326 51.1204 52.6689 50.8841 52.9605 50.8841H63.5175C63.809 50.8841 64.0453 51.1204 64.0453 51.4119C64.0453 51.7035 63.809 51.9398 63.5175 51.9398H52.9605C52.6689 51.9398 52.4326 51.7035 52.4326 51.4119Z"
			fill="#58707F"
		/>
		<rect
			x={ 8.86739 }
			y={ 58.063 }
			width={ 17.4542 }
			height={ 10.7681 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M11.6123 61.8636C11.6123 61.2805 12.085 60.8079 12.668 60.8079H20.0579C20.6409 60.8079 21.1136 61.2805 21.1136 61.8636C21.1136 62.4466 20.6409 62.9193 20.0579 62.9193H12.668C12.085 62.9193 11.6123 62.4466 11.6123 61.8636Z"
			fill="#58707F"
		/>
		<path
			d="M11.6123 65.5585C11.6123 65.267 11.8486 65.0307 12.1402 65.0307H22.6971C22.9887 65.0307 23.225 65.267 23.225 65.5585C23.225 65.8501 22.9887 66.0864 22.6971 66.0864H12.1402C11.8486 66.0864 11.6123 65.8501 11.6123 65.5585Z"
			fill="#58707F"
		/>
		<rect
			x={ 29.2775 }
			y={ 58.063 }
			width={ 17.4542 }
			height={ 10.7681 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M32.0225 61.8635C32.0225 61.2805 32.4951 60.8078 33.0782 60.8078H40.468C41.0511 60.8078 41.5237 61.2805 41.5237 61.8635C41.5237 62.4466 41.0511 62.9192 40.468 62.9192H33.0782C32.4951 62.9192 32.0225 62.4466 32.0225 61.8635Z"
			fill="#58707F"
		/>
		<path
			d="M32.0225 65.5585C32.0225 65.2669 32.2588 65.0306 32.5503 65.0306H43.1073C43.3988 65.0306 43.6351 65.2669 43.6351 65.5585C43.6351 65.85 43.3988 66.0863 43.1073 66.0863H32.5503C32.2588 66.0863 32.0225 65.85 32.0225 65.5585Z"
			fill="#58707F"
		/>
		<rect
			x={ 49.6877 }
			y={ 58.063 }
			width={ 17.4542 }
			height={ 10.7681 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M52.4326 61.8636C52.4326 61.2805 52.9053 60.8079 53.4883 60.8079H60.8782C61.4612 60.8079 61.9339 61.2805 61.9339 61.8636C61.9339 62.4466 61.4613 62.9193 60.8782 62.9193H53.4883C52.9053 62.9193 52.4326 62.4466 52.4326 61.8636Z"
			fill="#58707F"
		/>
		<path
			d="M52.4326 65.5585C52.4326 65.267 52.6689 65.0307 52.9605 65.0307H63.5175C63.809 65.0307 64.0453 65.267 64.0453 65.5585C64.0453 65.8501 63.809 66.0864 63.5175 66.0864H52.9605C52.6689 66.0864 52.4326 65.8501 52.4326 65.5585Z"
			fill="#58707F"
		/>
		<rect
			x={ 8.86739 }
			y={ 73.4761 }
			width={ 58.2745 }
			height={ 11.1904 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M11.1899 76.3265C11.1899 76.035 11.4263 75.7986 11.7178 75.7986H64.2916C64.5831 75.7986 64.8194 76.035 64.8194 76.3265C64.8194 76.618 64.5831 76.8543 64.2916 76.8543H11.7178C11.4263 76.8543 11.1899 76.618 11.1899 76.3265Z"
			fill="#58707F"
		/>
		<path
			d="M11.1899 79.0713C11.1899 78.7798 11.4263 78.5435 11.7178 78.5435H63.447C63.7385 78.5435 63.9749 78.7798 63.9749 79.0713C63.9749 79.3628 63.7385 79.5992 63.447 79.5992H11.7178C11.4263 79.5992 11.1899 79.3628 11.1899 79.0713Z"
			fill="#58707F"
		/>
		<path
			d="M11.1899 81.8161C11.1899 81.5246 11.4263 81.2883 11.7178 81.2883H43.811C44.1025 81.2883 44.3389 81.5246 44.3389 81.8161C44.3389 82.1076 44.1025 82.344 43.811 82.344H11.7178C11.4263 82.344 11.1899 82.1076 11.1899 81.8161Z"
			fill="#58707F"
		/>
		<path
			d="M8.65527 90.1569C8.65527 90.1569 8.65527 90.1569 8.65527 90.1569C8.65527 89.5739 9.12793 89.1012 9.71097 89.1012C9.71097 89.1012 9.71097 89.1012 9.71097 89.1012H27.6578C27.6578 89.1012 27.6578 89.1012 27.6578 89.1012C28.2409 89.1012 28.7135 89.5739 28.7135 90.1569C28.7135 90.1569 28.7135 90.1569 28.7135 90.1569C28.7135 90.1569 28.7135 90.1569 28.7135 90.1569C28.7135 90.74 28.2409 91.2126 27.6578 91.2126H9.71097C9.71097 91.2126 9.71097 91.2126 9.71097 91.2126C9.12793 91.2126 8.65527 90.74 8.65527 90.1569C8.65527 90.1569 8.65527 90.1569 8.65527 90.1569Z"
			fill="#58707F"
		/>
		<path
			d="M59.3291 90.1569C59.3291 90.1569 59.3291 90.1569 59.3291 90.1569C59.3291 89.5739 59.8018 89.1012 60.3848 89.1012C60.3848 89.1012 60.3848 89.1012 60.3848 89.1012H66.2967C66.2967 89.1012 66.2967 89.1012 66.2967 89.1012C66.8798 89.1012 67.3524 89.5739 67.3524 90.1569C67.3524 90.1569 67.3524 90.1569 67.3524 90.1569C67.3524 90.1569 67.3524 90.1569 67.3524 90.1569C67.3524 90.74 66.8798 91.2126 66.2967 91.2126H66.2967H60.3848C60.3848 91.2126 60.3848 91.2126 60.3848 91.2126C59.8018 91.2126 59.3291 90.74 59.3291 90.1569C59.3291 90.1569 59.3291 90.1569 59.3291 90.1569Z"
			fill="#58707F"
		/>
		<path
			d="M49.6162 90.1569C49.6162 90.1569 49.6162 90.1569 49.6162 90.1569C49.6162 89.5739 50.0889 89.1012 50.6719 89.1012C50.6719 89.1012 50.6719 89.1012 50.6719 89.1012H56.5838C56.5838 89.1012 56.5838 89.1012 56.5838 89.1012C57.1669 89.1012 57.6395 89.5739 57.6395 90.1569C57.6395 90.1569 57.6395 90.1569 57.6395 90.1569C57.6395 90.1569 57.6395 90.1569 57.6395 90.1569C57.6395 90.74 57.1669 91.2126 56.5838 91.2126H56.5838H50.6719C50.6719 91.2126 50.6719 91.2126 50.6719 91.2126C50.0889 91.2126 49.6162 90.74 49.6162 90.1569C49.6162 90.1569 49.6162 90.1569 49.6162 90.1569Z"
			fill="#58707F"
		/>
		<rect
			x={ 8.8669 }
			y={ 94.5906 }
			width={ 17.4542 }
			height={ 24.1509 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M12.21 98.3911C12.21 98.0413 12.4936 97.7577 12.8434 97.7577H22.3447C22.6945 97.7577 22.9781 98.0413 22.9781 98.3911C22.9781 98.7409 22.6945 99.0245 22.3447 99.0245H12.8434C12.4936 99.0245 12.21 98.7409 12.21 98.3911Z"
			fill="#58707F"
		/>
		<path
			d="M13.0547 100.925C13.0547 100.575 13.3383 100.291 13.6881 100.291H21.5003C21.8501 100.291 22.1337 100.575 22.1337 100.925C22.1337 101.275 21.8501 101.558 21.5003 101.558H13.6881C13.3383 101.558 13.0547 101.275 13.0547 100.925Z"
			fill="#58707F"
		/>
		<path
			d="M22.9246 110.216C22.9246 109.519 22.7783 108.829 22.4938 108.185C22.2094 107.541 21.7923 106.956 21.2667 106.463C20.7411 105.97 20.1171 105.579 19.4304 105.313C18.7436 105.046 18.0075 104.909 17.2642 104.909C16.5208 104.909 15.7847 105.046 15.0979 105.313C14.4112 105.579 13.7872 105.97 13.2616 106.463C12.736 106.956 12.319 107.541 12.0345 108.185C11.75 108.829 11.6037 109.519 11.6037 110.216C11.6037 110.441 11.4088 110.624 11.1683 110.624C10.9279 110.624 10.7329 110.441 10.7329 110.216C10.7329 109.412 10.9022 108.615 11.2304 107.873C11.5586 107.13 12.0396 106.455 12.6461 105.886C13.2526 105.318 13.9726 104.867 14.765 104.559C15.5574 104.251 16.4065 104.093 17.2642 104.093C18.1218 104.093 18.971 104.251 19.7633 104.559C20.5557 104.867 21.2757 105.318 21.8822 105.886C22.4887 106.455 22.9697 107.13 23.2979 107.873C23.6261 108.615 23.7954 109.412 23.7954 110.216C23.7954 110.441 23.6005 110.624 23.36 110.624C23.1195 110.624 22.9246 110.441 22.9246 110.216Z"
			fill="#58707F"
		/>
		<path
			d="M20.0538 109.703V110.03H18.6037V109.751L19.2895 109.016C19.3584 108.939 19.4128 108.872 19.4525 108.813C19.4923 108.754 19.521 108.701 19.5384 108.655C19.5569 108.607 19.5661 108.562 19.5661 108.519C19.5661 108.455 19.5554 108.4 19.5341 108.355C19.5127 108.308 19.4812 108.272 19.4394 108.247C19.3987 108.222 19.3482 108.209 19.288 108.209C19.224 108.209 19.1686 108.225 19.1221 108.256C19.0764 108.287 19.0415 108.33 19.0172 108.385C18.9939 108.441 18.9823 108.503 18.9823 108.573H18.5615C18.5615 108.447 18.5916 108.331 18.6518 108.227C18.712 108.121 18.7969 108.037 18.9066 107.975C19.0163 107.912 19.1463 107.88 19.2968 107.88C19.4453 107.88 19.5705 107.904 19.6724 107.953C19.7753 108 19.8529 108.069 19.9053 108.16C19.9587 108.249 19.9854 108.356 19.9854 108.48C19.9854 108.55 19.9743 108.618 19.9519 108.685C19.9296 108.751 19.8976 108.817 19.8558 108.883C19.8151 108.948 19.7656 109.014 19.7073 109.081C19.6491 109.148 19.5846 109.218 19.5137 109.289L19.1453 109.703H20.0538Z"
			fill="#58707F"
		/>
		<path
			d="M18.3763 109.238V109.567H16.849L16.8286 109.313L17.7124 107.911H18.0458L17.6847 108.515L17.245 109.238H18.3763ZM18.136 107.911V110.03H17.7167V107.911H18.136Z"
			fill="#58707F"
		/>
		<path
			d="M16.2014 107.906V110.03H15.7821V108.39L15.2783 108.55V108.219L16.1562 107.906H16.2014Z"
			fill="#58707F"
		/>
		<g filter="url(#filter1_d_20430_28757)">
			<path
				d="M16.4192 104.812C16.4192 105.159 16.1372 105.441 15.7894 105.441C15.4416 105.441 15.1597 105.159 15.1597 104.812C15.1597 104.464 15.4416 104.182 15.7894 104.182C16.1372 104.182 16.4192 104.464 16.4192 104.812Z"
				fill="#D6E4ED"
			/>
		</g>
		<g filter="url(#filter2_d_20430_28757)">
			<path
				d="M16.2844 104.811C16.2842 104.538 16.0621 104.316 15.7889 104.316C15.5159 104.317 15.2943 104.538 15.2941 104.811C15.2941 105.084 15.5158 105.307 15.7889 105.307C16.0622 105.307 16.2844 105.085 16.2844 104.811ZM16.5537 104.811C16.5537 105.234 16.2113 105.576 15.7889 105.576C15.3667 105.576 15.0249 105.234 15.0249 104.811C15.0251 104.389 15.3669 104.047 15.7889 104.047C16.2111 104.047 16.5535 104.389 16.5537 104.811Z"
				fill="#58707F"
			/>
		</g>
		<path
			d="M13.0547 114.519C13.0547 113.935 13.5273 113.463 14.1104 113.463H21.078C21.661 113.463 22.1337 113.935 22.1337 114.519C22.1337 115.102 21.661 115.574 21.078 115.574H14.1104C13.5273 115.574 13.0547 115.102 13.0547 114.519Z"
			fill="#58707F"
		/>
		<rect
			x={ 29.2771 }
			y={ 94.5906 }
			width={ 17.4542 }
			height={ 24.1509 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M32.6201 98.3911C32.6201 98.0413 32.9037 97.7577 33.2535 97.7577H42.7548C43.1046 97.7577 43.3882 98.0413 43.3882 98.3911C43.3882 98.7409 43.1046 99.0245 42.7548 99.0245H33.2535C32.9037 99.0245 32.6201 98.7409 32.6201 98.3911Z"
			fill="#58707F"
		/>
		<path
			d="M33.4648 100.925C33.4648 100.575 33.7484 100.291 34.0983 100.291H41.9104C42.2603 100.291 42.5438 100.575 42.5438 100.925C42.5438 101.275 42.2603 101.558 41.9104 101.558H34.0983C33.7484 101.558 33.4648 101.275 33.4648 100.925Z"
			fill="#58707F"
		/>
		<path
			d="M43.3352 110.216C43.3352 109.519 43.1889 108.829 42.9045 108.185C42.62 107.541 42.203 106.956 41.6774 106.463C41.1518 105.97 40.5278 105.579 39.841 105.313C39.1543 105.046 38.4181 104.909 37.6748 104.909C36.9315 104.909 36.1953 105.046 35.5086 105.313C34.8218 105.579 34.1978 105.97 33.6722 106.463C33.1466 106.956 32.7296 107.541 32.4451 108.185C32.1607 108.829 32.0144 109.519 32.0144 110.216C32.0144 110.441 31.8194 110.624 31.579 110.624C31.3385 110.624 31.1436 110.441 31.1436 110.216C31.1436 109.412 31.3129 108.615 31.6411 107.873C31.9693 107.13 32.4503 106.455 33.0567 105.886C33.6632 105.318 34.3832 104.867 35.1756 104.559C35.968 104.251 36.8171 104.093 37.6748 104.093C38.5325 104.093 39.3816 104.251 40.174 104.559C40.9664 104.867 41.6864 105.318 42.2929 105.886C42.8993 106.455 43.3803 107.13 43.7085 107.873C44.0368 108.615 44.2061 109.412 44.2061 110.216C44.2061 110.441 44.0111 110.624 43.7706 110.624C43.5302 110.624 43.3352 110.441 43.3352 110.216Z"
			fill="#58707F"
		/>
		<path
			d="M40.4635 109.703V110.03H39.0134V109.751L39.6992 109.016C39.7681 108.939 39.8224 108.872 39.8622 108.813C39.902 108.754 39.9306 108.701 39.9481 108.655C39.9666 108.607 39.9758 108.562 39.9758 108.519C39.9758 108.455 39.9651 108.4 39.9437 108.355C39.9224 108.308 39.8908 108.272 39.8491 108.247C39.8083 108.222 39.7579 108.209 39.6977 108.209C39.6336 108.209 39.5783 108.225 39.5317 108.256C39.4861 108.287 39.4512 108.33 39.4269 108.385C39.4036 108.441 39.392 108.503 39.392 108.573H38.9712C38.9712 108.447 39.0013 108.331 39.0615 108.227C39.1216 108.121 39.2066 108.037 39.3162 107.975C39.4259 107.912 39.556 107.88 39.7064 107.88C39.8549 107.88 39.9801 107.904 40.0821 107.953C40.1849 108 40.2626 108.069 40.315 108.16C40.3684 108.249 40.3951 108.356 40.3951 108.48C40.3951 108.55 40.3839 108.618 40.3616 108.685C40.3393 108.751 40.3072 108.817 40.2655 108.883C40.2247 108.948 40.1752 109.014 40.117 109.081C40.0588 109.148 39.9942 109.218 39.9234 109.289L39.555 109.703H40.4635Z"
			fill="#58707F"
		/>
		<path
			d="M38.7864 109.238V109.567H37.2592L37.2388 109.313L38.1225 107.911H38.4559L38.0949 108.515L37.6552 109.238H38.7864ZM38.5462 107.911V110.03H38.1269V107.911H38.5462Z"
			fill="#58707F"
		/>
		<path
			d="M36.611 107.906V110.03H36.1917V108.39L35.688 108.55V108.219L36.5659 107.906H36.611Z"
			fill="#58707F"
		/>
		<g filter="url(#filter3_d_20430_28757)">
			<path
				d="M36.8289 104.812C36.8289 105.159 36.5469 105.441 36.1991 105.441C35.8513 105.441 35.5693 105.159 35.5693 104.812C35.5693 104.464 35.8513 104.182 36.1991 104.182C36.5469 104.182 36.8289 104.464 36.8289 104.812Z"
				fill="#D6E4ED"
			/>
		</g>
		<g filter="url(#filter4_d_20430_28757)">
			<path
				d="M36.6941 104.811C36.6939 104.538 36.4717 104.316 36.1986 104.316C35.9256 104.317 35.704 104.538 35.7038 104.811C35.7038 105.084 35.9255 105.307 36.1986 105.307C36.4719 105.307 36.6941 105.085 36.6941 104.811ZM36.9633 104.811C36.9633 105.234 36.6209 105.576 36.1986 105.576C35.7764 105.576 35.4346 105.234 35.4346 104.811C35.4348 104.389 35.7765 104.047 36.1986 104.047C36.6208 104.047 36.9631 104.389 36.9633 104.811Z"
				fill="#58707F"
			/>
		</g>
		<path
			d="M33.4648 114.519C33.4648 113.936 33.9375 113.463 34.5205 113.463H41.4881C42.0712 113.463 42.5438 113.936 42.5438 114.519C42.5438 115.102 42.0712 115.574 41.4882 115.574H34.5205C33.9375 115.574 33.4648 115.102 33.4648 114.519Z"
			fill="#58707F"
		/>
		<rect
			x={ 49.6872 }
			y={ 94.5906 }
			width={ 17.4542 }
			height={ 24.1509 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M53.0303 98.3911C53.0303 98.0413 53.3139 97.7577 53.6637 97.7577H63.165C63.5148 97.7577 63.7984 98.0413 63.7984 98.3911C63.7984 98.7409 63.5148 99.0245 63.165 99.0245H53.6637C53.3139 99.0245 53.0303 98.7409 53.0303 98.3911Z"
			fill="#58707F"
		/>
		<path
			d="M53.875 100.925C53.875 100.575 54.1586 100.291 54.5084 100.291H62.3206C62.6704 100.291 62.954 100.575 62.954 100.925C62.954 101.275 62.6704 101.558 62.3206 101.558H54.5084C54.1586 101.558 53.875 101.275 53.875 100.925Z"
			fill="#58707F"
		/>
		<path
			d="M63.7444 110.216C63.7444 109.519 63.5981 108.829 63.3136 108.185C63.0292 107.541 62.6122 106.956 62.0866 106.463C61.5609 105.97 60.9369 105.579 60.2502 105.313C59.5634 105.046 58.8273 104.909 58.084 104.909C57.3406 104.909 56.6045 105.046 55.9178 105.313C55.231 105.579 54.607 105.97 54.0814 106.463C53.5558 106.956 53.1388 107.541 52.8543 108.185C52.5699 108.829 52.4236 109.519 52.4236 110.216C52.4236 110.441 52.2286 110.624 51.9882 110.624C51.7477 110.624 51.5527 110.441 51.5527 110.216C51.5527 109.412 51.722 108.615 52.0502 107.873C52.3785 107.13 52.8594 106.455 53.4659 105.886C54.0724 105.318 54.7924 104.867 55.5848 104.559C56.3772 104.251 57.2263 104.093 58.084 104.093C58.9417 104.093 59.7908 104.251 60.5832 104.559C61.3756 104.867 62.0956 105.318 62.702 105.886C63.3085 106.455 63.7895 107.13 64.1177 107.873C64.4459 108.615 64.6152 109.412 64.6152 110.216C64.6152 110.441 64.4203 110.624 64.1798 110.624C63.9393 110.624 63.7444 110.441 63.7444 110.216Z"
			fill="#58707F"
		/>
		<path
			d="M60.8737 109.703V110.03H59.4236V109.751L60.1093 109.016C60.1782 108.939 60.2326 108.872 60.2724 108.813C60.3122 108.754 60.3408 108.701 60.3583 108.655C60.3767 108.607 60.3859 108.562 60.3859 108.519C60.3859 108.455 60.3753 108.4 60.3539 108.355C60.3325 108.308 60.301 108.272 60.2593 108.247C60.2185 108.222 60.168 108.209 60.1079 108.209C60.0438 108.209 59.9885 108.225 59.9419 108.256C59.8963 108.287 59.8613 108.33 59.8371 108.385C59.8138 108.441 59.8021 108.503 59.8021 108.573H59.3813C59.3813 108.447 59.4114 108.331 59.4716 108.227C59.5318 108.121 59.6167 108.037 59.7264 107.975C59.8361 107.912 59.9661 107.88 60.1166 107.88C60.2651 107.88 60.3903 107.904 60.4922 107.953C60.5951 108 60.6727 108.069 60.7252 108.16C60.7785 108.249 60.8052 108.356 60.8052 108.48C60.8052 108.55 60.7941 108.618 60.7718 108.685C60.7494 108.751 60.7174 108.817 60.6757 108.883C60.6349 108.948 60.5854 109.014 60.5272 109.081C60.4689 109.148 60.4044 109.218 60.3335 109.289L59.9652 109.703H60.8737Z"
			fill="#58707F"
		/>
		<path
			d="M59.1966 109.238V109.567H57.6693L57.6489 109.313L58.5327 107.911H58.8661L58.505 108.515L58.0653 109.238H59.1966ZM58.9563 107.911V110.03H58.537V107.911H58.9563Z"
			fill="#58707F"
		/>
		<path
			d="M57.0217 107.906V110.03H56.6024V108.39L56.0986 108.55V108.219L56.9766 107.906H57.0217Z"
			fill="#58707F"
		/>
		<g filter="url(#filter5_d_20430_28757)">
			<path
				d="M57.239 104.812C57.239 105.159 56.9571 105.441 56.6093 105.441C56.2614 105.441 55.9795 105.159 55.9795 104.812C55.9795 104.464 56.2614 104.182 56.6093 104.182C56.9571 104.182 57.239 104.464 57.239 104.812Z"
				fill="#D6E4ED"
			/>
		</g>
		<g filter="url(#filter6_d_20430_28757)">
			<path
				d="M57.1048 104.811C57.1046 104.538 56.8824 104.316 56.6092 104.316C56.3362 104.317 56.1146 104.538 56.1144 104.811C56.1144 105.084 56.3361 105.307 56.6092 105.307C56.8825 105.307 57.1048 105.085 57.1048 104.811ZM57.374 104.811C57.374 105.234 57.0316 105.576 56.6092 105.576C56.1871 105.576 55.8452 105.234 55.8452 104.811C55.8454 104.389 56.1872 104.047 56.6092 104.047C57.0315 104.047 57.3738 104.389 57.374 104.811Z"
				fill="#58707F"
			/>
		</g>
		<path
			d="M53.875 114.519C53.875 113.935 54.3477 113.463 54.9307 113.463H61.8983C62.4814 113.463 62.954 113.935 62.954 114.519C62.954 115.102 62.4814 115.574 61.8983 115.574H54.9307C54.3477 115.574 53.875 115.102 53.875 114.519Z"
			fill="#58707F"
		/>
		<defs>
			<clipPath
				id="bgblur_0_20430_28757_clip_path"
				transform="translate(-53.1116 -7.60065)"
			>
				<rect
					x={ 54.4838 }
					y={ 8.97307 }
					width={ 12.5526 }
					height={ 4.64507 }
					rx={ 0.738989 }
				/>
			</clipPath>
			<filter
				id="filter1_d_20430_28757"
				x={ 15.0576 }
				y={ 104.08 }
				width={ 1.66797 }
				height={ 1.66772 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.102051 } dy={ 0.102051 } />
				<feGaussianBlur stdDeviation={ 0.102051 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28757"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28757"
					result="shape"
				/>
			</filter>
			<filter
				id="filter2_d_20430_28757"
				x={ 14.9229 }
				y={ 103.945 }
				width={ 1.93701 }
				height={ 1.93695 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.102051 } dy={ 0.102051 } />
				<feGaussianBlur stdDeviation={ 0.102051 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28757"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28757"
					result="shape"
				/>
			</filter>
			<filter
				id="filter3_d_20430_28757"
				x={ 35.4673 }
				y={ 104.08 }
				width={ 1.66797 }
				height={ 1.66772 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.102051 } dy={ 0.102051 } />
				<feGaussianBlur stdDeviation={ 0.102051 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28757"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28757"
					result="shape"
				/>
			</filter>
			<filter
				id="filter4_d_20430_28757"
				x={ 35.3325 }
				y={ 103.945 }
				width={ 1.93701 }
				height={ 1.93695 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.102051 } dy={ 0.102051 } />
				<feGaussianBlur stdDeviation={ 0.102051 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28757"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28757"
					result="shape"
				/>
			</filter>
			<filter
				id="filter5_d_20430_28757"
				x={ 55.8774 }
				y={ 104.08 }
				width={ 1.66797 }
				height={ 1.66772 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.102051 } dy={ 0.102051 } />
				<feGaussianBlur stdDeviation={ 0.102051 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28757"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28757"
					result="shape"
				/>
			</filter>
			<filter
				id="filter6_d_20430_28757"
				x={ 55.7432 }
				y={ 103.945 }
				width={ 1.93701 }
				height={ 1.93695 }
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={ 0 } result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dx={ 0.102051 } dy={ 0.102051 } />
				<feGaussianBlur stdDeviation={ 0.102051 } />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_20430_28757"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_20430_28757"
					result="shape"
				/>
			</filter>
			<clipPath id="clip1_20430_28757">
				<rect
					x={ 10.7671 }
					y={ 33.7685 }
					width={ 54.474 }
					height={ 0.844559 }
					rx={ 0.422279 }
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
);

export const AqiMinimalSixIcon = ( { isPopup = false } ) => (
	<svg
		width={ isPopup ? 102 : 76 }
		height={ isPopup ? 172 : 128 }
		viewBox="0 0 76 128"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x={ 0.558824 }
			y={ 0.558824 }
			width={ 74.8824 }
			height={ 126.882 }
			rx={ 1.67647 }
			fill="white"
		/>
		<rect
			x={ 0.558824 }
			y={ 0.558824 }
			width={ 74.8824 }
			height={ 126.882 }
			rx={ 1.67647 }
			stroke="#8796A1"
			strokeWidth={ 1.11765 }
		/>
		<path
			d="M4.43408 6.25544C4.43408 5.26012 4.43408 4.76246 4.74329 4.45325C5.0525 4.14404 5.55016 4.14404 6.54548 4.14404H69.4651C70.4604 4.14404 70.9581 4.14404 71.2673 4.45325C71.5765 4.76246 71.5765 5.26012 71.5765 6.25544V121.538C71.5765 122.533 71.5765 123.031 71.2673 123.34C70.9581 123.649 70.4604 123.649 69.4651 123.649H6.54548C5.55016 123.649 5.0525 123.649 4.74329 123.34C4.43408 123.031 4.43408 122.533 4.43408 121.538V6.25544Z"
			fill="white"
		/>
		<path
			d="M69.465 122.919V123.649H6.54568V122.919H69.465ZM70.846 121.538V6.25564C70.846 5.73761 70.8446 5.42221 70.814 5.19475C70.7999 5.08965 70.7825 5.03279 70.7704 5.00338C70.7607 4.97992 70.7545 4.97371 70.7507 4.96991C70.7469 4.96611 70.7408 4.95994 70.7172 4.95026C70.6879 4.93817 70.6311 4.92074 70.5259 4.9066C70.2984 4.87605 69.9831 4.87459 69.465 4.87459H6.54568C6.02764 4.87459 5.71225 4.87607 5.48479 4.9066C5.37965 4.92074 5.32282 4.93817 5.29342 4.95026C5.26986 4.95995 5.26375 4.96611 5.25995 4.96991C5.25615 4.97371 5.24999 4.97982 5.2403 5.00338C5.22821 5.03278 5.21078 5.08962 5.19664 5.19475C5.16611 5.42221 5.16463 5.7376 5.16463 6.25564V121.538C5.16463 122.056 5.16608 122.371 5.19664 122.599C5.21078 122.704 5.22821 122.761 5.2403 122.79C5.24995 122.813 5.25616 122.82 5.25995 122.823C5.26376 122.827 5.2701 122.834 5.29342 122.843C5.32284 122.855 5.37976 122.873 5.48479 122.887C5.71224 122.917 6.02766 122.919 6.54568 122.919V123.649L5.88717 123.644C5.36105 123.631 5.03327 123.581 4.80372 123.395L4.74333 123.34C4.5114 123.108 4.45366 122.77 4.43918 122.196L4.43408 121.538V6.25564C4.43408 5.32268 4.4341 4.82679 4.68875 4.51368L4.74333 4.45329C4.97519 4.22142 5.31299 4.16364 5.88717 4.14914L6.54568 4.14404H69.465C70.4603 4.14404 70.9581 4.14408 71.2673 4.45329C71.5765 4.7625 71.5766 5.26037 71.5766 6.25564V121.538L71.5715 122.196C71.557 122.77 71.4993 123.108 71.2673 123.34L71.2069 123.395C70.9773 123.581 70.6493 123.631 70.1228 123.644L69.465 123.649V122.919C69.9831 122.919 70.2984 122.917 70.5259 122.887C70.631 122.873 70.6879 122.855 70.7172 122.843C70.7407 122.833 70.7469 122.827 70.7507 122.823C70.7545 122.82 70.7607 122.813 70.7704 122.79C70.7825 122.761 70.7999 122.704 70.814 122.599C70.8446 122.371 70.846 122.056 70.846 121.538Z"
			fill="#58707F"
		/>
		<path
			d="M21.1133 9.81775C21.1133 9.05979 21.7277 8.44534 22.4857 8.44534H51.8341C52.5921 8.44534 53.2065 9.05979 53.2065 9.81775C53.2065 10.5757 52.5921 11.1902 51.8341 11.1902H22.4857C21.7277 11.1902 21.1133 10.5757 21.1133 9.81775Z"
			fill="#58707F"
		/>
		<path
			d="M24.2803 13.4071C24.2803 12.999 24.6111 12.6682 25.0193 12.6682H38.1099C38.5181 12.6682 38.8489 12.999 38.8489 13.4071C38.8489 13.8153 38.5181 14.1461 38.1099 14.1461H25.0193C24.6111 14.1461 24.2803 13.8153 24.2803 13.4071Z"
			fill="#58707F"
		/>
		<path
			d="M39.6934 13.4071C39.6934 12.999 40.0242 12.6682 40.4323 12.6682H49.3002C49.7083 12.6682 50.0392 12.999 50.0392 13.4071C50.0392 13.8153 49.7083 14.1461 49.3002 14.1461H40.4323C40.0242 14.1461 39.6934 13.8153 39.6934 13.4071Z"
			fill="#58707F"
		/>
		<rect
			x={ 8.86739 }
			y={ 65.6642 }
			width={ 58.2745 }
			height={ 12.035 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M11.1899 68.9369C11.1899 68.6454 11.4263 68.409 11.7178 68.409H64.2916C64.5831 68.409 64.8194 68.6454 64.8194 68.9369C64.8194 69.2284 64.5831 69.4647 64.2916 69.4647H11.7178C11.4263 69.4647 11.1899 69.2284 11.1899 68.9369Z"
			fill="#58707F"
		/>
		<path
			d="M11.1899 71.6817C11.1899 71.3902 11.4263 71.1538 11.7178 71.1538H63.0247C63.3162 71.1538 63.5526 71.3902 63.5526 71.6817C63.5526 71.9732 63.3162 72.2095 63.0247 72.2095H11.7178C11.4263 72.2095 11.1899 71.9732 11.1899 71.6817Z"
			fill="#58707F"
		/>
		<path
			d="M11.1899 74.4265C11.1899 74.135 11.4263 73.8987 11.7178 73.8987H55.2126C55.5041 73.8987 55.7404 74.135 55.7404 74.4265C55.7404 74.718 55.5041 74.9543 55.2126 74.9543H11.7178C11.4263 74.9543 11.1899 74.718 11.1899 74.4265Z"
			fill="#58707F"
		/>
		<rect
			x={ 8.86739 }
			y={ 35.8937 }
			width={ 58.2745 }
			height={ 24.9145 }
			rx={ 0.633419 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M12.2456 39.5887C12.2456 39.4138 12.3874 39.272 12.5623 39.272C12.7372 39.272 12.879 39.4138 12.879 39.5887V45.2895C12.879 45.4644 12.7372 45.6062 12.5623 45.6062C12.3874 45.6062 12.2456 45.4644 12.2456 45.2895V39.5887Z"
			fill="#58707F"
		/>
		<path
			d="M14.5684 40.4331C14.5684 40.0249 14.8992 39.6941 15.3073 39.6941H19.9524C20.3606 39.6941 20.6914 40.0249 20.6914 40.4331C20.6914 40.8412 20.3606 41.172 19.9524 41.172H15.3073C14.8992 41.172 14.5684 40.8412 14.5684 40.4331Z"
			fill="#58707F"
		/>
		<path
			d="M14.5684 44.4447C14.5684 44.0366 14.8992 43.7057 15.3073 43.7057H23.9641C24.3722 43.7057 24.7031 44.0366 24.7031 44.4447C24.7031 44.8528 24.3722 45.1837 23.9641 45.1837H15.3073C14.8992 45.1837 14.5684 44.8528 14.5684 44.4447Z"
			fill="#58707F"
		/>
		<path
			d="M31.6968 39.5887C31.6968 39.4138 31.8386 39.272 32.0135 39.272C32.1884 39.272 32.3302 39.4138 32.3302 39.5887V45.2895C32.3302 45.4644 32.1884 45.6062 32.0135 45.6062C31.8386 45.6062 31.6968 45.4644 31.6968 45.2895V39.5887Z"
			fill="#58707F"
		/>
		<path
			d="M34.1777 40.3278C34.1777 39.9196 34.5086 39.5888 34.9167 39.5888H39.5618C39.9699 39.5888 40.3008 39.9196 40.3008 40.3278C40.3008 40.7359 39.9699 41.0668 39.5618 41.0668H34.9167C34.5086 41.0668 34.1777 40.7359 34.1777 40.3278Z"
			fill="#58707F"
		/>
		<path
			d="M34.1777 44.3394C34.1777 43.9313 34.5086 43.6004 34.9167 43.6004H43.5734C43.9816 43.6004 44.3124 43.9313 44.3124 44.3394C44.3124 44.7475 43.9816 45.0784 43.5734 45.0784H34.9167C34.5086 45.0784 34.1777 44.7475 34.1777 44.3394Z"
			fill="#58707F"
		/>
		<path
			d="M51.3062 39.5887C51.3062 39.4138 51.4479 39.272 51.6229 39.272C51.7978 39.272 51.9396 39.4138 51.9396 39.5887V45.2895C51.9396 45.4644 51.7978 45.6062 51.6229 45.6062C51.4479 45.6062 51.3062 45.4644 51.3062 45.2895V39.5887Z"
			fill="#58707F"
		/>
		<path
			d="M53.6289 40.3278C53.6289 39.9196 53.9598 39.5888 54.3679 39.5888H59.013C59.4211 39.5888 59.752 39.9196 59.752 40.3278C59.752 40.7359 59.4211 41.0668 59.013 41.0668H54.3679C53.9598 41.0668 53.6289 40.7359 53.6289 40.3278Z"
			fill="#58707F"
		/>
		<path
			d="M53.6289 44.3394C53.6289 43.9313 53.9598 43.6004 54.3679 43.6004H63.0246C63.4328 43.6004 63.7636 43.9313 63.7636 44.3394C63.7636 44.7475 63.4328 45.0784 63.0246 45.0784H54.3679C53.9598 45.0784 53.6289 44.7475 53.6289 44.3394Z"
			fill="#58707F"
		/>
		<path
			d="M12.2456 51.4124C12.2456 51.2375 12.3874 51.0957 12.5623 51.0957C12.7372 51.0957 12.879 51.2375 12.879 51.4124V57.1132C12.879 57.2881 12.7372 57.4299 12.5623 57.4299C12.3874 57.4299 12.2456 57.2881 12.2456 57.1132V51.4124Z"
			fill="#58707F"
		/>
		<path
			d="M14.5684 52.2568C14.5684 51.8486 14.8992 51.5178 15.3073 51.5178H19.9524C20.3606 51.5178 20.6914 51.8486 20.6914 52.2568C20.6914 52.6649 20.3606 52.9958 19.9524 52.9958H15.3073C14.8992 52.9958 14.5684 52.6649 14.5684 52.2568Z"
			fill="#58707F"
		/>
		<path
			d="M14.5684 56.2684C14.5684 55.8603 14.8992 55.5294 15.3073 55.5294H23.9641C24.3722 55.5294 24.7031 55.8603 24.7031 56.2684C24.7031 56.6766 24.3722 57.0074 23.9641 57.0074H15.3073C14.8992 57.0074 14.5684 56.6766 14.5684 56.2684Z"
			fill="#58707F"
		/>
		<path
			d="M31.6968 51.4124C31.6968 51.2375 31.8386 51.0957 32.0135 51.0957C32.1884 51.0957 32.3302 51.2375 32.3302 51.4124V57.1132C32.3302 57.2881 32.1884 57.4299 32.0135 57.4299C31.8386 57.4299 31.6968 57.2881 31.6968 57.1132V51.4124Z"
			fill="#58707F"
		/>
		<path
			d="M34.1777 52.2568C34.1777 51.8486 34.5086 51.5178 34.9167 51.5178H39.5618C39.9699 51.5178 40.3008 51.8486 40.3008 52.2568C40.3008 52.6649 39.9699 52.9958 39.5618 52.9958H34.9167C34.5086 52.9958 34.1777 52.6649 34.1777 52.2568Z"
			fill="#58707F"
		/>
		<path
			d="M34.1777 56.2684C34.1777 55.8603 34.5086 55.5294 34.9167 55.5294H43.5734C43.9816 55.5294 44.3124 55.8603 44.3124 56.2684C44.3124 56.6766 43.9816 57.0074 43.5734 57.0074H34.9167C34.5086 57.0074 34.1777 56.6766 34.1777 56.2684Z"
			fill="#58707F"
		/>
		<path
			d="M51.3062 51.4124C51.3062 51.2375 51.4479 51.0957 51.6229 51.0957C51.7978 51.0957 51.9396 51.2375 51.9396 51.4124V57.1132C51.9396 57.2881 51.7978 57.4299 51.6229 57.4299C51.4479 57.4299 51.3062 57.2881 51.3062 57.1132V51.4124Z"
			fill="#58707F"
		/>
		<path
			d="M53.6289 52.2568C53.6289 51.8486 53.9598 51.5178 54.3679 51.5178H59.013C59.4211 51.5178 59.752 51.8486 59.752 52.2568C59.752 52.6649 59.4211 52.9958 59.013 52.9958H54.3679C53.9598 52.9958 53.6289 52.6649 53.6289 52.2568Z"
			fill="#58707F"
		/>
		<path
			d="M53.6289 56.2684C53.6289 55.8603 53.9598 55.5294 54.3679 55.5294H63.0246C63.4328 55.5294 63.7636 55.8603 63.7636 56.2684C63.7636 56.6766 63.4328 57.0074 63.0246 57.0074H54.3679C53.9598 57.0074 53.6289 56.6766 53.6289 56.2684Z"
			fill="#58707F"
		/>
		<path
			d="M10.7676 21.9581C10.7676 22.5411 10.295 23.0138 9.71195 23.0138C9.1289 23.0138 8.65625 22.5411 8.65625 21.9581C8.65625 21.375 9.1289 20.9024 9.71195 20.9024C10.295 20.9024 10.7676 21.375 10.7676 21.9581Z"
			fill="#D6E4ED"
		/>
		<path
			d="M10.6003 22.2128C10.6003 22.5626 10.3167 22.8462 9.96692 22.8462C9.61709 22.8462 9.3335 22.5626 9.3335 22.2128C9.3335 21.8629 9.61709 21.5793 9.96692 21.5793C10.3167 21.5793 10.6003 21.8629 10.6003 22.2128Z"
			fill="#58707F"
		/>
		<path
			d="M11.6123 21.9584C11.6123 21.926 11.6123 21.9099 11.6127 21.8962C11.6272 21.3538 12.0634 20.9176 12.6058 20.9031C12.6194 20.9027 12.6356 20.9027 12.668 20.9027H19.2133C19.2457 20.9027 19.2619 20.9027 19.2756 20.9031C19.8179 20.9176 20.2541 21.3538 20.2687 21.8962C20.269 21.9099 20.269 21.926 20.269 21.9584C20.269 21.9908 20.269 22.007 20.2687 22.0206C20.2541 22.563 19.8179 22.9992 19.2756 23.0137C19.2619 23.0141 19.2457 23.0141 19.2133 23.0141H12.668C12.6356 23.0141 12.6194 23.0141 12.6058 23.0137C12.0634 22.9992 11.6272 22.563 11.6127 22.0206C11.6123 22.007 11.6123 21.9908 11.6123 21.9584Z"
			fill="#58707F"
		/>
		<path
			d="M13.7406 26.5572L13.0162 26.3821L13.2943 23.8587H16.0443V24.6106H14.0462L13.9157 25.7778C13.9867 25.7344 14.0897 25.6909 14.2247 25.6474C14.362 25.6016 14.5165 25.5787 14.6882 25.5787C14.9262 25.5787 15.1391 25.6176 15.3268 25.6954C15.5144 25.771 15.6735 25.8808 15.804 26.025C15.9367 26.1692 16.0363 26.3455 16.1027 26.5537C16.1713 26.7597 16.2057 26.9932 16.2057 27.2541C16.2057 27.483 16.1713 27.6981 16.1027 27.8995C16.0363 28.0987 15.9344 28.276 15.7971 28.4317C15.6598 28.585 15.487 28.7063 15.2787 28.7956C15.0704 28.8826 14.8255 28.9261 14.544 28.9261C14.3311 28.9261 14.1263 28.8952 13.9295 28.8334C13.7349 28.7693 13.5598 28.6766 13.4042 28.5553C13.2485 28.4317 13.1238 28.2806 13.03 28.1021C12.9384 27.9236 12.8881 27.7187 12.8789 27.4876H13.775C13.791 27.6409 13.8322 27.7714 13.8986 27.8789C13.9649 27.9865 14.0519 28.0689 14.1595 28.1261C14.2693 28.1833 14.3964 28.212 14.5406 28.212C14.671 28.212 14.7832 28.1879 14.877 28.1399C14.9731 28.0895 15.0521 28.0197 15.1139 27.9304C15.1757 27.8412 15.2215 27.7359 15.2512 27.6146C15.281 27.4933 15.2959 27.3605 15.2959 27.2163C15.2959 27.0767 15.2787 26.9497 15.2444 26.8353C15.21 26.7185 15.1574 26.6178 15.0864 26.5331C15.0155 26.4485 14.9262 26.3832 14.8187 26.3374C14.7134 26.2917 14.5898 26.2688 14.4479 26.2688C14.2579 26.2688 14.1114 26.2974 14.0084 26.3546C13.9077 26.4118 13.8185 26.4794 13.7406 26.5572Z"
			fill="#58707F"
		/>
		<path
			d="M12.2954 27.0344V27.7485H8.69401L8.65625 27.1992L10.7745 23.8587H11.4989L10.7162 25.1873L9.57978 27.0344H12.2954ZM11.7015 23.8587V28.8574H10.7917V23.8587H11.7015Z"
			fill="#58707F"
		/>
		<path
			d="M47.1367 31.249C47.1367 29.8973 46.8703 28.5584 46.3531 27.3096C45.8358 26.0608 45.0772 24.9263 44.1214 23.9705C43.1656 23.0148 42.031 22.2568 40.7823 21.7396C39.5336 21.2223 38.1952 20.9559 36.8436 20.9559C35.4919 20.9559 34.153 21.2223 32.9042 21.7396C31.6555 22.2568 30.5208 23.0148 29.5651 23.9705C28.6093 24.9262 27.8514 26.0609 27.3341 27.3096C26.8169 28.5584 26.5505 29.8973 26.5505 31.249H24.1747C24.1747 29.5854 24.5029 27.9378 25.1396 26.4008C25.7762 24.8638 26.7093 23.4675 27.8857 22.2911C29.062 21.1148 30.4584 20.1817 31.9954 19.545C33.5324 18.9084 35.18 18.5802 36.8436 18.5802C38.5071 18.5802 40.1542 18.9084 41.6911 19.545C43.2281 20.1817 44.6251 21.1147 45.8015 22.2911C46.9778 23.4674 47.911 24.8639 48.5476 26.4008C49.1842 27.9378 49.5117 29.5854 49.5117 31.249H47.1367Z"
			fill="#58707F"
		/>
		<path
			d="M37.0203 30.9451L37.0225 21.7798L37.5257 30.8874L37.0203 30.9451Z"
			fill="#58707F"
		/>
		<path
			d="M37.5258 30.8873L37.0205 30.945L37.0225 21.7798L37.5258 30.8873ZM37.1173 30.8353L37.4228 30.8008L37.1191 25.3043L37.1173 30.8353Z"
			fill="#58707F"
		/>
		<path
			d="M37.4547 31.1758C37.4547 31.4455 37.236 31.6641 36.9664 31.6641C36.6967 31.6641 36.478 31.4455 36.478 31.1758C36.478 30.9061 36.6967 30.6874 36.9664 30.6874C37.236 30.6874 37.4547 30.9061 37.4547 31.1758Z"
			fill="white"
		/>
		<path
			d="M37.2596 31.1758C37.2596 31.014 37.1282 30.8825 36.9664 30.8825C36.8046 30.8825 36.6731 31.014 36.6731 31.1758C36.6731 31.3376 36.8045 31.469 36.9664 31.469V31.6641C36.6966 31.664 36.478 31.4455 36.478 31.1758C36.4781 30.9061 36.6967 30.6875 36.9664 30.6874C37.2361 30.6874 37.4546 30.9061 37.4547 31.1758C37.4547 31.4455 37.2361 31.6641 36.9664 31.6641V31.469C37.1282 31.469 37.2596 31.3376 37.2596 31.1758Z"
			fill="#58707F"
		/>
		<path
			d="M53.418 21.6417C53.418 21.6093 53.418 21.5931 53.4183 21.5795C53.4329 21.0371 53.8691 20.6009 54.4114 20.5864C54.4251 20.586 54.4413 20.586 54.4737 20.586H66.2975C66.3299 20.586 66.346 20.586 66.3597 20.5864C66.9021 20.6009 67.3383 21.0371 67.3528 21.5795C67.3532 21.5931 67.3532 21.6093 67.3532 21.6417C67.3532 21.6741 67.3532 21.6903 67.3528 21.7039C67.3383 22.2463 66.9021 22.6825 66.3597 22.697C66.346 22.6974 66.3299 22.6974 66.2975 22.6974H54.4737C54.4413 22.6974 54.4251 22.6974 54.4114 22.697C53.8691 22.6825 53.4329 22.2463 53.4183 21.7039C53.418 21.6903 53.418 21.6741 53.418 21.6417Z"
			fill="#58707F"
		/>
		<foreignObject
			x={ 53.5339 }
			y={ 23.3308 }
			width={ 15.2973 }
			height={ 7.38991 }
		>
			<div
				xmlns="http://www.w3.org/1999/xhtml"
				style={ {
					backdropFilter: 'blur(0.63px)',
					clipPath: 'url(#bgblur_0_20430_28758_clip_path)',
					height: '100%',
					width: '100%',
				} }
			/>
		</foreignObject>
		<g data-figma-bg-blur-radius={ 1.26684 }>
			<rect
				x={ 54.9061 }
				y={ 24.7032 }
				width={ 12.5526 }
				height={ 4.64507 }
				rx={ 0.738989 }
				fill="#D6E4ED"
			/>
			<rect
				x={ 54.9061 }
				y={ 24.7032 }
				width={ 12.5526 }
				height={ 4.64507 }
				rx={ 0.738989 }
				stroke="#58707F"
				strokeWidth={ 0.21114 }
			/>
			<path
				d="M63.5315 26.814V27.988H63.2085V26.5379H63.5168L63.5315 26.814ZM63.9751 26.5285L63.9724 26.8287C63.9528 26.8251 63.9313 26.8225 63.9081 26.8207C63.8858 26.8189 63.8634 26.818 63.8411 26.818C63.7857 26.818 63.737 26.826 63.695 26.8421C63.653 26.8573 63.6177 26.8796 63.5891 26.9091C63.5614 26.9377 63.54 26.9726 63.5248 27.0137C63.5096 27.0548 63.5007 27.1008 63.498 27.1517L63.4243 27.1571C63.4243 27.0659 63.4332 26.9815 63.4511 26.9038C63.4689 26.826 63.4958 26.7577 63.5315 26.6987C63.5681 26.6397 63.6137 26.5937 63.6682 26.5607C63.7236 26.5276 63.7875 26.5111 63.8599 26.5111C63.8795 26.5111 63.9005 26.5129 63.9228 26.5164C63.9461 26.52 63.9635 26.524 63.9751 26.5285Z"
				fill="#58707F"
			/>
			<path
				d="M61.5879 27.279V27.2482C61.5879 27.1437 61.6031 27.0467 61.6335 26.9574C61.6638 26.8671 61.7076 26.789 61.7648 26.7228C61.8229 26.6558 61.8935 26.604 61.9766 26.5674C62.0605 26.5298 62.1553 26.5111 62.2607 26.5111C62.367 26.5111 62.4617 26.5298 62.5448 26.5674C62.6288 26.604 62.6998 26.6558 62.7579 26.7228C62.816 26.789 62.8602 26.8671 62.8906 26.9574C62.921 27.0467 62.9362 27.1437 62.9362 27.2482V27.279C62.9362 27.3836 62.921 27.4805 62.8906 27.5699C62.8602 27.6592 62.816 27.7374 62.7579 27.8044C62.6998 27.8705 62.6293 27.9224 62.5462 27.9599C62.4631 27.9965 62.3688 28.0148 62.2634 28.0148C62.157 28.0148 62.0619 27.9965 61.9779 27.9599C61.8948 27.9224 61.8242 27.8705 61.7661 27.8044C61.7081 27.7374 61.6638 27.6592 61.6335 27.5699C61.6031 27.4805 61.5879 27.3836 61.5879 27.279ZM61.9109 27.2482V27.279C61.9109 27.3443 61.9176 27.4059 61.931 27.464C61.9444 27.5221 61.9654 27.573 61.994 27.6168C62.0226 27.6606 62.0592 27.695 62.1039 27.72C62.1486 27.745 62.2017 27.7575 62.2634 27.7575C62.3232 27.7575 62.3751 27.745 62.4188 27.72C62.4635 27.695 62.5001 27.6606 62.5287 27.6168C62.5573 27.573 62.5783 27.5221 62.5917 27.464C62.606 27.4059 62.6132 27.3443 62.6132 27.279V27.2482C62.6132 27.1839 62.606 27.1231 62.5917 27.0659C62.5783 27.0079 62.5569 26.9565 62.5274 26.9118C62.4988 26.8671 62.4622 26.8323 62.4175 26.8073C62.3737 26.7814 62.3214 26.7684 62.2607 26.7684C62.1999 26.7684 62.1472 26.7814 62.1025 26.8073C62.0588 26.8323 62.0226 26.8671 61.994 26.9118C61.9654 26.9565 61.9444 27.0079 61.931 27.0659C61.9176 27.1231 61.9109 27.1839 61.9109 27.2482Z"
				fill="#58707F"
			/>
			<path
				d="M60.0308 27.279V27.2482C60.0308 27.1437 60.046 27.0467 60.0763 26.9574C60.1067 26.8671 60.1505 26.789 60.2077 26.7228C60.2658 26.6558 60.3363 26.604 60.4194 26.5674C60.5034 26.5298 60.5981 26.5111 60.7036 26.5111C60.8099 26.5111 60.9046 26.5298 60.9877 26.5674C61.0717 26.604 61.1427 26.6558 61.2008 26.7228C61.2589 26.789 61.3031 26.8671 61.3335 26.9574C61.3639 27.0467 61.379 27.1437 61.379 27.2482V27.279C61.379 27.3836 61.3639 27.4805 61.3335 27.5699C61.3031 27.6592 61.2589 27.7374 61.2008 27.8044C61.1427 27.8705 61.0721 27.9224 60.989 27.9599C60.9059 27.9965 60.8117 28.0148 60.7062 28.0148C60.5999 28.0148 60.5048 27.9965 60.4208 27.9599C60.3377 27.9224 60.2671 27.8705 60.209 27.8044C60.1509 27.7374 60.1067 27.6592 60.0763 27.5699C60.046 27.4805 60.0308 27.3836 60.0308 27.279ZM60.3538 27.2482V27.279C60.3538 27.3443 60.3605 27.4059 60.3739 27.464C60.3873 27.5221 60.4083 27.573 60.4369 27.6168C60.4654 27.6606 60.5021 27.695 60.5468 27.72C60.5914 27.745 60.6446 27.7575 60.7062 27.7575C60.7661 27.7575 60.8179 27.745 60.8617 27.72C60.9064 27.695 60.943 27.6606 60.9716 27.6168C61.0002 27.573 61.0212 27.5221 61.0346 27.464C61.0489 27.4059 61.056 27.3443 61.056 27.279V27.2482C61.056 27.1839 61.0489 27.1231 61.0346 27.0659C61.0212 27.0079 60.9998 26.9565 60.9703 26.9118C60.9417 26.8671 60.905 26.8323 60.8604 26.8073C60.8166 26.7814 60.7643 26.7684 60.7036 26.7684C60.6428 26.7684 60.5901 26.7814 60.5454 26.8073C60.5016 26.8323 60.4654 26.8671 60.4369 26.9118C60.4083 26.9565 60.3873 27.0079 60.3739 27.0659C60.3605 27.1231 60.3538 27.1839 60.3538 27.2482Z"
				fill="#58707F"
			/>
			<path
				d="M59.1313 27.2603H58.6233V26.9936H59.1313C59.2197 26.9936 59.2912 26.9793 59.3457 26.9507C59.4002 26.9221 59.44 26.8828 59.465 26.8327C59.4909 26.7818 59.5039 26.7237 59.5039 26.6585C59.5039 26.5968 59.4909 26.5392 59.465 26.4856C59.44 26.4311 59.4002 26.3873 59.3457 26.3543C59.2912 26.3212 59.2197 26.3047 59.1313 26.3047H58.7265V27.988H58.3901V26.0366H59.1313C59.2823 26.0366 59.4105 26.0634 59.5159 26.117C59.6223 26.1698 59.7031 26.243 59.7585 26.3368C59.8139 26.4298 59.8416 26.5361 59.8416 26.6558C59.8416 26.7818 59.8139 26.8899 59.7585 26.9802C59.7031 27.0704 59.6223 27.1396 59.5159 27.1879C59.4105 27.2361 59.2823 27.2603 59.1313 27.2603Z"
				fill="#58707F"
			/>
		</g>
		<g clipPath="url(#clip1_20430_28758)">
			<g clipPath="url(#clip2_20430_28758)">
				<path
					d="M10.7676 93.9052C10.7676 93.672 10.9566 93.4829 11.1899 93.4829C11.4231 93.4829 11.6121 93.672 11.6121 93.9052V97.2835C11.6121 97.5167 11.4231 97.7057 11.1899 97.7057C10.9566 97.7057 10.7676 97.5167 10.7676 97.2835V93.9052Z"
					fill="#58707F"
				/>
				<path
					d="M14.8848 95.6998H12.7732V95.4888H14.8848V95.6998Z"
					fill="#58707F"
				/>
				<path
					d="M10.7676 100.028C10.7676 99.795 10.9566 99.606 11.1899 99.606C11.4231 99.606 11.6121 99.795 11.6121 100.028V102.562C11.6121 102.795 11.4231 102.984 11.1899 102.984C10.9566 102.984 10.7676 102.795 10.7676 102.562V100.028Z"
					fill="#58707F"
				/>
				<path
					d="M14.8848 101.401H12.7732V101.19H14.8848V101.401Z"
					fill="#58707F"
				/>
				<path
					d="M10.7676 106.151C10.7676 105.918 10.9566 105.729 11.1899 105.729C11.4231 105.729 11.6121 105.918 11.6121 106.151V109.107C11.6121 109.34 11.4231 109.529 11.1899 109.529C10.9566 109.529 10.7676 109.34 10.7676 109.107V106.151Z"
					fill="#58707F"
				/>
				<path
					d="M14.8848 107.735H12.7732V107.524H14.8848V107.735Z"
					fill="#58707F"
				/>
				<path
					d="M10.7676 111.43C10.7676 111.196 10.9566 111.007 11.1899 111.007C11.4231 111.007 11.6121 111.196 11.6121 111.43V113.752C11.6121 113.985 11.4231 114.175 11.1899 114.175C10.9566 114.175 10.7676 113.985 10.7676 113.752V111.43Z"
					fill="#58707F"
				/>
				<path
					d="M14.8848 112.696H12.7732V112.485H14.8848V112.696Z"
					fill="#58707F"
				/>
			</g>
			<path
				d="M14.9897 90.1051L15.2008 90.1051L15.2008 112.486L14.9897 112.486L14.9897 90.1051Z"
				fill="#58707F"
			/>
			<path
				d="M16.8901 94.9612C16.8901 94.4948 17.2683 94.1167 17.7347 94.1167H19.2127C19.6791 94.1167 20.0572 94.4948 20.0572 94.9612V112.697H16.8901V94.9612Z"
				fill="#58707F"
			/>
			<path
				d="M23.1641 98.1283C23.1641 97.6619 23.5422 97.2838 24.0086 97.2838H25.4866C25.953 97.2838 26.3312 97.6619 26.3312 98.1283V112.697H23.1641V98.1283Z"
				fill="#58707F"
			/>
			<path
				d="M29.4375 94.3279C29.4375 93.8615 29.8156 93.4834 30.2821 93.4834H31.76C32.2265 93.4834 32.6046 93.8615 32.6046 94.3279V112.697H29.4375V94.3279Z"
				fill="#58707F"
			/>
			<path
				d="M35.7119 103.829C35.7119 103.363 36.09 102.985 36.5565 102.985H38.0344C38.5009 102.985 38.879 103.363 38.879 103.829V112.697H35.7119V103.829Z"
				fill="#58707F"
			/>
			<path
				d="M41.9854 94.9612C41.9854 94.4948 42.3635 94.1167 42.8299 94.1167H44.3079C44.7743 94.1167 45.1524 94.4948 45.1524 94.9612V112.697H41.9854V94.9612Z"
				fill="#58707F"
			/>
			<path
				d="M48.2593 96.4391C48.2593 95.9727 48.6374 95.5946 49.1038 95.5946H50.5818C51.0483 95.5946 51.4264 95.9727 51.4264 96.4391V112.697H48.2593V96.4391Z"
				fill="#58707F"
			/>
			<path
				d="M54.5332 96.4392C54.5332 95.9728 54.9113 95.5946 55.3778 95.5946H56.8557C57.3222 95.5946 57.7003 95.9728 57.7003 96.4392V112.697H54.5332V96.4392Z"
				fill="#58707F"
			/>
			<path
				d="M60.8071 95.5946C60.8071 95.1281 61.1853 94.75 61.6517 94.75H63.1297C63.5961 94.75 63.9742 95.1281 63.9742 95.5946V112.697H60.8071V95.5946Z"
				fill="#58707F"
			/>
			<path
				opacity={ 0.5 }
				d="M49.6172 88.205C49.6172 88.2633 49.57 88.3112 49.5117 88.3112C49.4534 88.3112 49.4062 88.2633 49.4062 88.205L49.4062 87.783C49.4062 87.7247 49.4534 87.6775 49.5117 87.6775C49.57 87.6775 49.6172 87.7247 49.6172 87.783L49.6172 88.205ZM49.6172 89.6835C49.617 89.7417 49.5699 89.7891 49.5117 89.7891C49.4535 89.789 49.4063 89.7417 49.4062 89.6835L49.4062 88.8388C49.4062 88.7805 49.4534 88.7333 49.5117 88.7333C49.57 88.7333 49.6172 88.7805 49.6172 88.8388L49.6172 89.6835ZM49.6172 91.1614C49.6171 91.2196 49.5699 91.2669 49.5117 91.2669C49.4534 91.2668 49.4062 91.2196 49.4062 91.1614L49.4062 90.3166C49.4062 90.2584 49.4534 90.2111 49.5117 90.2111C49.5699 90.2111 49.6171 90.2583 49.6172 90.3166L49.6172 91.1614ZM49.6172 92.6392C49.6172 92.6975 49.57 92.7447 49.5117 92.7447C49.4534 92.7447 49.4062 92.6975 49.4062 92.6392L49.4062 91.7944C49.4063 91.7363 49.4535 91.6889 49.5117 91.6889C49.5699 91.6889 49.617 91.7362 49.6172 91.7944L49.6172 92.6392ZM49.6172 94.117C49.6172 94.1753 49.57 94.2225 49.5117 94.2225C49.4534 94.2225 49.4062 94.1753 49.4062 94.117L49.4062 93.273C49.4062 93.2147 49.4534 93.1668 49.5117 93.1667C49.57 93.1667 49.6172 93.2147 49.6172 93.273L49.6172 94.117ZM49.6172 95.5949C49.6172 95.6532 49.57 95.7011 49.5117 95.7011C49.4534 95.7011 49.4062 95.6531 49.4062 95.5949L49.4062 94.7508C49.4062 94.6925 49.4534 94.6453 49.5117 94.6453C49.57 94.6453 49.6172 94.6925 49.6172 94.7508L49.6172 95.5949ZM49.6172 97.0734L49.6092 97.1142C49.5932 97.1521 49.5555 97.1789 49.5117 97.1789C49.4679 97.1789 49.4301 97.1521 49.4142 97.1142L49.4062 97.0734L49.4062 96.2286C49.4062 96.1703 49.4534 96.1232 49.5117 96.1231C49.57 96.1231 49.6172 96.1703 49.6172 96.2286L49.6172 97.0734ZM49.6172 98.5512L49.6092 98.592C49.5932 98.63 49.5555 98.6567 49.5117 98.6567C49.4679 98.6567 49.4301 98.63 49.4142 98.592L49.4062 98.5512L49.4062 97.7065C49.4063 97.6482 49.4535 97.601 49.5117 97.6009C49.5699 97.6009 49.6171 97.6482 49.6172 97.7065L49.6172 98.5512ZM49.6172 100.029C49.6172 100.087 49.57 100.135 49.5117 100.135C49.4534 100.135 49.4062 100.087 49.4062 100.029L49.4062 99.1843C49.4063 99.1261 49.4535 99.0788 49.5117 99.0788C49.5699 99.0788 49.617 99.1261 49.6172 99.1843L49.6172 100.029ZM49.6172 101.507C49.6172 101.565 49.57 101.612 49.5117 101.612C49.4534 101.612 49.4062 101.565 49.4062 101.507L49.4062 100.663C49.4062 100.605 49.4534 100.557 49.5117 100.557C49.57 100.557 49.6172 100.605 49.6172 100.663L49.6172 101.507ZM49.6172 102.985C49.617 103.044 49.5699 103.091 49.5117 103.091C49.4535 103.091 49.4064 103.044 49.4062 102.985L49.4062 102.141C49.4062 102.082 49.4534 102.035 49.5117 102.035C49.57 102.035 49.6172 102.082 49.6172 102.141L49.6172 102.985ZM49.6172 104.463C49.6171 104.521 49.5699 104.569 49.5117 104.569C49.4535 104.569 49.4063 104.521 49.4062 104.463L49.4062 103.618C49.4062 103.56 49.4534 103.513 49.5117 103.513C49.57 103.513 49.6172 103.56 49.6172 103.618L49.6172 104.463ZM49.6172 105.941C49.6172 105.999 49.57 106.047 49.5117 106.047C49.4534 106.047 49.4062 105.999 49.4062 105.941L49.4062 105.096C49.4063 105.038 49.4535 104.991 49.5117 104.991C49.5699 104.991 49.6171 105.038 49.6172 105.096L49.6172 105.941ZM49.6172 107.419C49.6172 107.477 49.57 107.524 49.5117 107.524C49.4534 107.524 49.4062 107.477 49.4062 107.419L49.4062 106.574C49.4063 106.516 49.4535 106.469 49.5117 106.469C49.5699 106.469 49.617 106.516 49.6172 106.574L49.6172 107.419ZM49.6172 108.897C49.6172 108.955 49.57 109.002 49.5117 109.002C49.4534 109.002 49.4062 108.955 49.4062 108.897L49.4062 108.053C49.4062 107.994 49.4534 107.947 49.5117 107.947C49.57 107.947 49.6172 107.994 49.6172 108.053L49.6172 108.897ZM49.6172 110.375L49.6092 110.416C49.5932 110.454 49.5554 110.481 49.5117 110.481C49.4679 110.481 49.4302 110.454 49.4142 110.416L49.4062 110.375L49.4062 109.531C49.4062 109.472 49.4534 109.425 49.5117 109.425C49.57 109.425 49.6172 109.472 49.6172 109.531L49.6172 110.375ZM49.6172 111.853L49.6092 111.894C49.5932 111.932 49.5555 111.959 49.5117 111.959C49.4679 111.959 49.4301 111.932 49.4142 111.894L49.4062 111.853L49.4062 111.008C49.4062 110.95 49.4534 110.903 49.5117 110.903C49.57 110.903 49.6172 110.95 49.6172 111.008L49.6172 111.853ZM49.6172 113.331L49.6092 113.372C49.5932 113.41 49.5555 113.436 49.5117 113.436C49.4678 113.436 49.4301 113.41 49.4142 113.372L49.4062 113.331L49.4062 112.486C49.4063 112.428 49.4535 112.381 49.5117 112.381C49.5699 112.381 49.6171 112.428 49.6172 112.486L49.6172 113.331ZM49.6172 114.809C49.6172 114.867 49.57 114.914 49.5117 114.914C49.4534 114.914 49.4062 114.867 49.4062 114.809L49.4062 113.964C49.4064 113.906 49.4535 113.859 49.5117 113.858C49.5699 113.858 49.617 113.906 49.6172 113.964L49.6172 114.809ZM49.6172 115.865C49.6172 115.923 49.57 115.97 49.5117 115.97C49.4534 115.97 49.4062 115.923 49.4062 115.865L49.4062 115.443C49.4062 115.384 49.4534 115.337 49.5117 115.337C49.57 115.337 49.6172 115.384 49.6172 115.443L49.6172 115.865Z"
				fill="white"
			/>
			<rect
				x={ 42.2263 }
				y={ 93.7999 }
				width={ 11.8238 }
				height={ 7.38989 }
				rx={ 0.422279 }
				fill="#D6E4ED"
			/>
			<rect
				x={ 42.2263 }
				y={ 93.7999 }
				width={ 11.8238 }
				height={ 7.38989 }
				rx={ 0.422279 }
				stroke="#58707F"
				strokeWidth={ 0.422279 }
			/>
			<path
				d="M44.1265 96.2282C44.1265 95.9366 44.3628 95.7003 44.6543 95.7003H48.4548C48.7464 95.7003 48.9827 95.9366 48.9827 96.2282C48.9827 96.5197 48.7464 96.756 48.4548 96.756H44.6543C44.3628 96.756 44.1265 96.5197 44.1265 96.2282Z"
				fill="#58707F"
			/>
			<path
				d="M44.1265 98.7617C44.1265 98.4702 44.3628 98.2338 44.6543 98.2338H51.6219C51.9134 98.2338 52.1498 98.4702 52.1498 98.7617C52.1498 99.0532 51.9134 99.2895 51.6219 99.2895H44.6543C44.3628 99.2895 44.1265 99.0532 44.1265 98.7617Z"
				fill="#58707F"
			/>
			<path
				d="M66.9307 112.486V112.697H15.2017V112.486H66.9307Z"
				fill="#58707F"
			/>
			<path
				d="M18.4742 112.591V114.703H18.2632V112.591H18.4742Z"
				fill="#58707F"
			/>
			<path
				d="M15.4126 116.392C15.4126 116.1 15.6489 115.864 15.9404 115.864H20.7967C21.0882 115.864 21.3245 116.1 21.3245 116.392C21.3245 116.683 21.0882 116.92 20.7967 116.92H15.9404C15.6489 116.92 15.4126 116.683 15.4126 116.392Z"
				fill="#58707F"
			/>
			<path
				d="M31.1427 112.591V114.703H30.9316V112.591H31.1427Z"
				fill="#58707F"
			/>
			<path
				d="M28.0811 116.392C28.0811 116.1 28.3174 115.864 28.6089 115.864H33.4651C33.7566 115.864 33.993 116.1 33.993 116.392C33.993 116.683 33.7566 116.92 33.4651 116.92H28.6089C28.3174 116.92 28.0811 116.683 28.0811 116.392Z"
				fill="#58707F"
			/>
			<path
				d="M43.8106 112.591V114.703H43.5996V112.591H43.8106Z"
				fill="#58707F"
			/>
			<path
				d="M40.749 116.392C40.749 116.1 40.9853 115.864 41.2769 115.864H46.1331C46.4246 115.864 46.6609 116.1 46.6609 116.392C46.6609 116.683 46.4246 116.92 46.1331 116.92H41.2769C40.9853 116.92 40.749 116.683 40.749 116.392Z"
				fill="#58707F"
			/>
			<path
				d="M56.2681 112.591V114.703H56.0571V112.591H56.2681Z"
				fill="#58707F"
			/>
			<path
				d="M53.2065 116.392C53.2065 116.1 53.4429 115.864 53.7344 115.864H58.5906C58.8821 115.864 59.1185 116.1 59.1185 116.392C59.1185 116.683 58.8821 116.92 58.5906 116.92H53.7344C53.4429 116.92 53.2065 116.683 53.2065 116.392Z"
				fill="#58707F"
			/>
		</g>
		<rect
			x={ 8.8669 }
			y={ 87.6769 }
			width={ 58.2745 }
			height={ 31.4598 }
			rx={ 0.21114 }
			stroke="#58707F"
			strokeWidth={ 0.422279 }
		/>
		<path
			d="M8.65527 83.3999C8.65527 83.3999 8.65527 83.3999 8.65527 83.3999C8.65527 82.8169 9.12793 82.3442 9.71097 82.3442C9.71097 82.3442 9.71097 82.3442 9.71097 82.3442H27.6578C27.6578 82.3442 27.6578 82.3442 27.6578 82.3442C28.2409 82.3442 28.7135 82.8169 28.7135 83.3999C28.7135 83.3999 28.7135 83.3999 28.7135 83.3999C28.7135 83.3999 28.7135 83.3999 28.7135 83.3999C28.7135 83.983 28.2409 84.4556 27.6578 84.4556H9.71097C9.71097 84.4556 9.71097 84.4556 9.71097 84.4556C9.12793 84.4556 8.65527 83.983 8.65527 83.3999C8.65527 83.3999 8.65527 83.3999 8.65527 83.3999Z"
			fill="#58707F"
		/>
		<path
			d="M59.3291 83.3999C59.3291 83.3999 59.3291 83.3999 59.3291 83.3999C59.3291 82.8169 59.8018 82.3442 60.3848 82.3442C60.3848 82.3442 60.3848 82.3442 60.3848 82.3442H66.2967C66.2967 82.3442 66.2967 82.3442 66.2967 82.3442C66.8798 82.3442 67.3524 82.8169 67.3524 83.3999C67.3524 83.3999 67.3524 83.3999 67.3524 83.3999C67.3524 83.3999 67.3524 83.3999 67.3524 83.3999C67.3524 83.983 66.8798 84.4556 66.2967 84.4556H66.2967H60.3848C60.3848 84.4556 60.3848 84.4556 60.3848 84.4556C59.8018 84.4556 59.3291 83.983 59.3291 83.3999C59.3291 83.3999 59.3291 83.3999 59.3291 83.3999Z"
			fill="#58707F"
		/>
		<path
			d="M49.6162 83.3999C49.6162 83.3999 49.6162 83.3999 49.6162 83.3999C49.6162 82.8169 50.0889 82.3442 50.6719 82.3442C50.6719 82.3442 50.6719 82.3442 50.6719 82.3442H56.5838C56.5838 82.3442 56.5838 82.3442 56.5838 82.3442C57.1669 82.3442 57.6395 82.8169 57.6395 83.3999C57.6395 83.3999 57.6395 83.3999 57.6395 83.3999C57.6395 83.3999 57.6395 83.3999 57.6395 83.3999C57.6395 83.983 57.1669 84.4556 56.5838 84.4556H56.5838H50.6719C50.6719 84.4556 50.6719 84.4556 50.6719 84.4556C50.0889 84.4556 49.6162 83.983 49.6162 83.3999C49.6162 83.3999 49.6162 83.3999 49.6162 83.3999Z"
			fill="#58707F"
		/>
		<defs>
			<clipPath
				id="bgblur_0_20430_28758_clip_path"
				transform="translate(-53.5339 -23.3308)"
			>
				<rect
					x={ 54.9061 }
					y={ 24.7032 }
					width={ 12.5526 }
					height={ 4.64507 }
					rx={ 0.738989 }
				/>
			</clipPath>
			<clipPath id="clip1_20430_28758">
				<rect
					x={ 8.65576 }
					y={ 87.4658 }
					width={ 58.6968 }
					height={ 31.8821 }
					rx={ 0.422279 }
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip2_20430_28758">
				<rect
					width={ 4.22279 }
					height={ 27.8704 }
					fill="white"
					transform="translate(10.7671 87.3602)"
				/>
			</clipPath>
		</defs>
	</svg>
);
